(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-announcement-bar]').forEach(function (bar) {
      var slides = bar.querySelectorAll('[data-announcement-slide]');
      if (slides.length < 2) return;
      var prevBtn = bar.querySelector('[data-announcement-prev]');
      var nextBtn = bar.querySelector('[data-announcement-next]');
      var pauseBtn = bar.querySelector('[data-announcement-pause]');
      var userPaused = false;
      var interval = parseInt(bar.dataset.announcementInterval, 10) * 1000;
      var fadeDuration = parseInt(bar.dataset.fadeDuration, 10) || 300;
      var reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      var current = 0;
      var timer = null;

      function showSlide(index) {
        var prev = slides[current];
        current = (index + slides.length) % slides.length;
        var next = slides[current];
        prev.classList.add('opacity-0', 'pointer-events-none');
        prev.classList.remove('opacity-100');
        setTimeout(function () {
          prev.classList.add('absolute', 'inset-0');
          prev.classList.remove('relative');
          next.classList.remove('absolute', 'inset-0', 'opacity-0', 'pointer-events-none');
          next.classList.add('opacity-100', 'relative');
        }, fadeDuration);
      }

      function nextSlide() { showSlide(current + 1); }

      function startTimer() {
        stopTimer();
        if (reduceMotionQuery.matches) return;
        if (userPaused) return;
        if (window.pigment && window.pigment.isHidden && window.pigment.isHidden()) return;
        timer = setInterval(nextSlide, interval);
      }
      function stopTimer() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { showSlide(current - 1); startTimer(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { showSlide(current + 1); startTimer(); });
      if (pauseBtn) pauseBtn.addEventListener('click', function () {
        userPaused = !userPaused;
        pauseBtn.setAttribute('aria-pressed', String(userPaused));
        pauseBtn.setAttribute('aria-label', userPaused ? 'Resume announcements' : 'Pause announcements');
        if (userPaused) stopTimer(); else startTimer();
      });

      bar.addEventListener('mouseenter', stopTimer);
      bar.addEventListener('mouseleave', startTimer);
      bar.addEventListener('focusin', stopTimer);
      bar.addEventListener('focusout', function (e) {
        if (!bar.contains(e.relatedTarget)) startTimer();
      });

      reduceMotionQuery.addEventListener('change', function (e) {
        if (e.matches) stopTimer(); else startTimer();
      });

      if (window.pigment && window.pigment.onVisibility) {
        window.pigment.onVisibility(function (hidden) {
          if (hidden) stopTimer(); else startTimer();
        });
      }

      startTimer();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["automated-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-product-recommendations]').forEach(function (container) {
      var PRODUCTS_TO_SHOW = parseInt(container.dataset.productsToShow, 10) || 6;
      var STAGGER_MS = 75;

      function initCarousel(section) {
        if (!section) return;
        var scrollContainer = section.querySelector('[data-scroll-container]');
        var leftBtn = section.querySelector('[data-scroll-left]');
        var rightBtn = section.querySelector('[data-scroll-right]');
        if (!scrollContainer || !leftBtn || !rightBtn) return;

        function getScrollAmount() {
          var firstCard = scrollContainer.querySelector(':scope > div');
          if (!firstCard) return 300;
          var cs = getComputedStyle(scrollContainer);
          var gap = parseFloat(cs.columnGap || cs.gap) || 0;
          return firstCard.offsetWidth + gap;
        }
        function updateButtonStates() {
          var scrollLeft = scrollContainer.scrollLeft;
          var maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;
          leftBtn.disabled = scrollLeft <= 0;
          rightBtn.disabled = scrollLeft >= maxScroll - 1;
        }
        leftBtn.addEventListener('click', function () {
          scrollContainer.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        });
        rightBtn.addEventListener('click', function () {
          scrollContainer.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        });
        scrollContainer.addEventListener('scroll', updateButtonStates, { passive: true });
        window.addEventListener('resize', updateButtonStates, { passive: true });
        updateButtonStates();
      }

      function getBrandProductIds() {
        var ids = new Set();
        var brandSection = document.querySelector('[data-brand-products]');
        if (!brandSection) return ids;
        var brandContainer = brandSection.querySelector('[data-scroll-container]');
        if (!brandContainer) return ids;
        brandContainer.querySelectorAll(':scope > [data-product-id]').forEach(function (card) {
          ids.add(card.getAttribute('data-product-id'));
        });
        return ids;
      }

      // Initialise the carousel if recommendations were server-rendered.
      var existing = container.querySelector('[data-automated-recommendations]');
      if (existing) initCarousel(existing);

      var url = container.dataset.url;
      if (!url) return;

      function doFetch() {
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var html = document.createElement('div');
          html.innerHTML = text;
          var recommendations = html.querySelector('[data-product-recommendations]');
          if (!recommendations || !recommendations.innerHTML.trim().length) {
            container.style.display = 'none';
            return;
          }

          // Drop products that already appear in the brand-products carousel.
          var excludeIds = getBrandProductIds();
          if (excludeIds.size > 0) {
            var recsScroll = recommendations.querySelector('[data-scroll-container]');
            if (recsScroll) {
              recsScroll.querySelectorAll(':scope > [data-product-id]').forEach(function (card) {
                if (excludeIds.has(card.getAttribute('data-product-id'))) card.remove();
              });
            }
          }

          // Trim to target display count after dedup.
          var parsedSection = recommendations.querySelector('[data-automated-recommendations]');
          var parsedScroll = parsedSection ? parsedSection.querySelector('[data-scroll-container]') : null;
          if (parsedScroll) {
            var excess = parsedScroll.querySelectorAll(':scope > [data-product-id]');
            for (var i = PRODUCTS_TO_SHOW; i < excess.length; i++) excess[i].remove();
          }

          var remaining = parsedScroll ? parsedScroll.querySelectorAll(':scope > [data-product-id]') : [];
          if (remaining.length > 0) {
            container.innerHTML = recommendations.innerHTML;
            var section = container.querySelector('[data-automated-recommendations]');
            if (section) {
              initCarousel(section);
              section.querySelectorAll('[data-scroll-container] > [data-product-id]').forEach(function (card, i) {
                // Replace per-element inline animation with the shared
                // .stagger-fade-in helper + a single --stagger-i variable.
                card.classList.add('stagger-fade-in');
                card.style.setProperty('--stagger-i', i);
                card.style.setProperty('--stagger-step', STAGGER_MS + 'ms');
              });
            }
          } else {
            container.style.display = 'none';
          }
        })
        .catch(function () { container.style.display = 'none'; });
      }

      /* Defer the recommendations fetch until the placeholder enters the
         viewport. The product page above-the-fold cost was paying for a
         /recommendations request on every render even though the carousel
         lives below product info, gallery, and the form — pushing it to
         intersect frees up the network for the LCP image. */
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              io.disconnect();
              doFetch();
            }
          });
        }, { rootMargin: '2000px 0px' });
        io.observe(container);
      } else {
        doFetch();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bind(wrapper) {
      if (wrapper.dataset.contactFormBound === '1') return;
      wrapper.dataset.contactFormBound = '1';

      var formId = wrapper.dataset.formId;
      var form = formId ? document.getElementById(formId) : wrapper.querySelector('form');
      if (!form) return;

      var loadingLabel = wrapper.dataset.loadingLabel || 'Sending…';
      var successLabel = wrapper.dataset.successLabel || 'Sent';
      var errorLabel = wrapper.dataset.errorLabel || 'Could not send. Try again.';
      var honeypot = form.querySelector('[data-honeypot]');

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        // Honeypot tripped — silently drop and pretend it succeeded.
        if (honeypot && honeypot.value) {
          form.reset();
          window.showToast && window.showToast('contact-form-toast', {
            message: successLabel, icon: 'check', duration: 3000
          });
          return;
        }

        var submitBtn = form.querySelector('button[type="submit"]');
        var originalLabel = submitBtn ? submitBtn.textContent : '';

        form.setAttribute('aria-busy', 'true');
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = loadingLabel;
        }

        var formData = new FormData(form);
        fetch(form.action, { method: 'POST', body: formData, headers: { 'Accept': 'text/html' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var responseForm = formId ? doc.getElementById(formId) : null;
            var successEl = responseForm && responseForm.querySelector('[data-form-success]');
            var errorsEl = responseForm && responseForm.querySelector('[data-form-errors]');

            if (successEl) {
              form.reset();
              window.showToast && window.showToast('contact-form-toast', {
                message: successLabel, icon: 'check', duration: 3000
              });
              var existingErrors = form.querySelector('[data-form-errors]');
              if (existingErrors) existingErrors.remove();
              return;
            }

            if (errorsEl) {
              var existingErrors = form.querySelector('[data-form-errors]');
              if (existingErrors) {
                existingErrors.replaceWith(errorsEl);
              } else {
                form.appendChild(errorsEl);
              }
              window.showToast && window.showToast('contact-form-toast', {
                message: errorsEl.textContent.trim() || errorLabel,
                icon: 'x', duration: 4000
              });
            } else {
              window.showToast && window.showToast('contact-form-toast', {
                message: errorLabel, icon: 'x', duration: 4000
              });
            }
          })
          .catch(function () {
            window.showToast && window.showToast('contact-form-toast', {
              message: errorLabel, icon: 'x', duration: 4000
            });
          })
          .then(function () {
            form.setAttribute('aria-busy', 'false');
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = originalLabel;
            }
          });
      });
    }

    document.querySelectorAll('[data-contact-form]').forEach(bind);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-store-reviews"] && !Shopify.designMode) return;
  try {
    
    (function () {
      function init(section) {
        var container = section.querySelector('[data-scroll-container]');
        var leftBtn = section.querySelector('[data-scroll-left]');
        var rightBtn = section.querySelector('[data-scroll-right]');
        if (!container || !leftBtn || !rightBtn) return;

        function getScrollAmount() {
          var firstCard = container.querySelector(':scope > div');
          if (!firstCard) return 300;
          return firstCard.offsetWidth + 12;
        }

        function updateButtonStates() {
          var scrollLeft = container.scrollLeft;
          var maxScroll = container.scrollWidth - container.clientWidth;
          leftBtn.disabled = scrollLeft <= 0;
          rightBtn.disabled = scrollLeft >= maxScroll - 1;
        }

        leftBtn.addEventListener('click', function () {
          container.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        });

        rightBtn.addEventListener('click', function () {
          container.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        });

        container.addEventListener('scroll', updateButtonStates, { passive: true });
        window.addEventListener('resize', updateButtonStates, { passive: true });
        updateButtonStates();
      }

      document.querySelectorAll('[data-custom-store-reviews]').forEach(init);
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-featured-collection]').forEach(function (section) {
      if (section.dataset.featuredCollectionInit === '1') return;
      section.dataset.featuredCollectionInit = '1';

      var container = section.querySelector('[data-scroll-container]');
      var leftBtn = section.querySelector('[data-scroll-left]');
      var rightBtn = section.querySelector('[data-scroll-right]');
      if (!container || !leftBtn || !rightBtn) return;

      function getScrollAmount() {
        var firstCard = container.querySelector(':scope > div');
        if (!firstCard) return 300;
        var cs = getComputedStyle(container);
        var gap = parseFloat(cs.columnGap || cs.gap) || 0;
        return firstCard.offsetWidth + gap;
      }
      function updateButtonStates() {
        var scrollLeft = container.scrollLeft;
        var maxScroll = container.scrollWidth - container.clientWidth;
        leftBtn.disabled = scrollLeft <= 0;
        rightBtn.disabled = scrollLeft >= maxScroll - 1;
      }
      leftBtn.addEventListener('click', function () {
        container.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
      rightBtn.addEventListener('click', function () {
        container.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
      container.addEventListener('scroll', updateButtonStates, { passive: true });
      window.addEventListener('resize', updateButtonStates, { passive: true });
      updateButtonStates();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-footer-section]').forEach(function (footer) {
      footer.addEventListener('change', function (e) {
        var t = e.target;
        if (t && t.matches && t.matches('[data-localization-auto-submit]') && t.form) {
          t.form.submit();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    if (header.dataset.headerBound === '1') return;
    header.dataset.headerBound = '1';

    // Mobile Menu - uses drawer component (opens/closes via window.drawer_mobile_menu)
    const mobileMenuToggle = header.querySelector('[data-mobile-menu-toggle]');

    // Mega Menu (Desktop) - Full Width Dropdowns
    const nav = header.querySelector('nav');
    const megaMenuTriggers = header.querySelectorAll('[data-mega-menu-trigger]');
    const megaMenuBackdrop = document.querySelector('[data-mega-menu-backdrop]');
    // Move backdrop to body so it's in the root stacking context.
    // Inside the header group (z-100), it would sit above the announcement bar (z-60).
    // In the root context at z-50, it renders below the announcement bar (z-60).
    if (megaMenuBackdrop) document.body.appendChild(megaMenuBackdrop);
    let activeMenu = null;
    let menuTimeout = null;

    function showBackdrop() {
      megaMenuBackdrop?.setAttribute('data-open', '');
      megaMenuBackdrop?.setAttribute('aria-hidden', 'false');
    }

    function hideBackdrop() {
      megaMenuBackdrop?.removeAttribute('data-open');
      megaMenuBackdrop?.setAttribute('aria-hidden', 'true');
    }

    function closeAllMenus() {
      header.querySelectorAll('[data-mega-menu-content]').forEach(content => {
        content.removeAttribute('data-open');
        content.setAttribute('aria-hidden', 'true');
      });
      megaMenuTriggers.forEach(trigger => {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.querySelector('svg')?.classList.remove('rotate-180');
      });
      hideBackdrop();
      activeMenu = null;
    }

    function openMenu(index) {
      clearTimeout(menuTimeout);
      closeAllMenus();

      const trigger = header.querySelector(`[data-mega-menu-trigger="${index}"]`);
      const content = header.querySelector(`[data-mega-menu-content="${index}"]`);

      if (trigger && content) {
        content.setAttribute('data-open', '');
        content.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');
        trigger.querySelector('svg')?.classList.add('rotate-180');
        showBackdrop();
        activeMenu = index;
      }
    }

    function scheduleClose() {
      menuTimeout = setTimeout(() => {
        closeAllMenus();
      }, 150);
    }

    function cancelClose() {
      clearTimeout(menuTimeout);
    }

    megaMenuTriggers.forEach(trigger => {
      const index = trigger.getAttribute('data-mega-menu-trigger');

      trigger.addEventListener('mouseenter', () => openMenu(index));
      trigger.addEventListener('mouseleave', scheduleClose);
      trigger.addEventListener('focus', () => openMenu(index));
    });

    header.querySelectorAll('[data-mega-menu-content]').forEach(content => {
      content.addEventListener('mouseenter', cancelClose);
      content.addEventListener('mouseleave', scheduleClose);
      content.addEventListener('focusin', cancelClose);
      content.addEventListener('focusout', (e) => {
        if (!content.contains(e.relatedTarget)) scheduleClose();
      });
    });

    // Close mega menu when clicking backdrop
    megaMenuBackdrop?.addEventListener('click', closeAllMenus);

    // Close mega menu when mouse leaves nav area entirely
    nav?.addEventListener('mouseleave', scheduleClose);

    // Search Overlay - elements are outside header to avoid stacking context issues
    const searchModal = document.querySelector('[data-search-modal]');
    const searchToggle = header.querySelector('[data-search-toggle]');
    const searchBackdrop = document.querySelector('[data-search-backdrop]');
    // Move search elements to body so they escape the header group stacking context
    if (searchBackdrop) document.body.appendChild(searchBackdrop);
    if (searchModal) document.body.appendChild(searchModal);
    const searchClose = searchModal?.querySelector('[data-search-close]');
    const searchInput = searchModal?.querySelector('[data-search-input]');
    const searchResults = searchModal?.querySelector('[data-search-results]');
    let searchIsOpen = false;

    function openSearch() {
      searchBackdrop?.setAttribute('data-open', '');
      searchBackdrop?.setAttribute('aria-hidden', 'false');
      searchModal?.setAttribute('data-open', '');
      searchModal?.removeAttribute('inert');
      document.body.style.overflow = 'hidden';
      searchIsOpen = true;
      setTimeout(() => searchInput?.focus(), 100);
    }

    function closeSearch() {
      searchBackdrop?.removeAttribute('data-open');
      searchBackdrop?.setAttribute('aria-hidden', 'true');
      searchModal?.removeAttribute('data-open');
      searchModal?.setAttribute('inert', '');
      document.body.style.overflow = '';
      searchIsOpen = false;
      if (searchInput) searchInput.value = '';
      searchResults?.classList.add('hidden');
      searchToggle?.focus();
    }

    searchToggle?.addEventListener('click', openSearch);
    searchClose?.addEventListener('click', closeSearch);
    searchBackdrop?.addEventListener('click', closeSearch);

    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        if (searchIsOpen) closeSearch();
        if (activeMenu) closeAllMenus();
      }
    });

    // Predictive Search
    var searchUrl = header.dataset.searchUrl || '/search';
    var searchNoProductsLabel = header.dataset.searchNoProductsLabel || 'No products found.';
    var searchViewAllLabel = header.dataset.searchViewAllLabel || 'View all results';
    /* Hidden-product handles for the predictive-search filter.
       Shopify's /search/suggest.json doesn't expose metafields, so we
       collect handles where custom.hide_product == true server-side and
       filter results client-side before they're shown.

       Source: <section id="hidden-products-feed"> rendered from
       layout/theme.liquid. It paginates collections.all.products by 250
       (Liquid's hard cap) and writes the page's handles into a hidden
       <div data-hidden-products-feed>. Page 1 is inline; pages 2..N are
       walked via the Section Rendering API on first search-input focus.

       Cached in sessionStorage for the tab session so we only walk once. */
    var hiddenProductHandles = new Set();
    var hiddenHandlesPromise = null;
    var HIDDEN_HANDLES_CACHE_KEY = 'hiddenProductHandles:v1';

    function readFeedFromDoc(doc) {
      var el = doc.querySelector('[data-hidden-products-feed]');
      if (!el) return null;
      var handles = (el.getAttribute('data-handles') || '')
        .split(',').filter(Boolean);
      var hasNext = el.getAttribute('data-has-next') === 'true';
      return { handles: handles, hasNext: hasNext };
    }

    function loadHiddenProductHandles() {
      if (hiddenHandlesPromise) return hiddenHandlesPromise;

      // Session cache hit: skip the network walk entirely.
      try {
        var cached = sessionStorage.getItem(HIDDEN_HANDLES_CACHE_KEY);
        if (cached) {
          var parsed = JSON.parse(cached);
          if (Array.isArray(parsed)) {
            hiddenProductHandles = new Set(parsed);
            hiddenHandlesPromise = Promise.resolve(hiddenProductHandles);
            return hiddenHandlesPromise;
          }
        }
      } catch (e) { /* sessionStorage may be unavailable */ }

      // Read page 1 from the inline feed already in this document.
      var inline = readFeedFromDoc(document);
      var collected = new Set(inline ? inline.handles : []);
      var hasNext = !!(inline && inline.hasNext);

      hiddenHandlesPromise = (async function () {
        var page = 2;
        var SAFETY_CAP = 40; // 40 * 250 = 10,000 products
        while (hasNext && page <= SAFETY_CAP + 1) {
          try {
            var url = window.Shopify.routes.root +
              '?section_id=hidden-products-feed&page=' + page;
            var r = await fetch(url);
            if (!r.ok) break;
            var text = await r.text();
            var tmp = document.createElement('div');
            tmp.innerHTML = text;
            var pageData = readFeedFromDoc(tmp);
            if (!pageData) break;
            for (var i = 0; i < pageData.handles.length; i++) {
              collected.add(pageData.handles[i]);
            }
            hasNext = pageData.hasNext;
            page += 1;
          } catch (e) {
            break;
          }
        }
        try {
          sessionStorage.setItem(
            HIDDEN_HANDLES_CACHE_KEY,
            JSON.stringify(Array.from(collected))
          );
        } catch (e) { /* sessionStorage may be unavailable */ }
        hiddenProductHandles = collected;
        return hiddenProductHandles;
      })();

      return hiddenHandlesPromise;
    }
    function formatMoney(price) {
      // Use the shared Intl-based formatter so non-GBP shops render
      // their own currency symbol instead of a hard-coded '£'.
      var ns = window.pigment;
      if (ns && ns.formatMoney) {
        // Shopify's predictive-search API returns price as a major-unit
        // string (e.g. "12.50"), not minor units. Multiply to cents.
        return ns.formatMoney(Math.round(parseFloat(price) * 100));
      }
      return parseFloat(price).toFixed(2);
    }
    /* Build a properly-sized Shopify CDN image URL from a raw image URL.
       Handles both URLs that already have a query string and ones that don't,
       and serves an appropriately-sized image at retina density. */
    function buildCdnImageUrl(rawUrl, width) {
      if (!rawUrl) return '';
      var url;
      try {
        url = new URL(rawUrl, window.location.origin);
      } catch (e) {
        return rawUrl;
      }
      url.searchParams.set('width', String(width));
      return url.toString();
    }
    // Predictive search: load-on-interaction. The input listener (and the
    // first fetch) only attach after the user actually focuses the search
    // box, so the keystroke-handling code never runs on pages where the
    // overlay is never opened.
    var searchTimeout;
    var resultsCache = new Map(); // query → cached enriched products

    /* suggest.json's featured_image can be a variant-attached image
       when the matching variant has its own image. The PDP gallery
       filters those out (`product.images | where: 'attached_to_variant?', false`),
       so search results must do the same to stay consistent.
       Fetch /products/{handle}.js, compute the first non-variant image,
       and cache per handle for the session. */
    var productImageCache = new Map(); // handle → Promise<imageUrl|null>

    function stripQuery(url) {
      if (!url) return '';
      var i = url.indexOf('?');
      return i === -1 ? url : url.substring(0, i);
    }

    function resolveProductImage(handle) {
      if (!handle) return Promise.resolve(null);
      if (productImageCache.has(handle)) return productImageCache.get(handle);
      var promise = fetch(window.Shopify.routes.root + 'products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (product) {
          if (!product) return null;
          var variantSrcs = new Set();
          (product.variants || []).forEach(function (v) {
            if (v && v.featured_image && v.featured_image.src) {
              variantSrcs.add(stripQuery(v.featured_image.src));
            }
          });
          var images = product.images || [];
          for (var i = 0; i < images.length; i++) {
            if (!variantSrcs.has(stripQuery(images[i]))) return images[i];
          }
          return product.featured_image || null;
        })
        .catch(function () { return null; });
      productImageCache.set(handle, promise);
      return promise;
    }

    function escapeAttr(s) {
      return (s || '').replace(/"/g, '&quot;');
    }

    function renderSearchResults(query, products) {
      var inner = searchResults.querySelector('[data-search-results-inner]');
      if (!products || products.length === 0) {
        inner.innerHTML = '<p class="mt-4 pl-2 text-base font-semibold text-foreground">' + searchNoProductsLabel + '</p>';
        return;
      }
      var html = '<div class="flex flex-col gap-1">';
      for (var i = 0; i < products.length; i++) {
        var p = products[i];
        var imgUrl = p.product_image_url;
        var img = imgUrl
          ? '<img src="' + buildCdnImageUrl(imgUrl, 128) + '" srcset="' +
              buildCdnImageUrl(imgUrl, 64) + ' 1x, ' +
              buildCdnImageUrl(imgUrl, 128) + ' 2x" alt="' +
              escapeAttr(p.title) + '" class="h-16 w-16 object-cover border border-transparent group-hover:border-border transition-colors" width="64" height="64" loading="lazy" decoding="async">'
          : '<div class="h-16 w-16 bg-muted border border-transparent group-hover:border-border transition-colors"></div>';
        html += '<a href="' + p.url + '" class="stagger-fade-in group flex items-center gap-4 p-2 transition-colors hover:bg-secondary" style="--stagger-i: ' + i + ';">' +
          img +
          '<div class="flex-1 min-w-0">' +
          '<p class="text-base font-semibold text-foreground truncate">' + p.title + '</p>' +
          '<p class="mt-1 text-sm font-medium text-muted-foreground">' + formatMoney(p.price) + '</p>' +
          '</div></a>';
      }
      html += '</div>' +
        '<a href="' + searchUrl + '?q=' + encodeURIComponent(query) + '" class="stagger-fade-in text-cta mt-2 ml-2 text-foreground" style="--stagger-i: ' + products.length + ';">' +
        searchViewAllLabel +
        '<svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8.25 4.5l7.5 7.5-7.5 7.5" /></svg>' +
        '</a>';
      inner.innerHTML = html;
    }

    function handleSearchInput(e) {
      clearTimeout(searchTimeout);
      var query = e.target.value.trim();
      if (query.length < 2) {
        searchResults.classList.add('hidden');
        return;
      }
      // Cache hit: render immediately, no fetch.
      if (resultsCache.has(query)) {
        renderSearchResults(query, resultsCache.get(query));
        searchResults.classList.remove('hidden');
        return;
      }
      searchTimeout = setTimeout(function () {
        // Race the over-fetched suggest.json against the hidden-handles
        // walk. Once both resolve, filter, slice to 4, render. Suggest is
        // limited to 10 (the API max) so we still reach 4 visible after
        // dropping a few hidden ones.
        var suggestPromise = fetch(window.Shopify.routes.root + 'search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=10')
          .then(function (r) { return r.json(); });
        Promise.all([suggestPromise, loadHiddenProductHandles()])
          .then(function (results) {
            var data = results[0];
            var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            if (hiddenProductHandles.size > 0) {
              products = products.filter(function (p) {
                // suggest.json should return `handle`; if not, parse it
                // from the product URL as a fallback (e.g. /products/foo).
                var h = p.handle;
                if (!h && p.url) {
                  var m = p.url.match(/\/products\/([^?#\/]+)/);
                  h = m ? m[1] : '';
                }
                return !hiddenProductHandles.has(h);
              });
            }
            products = products.slice(0, 4);
            // Resolve each product's first non-variant image to match the
            // PDP gallery (which excludes variant-attached images).
            // Also strip ?variant=… from the URL so the search link opens
            // the product, not a specific variant view.
            Promise.all(products.map(function (p) {
              var h = p.handle;
              if (!h && p.url) {
                var m = p.url.match(/\/products\/([^?#\/]+)/);
                h = m ? m[1] : '';
              }
              return resolveProductImage(h).then(function (imageUrl) {
                p.product_image_url = imageUrl ||
                  (p.featured_image && p.featured_image.url) || null;
                if (p.url) p.url = p.url.split('?')[0];
                return p;
              });
            })).then(function (enriched) {
              resultsCache.set(query, enriched);
              renderSearchResults(query, enriched);
              searchResults.classList.remove('hidden');
            });
          })
          .catch(function () { /* swallow */ });
      }, 300);
    }

    var searchInputBound = false;
    function bindSearchInput() {
      if (searchInputBound || !searchInput) return;
      searchInputBound = true;
      searchInput.addEventListener('input', handleSearchInput);
      // Kick off the hidden-handles walk in the background so it's
      // (usually) ready by the time the user finishes typing.
      loadHiddenProductHandles();
    }
    // Defer wiring until the user actually engages with the search box.
    if (searchInput) {
      searchInput.addEventListener('focus', bindSearchInput, { once: true });
    }

    // Hide header when any non-mobile-menu drawer is open. Previously this
    // installed a separate MutationObserver per drawer; consolidate to one
    // shared observer driven only by the `class` attribute.
    var sharedDrawerObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type !== 'attributes' || m.attributeName !== 'class') continue;
        var drawer = m.target;
        if (drawer.id === 'mobile-menu') continue;
        if (drawer.classList.contains('drawer-visible')) {
          header.classList.add('-translate-y-full');
        } else {
          header.classList.remove('-translate-y-full');
        }
      }
    });
    document.querySelectorAll('[data-drawer]').forEach(function (drawer) {
      if (drawer.id === 'mobile-menu') return;
      sharedDrawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    });

    // Desktop vs mobile nav is decided by the `xl:` Tailwind breakpoint in
    // markup (no JS measurement) — this keeps the initial paint identical
    // to the final layout and eliminates the logo-jump flash that used to
    // occur while `checkNavFit` reran on every page load.

    // Track header height for sticky elements below header
    // Sets --header-height CSS variable on :root for use by sticky-below-header elements
    function updateHeaderHeight() {
      const headerGroup = document.querySelector('.shopify-section-group-header-group');
      if (headerGroup) {
        const height = headerGroup.offsetHeight;
        document.documentElement.style.setProperty('--header-height', `${height}px`);
      }
    }

    updateHeaderHeight();

    // Re-measure when header container resizes (breakpoint crossings, drawer
    // open/close, announcement bar changes).
    const navContainer = header.querySelector('[data-desktop-nav]')?.closest('.container');
    if (navContainer) {
      new ResizeObserver(updateHeaderHeight).observe(navContainer);
    }

    // Fonts loading can change header height slightly.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(updateHeaderHeight);
    }

    // Expose function globally for other scripts if needed
    window.updateHeaderHeight = updateHeaderHeight;
  })();

  /* ──────────────────────────────────────────────────────────────────
     Mobile nav slide module (formerly inlined inside the drawer capture).
     Lives in the same bundle file as the rest of the header JS and
     binds when [data-mobile-nav] appears in the DOM.
     ────────────────────────────────────────────────────────────────── */
  (function () {
    var nav = document.querySelector('[data-mobile-nav]');
    if (!nav) return;

    var main = nav.querySelector('[data-mobile-nav-main]');
    var drawerContent = nav.closest('[data-drawer-content]');
    var drawer = document.getElementById('mobile-menu');
    var drawerHeader = drawer ? drawer.querySelector('[data-drawer-header]') : null;
    var activeSub = null;
    var backBtn = null;
    var isAnimating = false;

    var DURATION = 300;
    var EASING = 'cubic-bezier(0.33, 1, 0.68, 1)';

    function showBackButton() {
      if (!drawerHeader) return;
      backBtn = document.createElement('button');
      backBtn.type = 'button';
      backBtn.className = 'flex items-center gap-2 text-foreground hover:text-muted-foreground transition-colors';
      backBtn.setAttribute('aria-label', 'Back');
      backBtn.innerHTML = '<svg class="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>';
      backBtn.addEventListener('click', goBack);
      drawerHeader.classList.remove('justify-end');
      drawerHeader.classList.add('justify-between');
      drawerHeader.insertBefore(backBtn, drawerHeader.firstChild);
    }

    function hideBackButton() {
      if (backBtn && drawerHeader) {
        backBtn.remove();
        backBtn = null;
        drawerHeader.classList.remove('justify-between');
        drawerHeader.classList.add('justify-end');
      }
    }

    function cancelAnimations(el) {
      el.getAnimations().forEach(function (a) { a.cancel(); });
    }

    nav.querySelectorAll('[data-mobile-nav-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (isAnimating) return;
        var index = btn.dataset.mobileNavOpen;
        var sub = nav.querySelector('[data-mobile-nav-sub="' + index + '"]');
        if (!sub) return;
        isAnimating = true;
        activeSub = sub;
        if (drawerContent) drawerContent.scrollTop = 0;
        main.style.position = 'absolute';
        main.style.inset = '0';
        sub.classList.remove('hidden');
        showBackButton();
        main.animate(
          [{ transform: 'translateX(0)' }, { transform: 'translateX(-100%)' }],
          { duration: DURATION, easing: EASING }
        );
        sub.animate(
          [{ transform: 'translateX(100%)' }, { transform: 'translateX(0)' }],
          { duration: DURATION, easing: EASING }
        ).finished.then(function () {
          main.classList.add('hidden');
          main.style.position = '';
          main.style.inset = '';
          isAnimating = false;
        });
      });
    });

    function goBack() {
      if (!activeSub || isAnimating) return;
      isAnimating = true;
      if (drawerContent) drawerContent.scrollTop = 0;
      activeSub.style.position = 'absolute';
      activeSub.style.inset = '0';
      main.classList.remove('hidden');
      main.animate(
        [{ transform: 'translateX(-100%)' }, { transform: 'translateX(0)' }],
        { duration: DURATION, easing: EASING }
      );
      var sub = activeSub;
      activeSub = null;
      sub.animate(
        [{ transform: 'translateX(0)' }, { transform: 'translateX(100%)' }],
        { duration: DURATION, easing: EASING }
      ).finished.then(function () {
        sub.classList.add('hidden');
        sub.style.position = '';
        sub.style.inset = '';
        hideBackButton();
        isAnimating = false;
      });
    }

    if (drawer) {
      var observer = new MutationObserver(function () {
        if (drawer.getAttribute('aria-hidden') === 'true' && activeSub) {
          cancelAnimations(main);
          cancelAnimations(activeSub);
          main.classList.remove('hidden');
          main.style.position = '';
          main.style.inset = '';
          activeSub.classList.add('hidden');
          activeSub.style.position = '';
          activeSub.style.inset = '';
          activeSub = null;
          isAnimating = false;
          hideBackButton();
        }
      });
      observer.observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-image-with-collection]').forEach(function (section) {
      var container = section.querySelector('[data-scroll-container]');
      var leftBtn = section.querySelector('[data-scroll-left]');
      var rightBtn = section.querySelector('[data-scroll-right]');
      if (!container || !leftBtn || !rightBtn) return;

      function getScrollAmount() {
        var firstCard = container.querySelector(':scope > div');
        if (!firstCard) return 300;
        return firstCard.offsetWidth + 16;
      }
      function updateButtonStates() {
        var scrollLeft = container.scrollLeft;
        var maxScroll = container.scrollWidth - container.clientWidth;
        leftBtn.disabled = scrollLeft <= 0;
        rightBtn.disabled = scrollLeft >= maxScroll - 1;
      }
      leftBtn.addEventListener('click', function () {
        container.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
      rightBtn.addEventListener('click', function () {
        container.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
      container.addEventListener('scroll', updateButtonStates, { passive: true });
      window.addEventListener('resize', updateButtonStates, { passive: true });
      updateButtonStates();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  // Shared helpers used by every IIFE in this bundle.
  var sharedRootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function cartGetCart(force) {
    var ns = window.pigment;
    if (ns && ns.cart) return ns.cart.get(!!force);
    return fetch(sharedRootUrl + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function cartGetProduct(handle) {
    // Returns {product: ...} (matches /products/{handle}.json shape) but is
    // backed by the shared per-page product cache so duplicate handles only
    // hit the network once across the cart page lifecycle.
    var ns = window.pigment;
    if (ns && ns.getProduct) {
      return ns.getProduct(handle).then(function (p) { return { product: p }; });
    }
    return fetch(sharedRootUrl + 'products/' + handle + '.json').then(function (r) { return r.json(); });
  }

  // Initialise window.giftVariantIds from the data island left by the
  // non-gift-count branch above. Done before any other IIFE so the header
  // badge subtraction is correct on first paint.
  (function () {
    var init = document.querySelector('[data-cart-non-gift-init]');
    if (!init) return;
    try {
      var ids = init.dataset.giftVariantIds || '';
      window.giftVariantIds = ids
        .split(',')
        .map(function (s) { return parseInt(s.trim(), 10); })
        .filter(function (n) { return !isNaN(n); });
    } catch (e) { window.giftVariantIds = []; }
    var count = parseInt(init.dataset.nonGiftCount, 10) || 0;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 99 ? '99+' : count;
    });
    var cartIcon = document.querySelector('[data-cart-icon]');
    if (cartIcon) cartIcon.setAttribute('aria-label', 'Cart (' + count + ' items)');
  })();

  (function () {
    var cartSectionEl = document.querySelector('[data-cart-section]');
    var ds = cartSectionEl ? cartSectionEl.dataset : {};
    var cartTitleLabel = ds.cartTitleLabel || 'Cart';
    var emptyHeadingLabel = ds.cartEmptyHeading || 'Your cart is empty';
    var emptyDescriptionLabel = ds.cartEmptyDescription || '';
    var visitHomepageLabel = ds.cartVisitHomepage || 'Visit homepage';
    var cartUpdateFailedLabel = ds.cartUpdateFailedLabel || "Couldn't update cart. Refresh and try again.";
    var cartClearFailedLabel = ds.cartClearFailedLabel || "Couldn't clear cart. Try again.";
    var cartCopyFailedLabel = ds.cartCopyFailedLabel || "Couldn't copy link. Try again.";
    var cartLinkCopiedLabel = ds.cartLinkCopiedLabel || 'Link copied';
    var cartClearedLabel = ds.cartClearedLabel || 'Cart cleared';
    var cartTotalLabel = ds.cartTotalLabel || 'Total';
    var cartItems = document.querySelector('[data-cart-items]');
    if (!cartItems) return;

    /* Resolve the real Section Rendering API id for this section instance.
       cart.json keys this section under "main", so the wrapper is
       <section id="shopify-section-main">. Passing the section TYPE
       ("main-cart") instead causes Shopify to render the section without
       its template blocks, which breaks the gift-skip in the line-items
       loop (all_gift_vid_set ends up empty, and gift lines render). */
    var cartSectionId = (cartSectionEl
      && cartSectionEl.closest('[id^="shopify-section-"]')
      && cartSectionEl.closest('[id^="shopify-section-"]').id.replace('shopify-section-', ''))
      || 'main';

    const rootUrl = window.Shopify?.routes?.root || '/';
    const subtotalEl = document.querySelector('[data-cart-subtotal]');
    const totalEl = document.querySelector('[data-cart-total]');
    const cartNote = document.querySelector('[data-cart-note]');
    const cartSection = document.querySelector('.section');

    let updating = false;
    const updateQueue = [];

    function debounce(fn, delay) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn(...args), delay);
      };
    }

    function formatMoney(cents) {
      var ns = window.pigment;
      if (ns && ns.formatMoney) return ns.formatMoney(cents);
      return (cents / 100).toFixed(2);
    }

    /* ── Toggle the spinner inside every [data-price-area] descendant.
          Each price area has one [data-price-content] (the rendered
          money) and one [data-price-spinner]. Swapping their `display`
          gives the user immediate "loading" feedback while the cart
          /change.js round-trip is in flight. ── */
    function togglePriceAreas(scope, loading) {
      if (!scope) return;
      const areas = scope.querySelectorAll('[data-price-area]');
      areas.forEach(area => {
        const content = area.querySelector('[data-price-content]');
        const spinner = area.querySelector('[data-price-spinner]');
        if (content) content.style.display = loading ? 'none' : '';
        if (spinner) spinner.style.display = loading ? 'inline-flex' : 'none';
      });
    }

    /* ── Recompute the parent product-group spinner: it's loading
          while ANY variant inside the group still has a pending
          quantity that the API hasn't acknowledged yet, OR while the
          whole cart has an in-flight update (because automatic
          discounts may re-price unrelated siblings). ── */
    function refreshGroupLoading(group) {
      if (!group) return;
      const anyPending = group.querySelector('[data-line-item][data-pending-qty]');
      const groupHeader = group.querySelector('[data-group-price-area]');
      if (!groupHeader) return;
      const shouldLoad = !!anyPending || cartIsUpdating;
      togglePriceAreas(groupHeader.parentElement, shouldLoad);
    }

    /* ── Set loading state on a line item.
          Only the price areas flip to a spinner — pointer-events stay
          live so the user can keep clicking +/- while a request is in
          flight. The debounce + queue in changeCart coalesce the
          rapid-fire clicks into the minimum number of API calls. */
    function setLineLoading(lineItem, loading) {
      togglePriceAreas(lineItem, loading);
      const group = lineItem.closest('[data-product-group]');
      if (group) refreshGroupLoading(group);
    }

    /* ── Cart-wide loading state.
          When any line's quantity changes, automatic discounts on
          unrelated lines may also re-price (e.g. a "buy 12 get X%
          off" promo dropping below threshold). Shopify's
          /cart/change.js response is authoritative for the entire
          cart, so we flash spinners on every line and every group
          total during the in-flight window — they all then settle
          to the API's new values inside updateCartUI. ── */
    let cartIsUpdating = false;
    function setCartUpdating(updating) {
      cartIsUpdating = updating;
      document.querySelectorAll('[data-line-item]').forEach(li => {
        /* Per-line pendingQty wins so a row that already has a more
           recent click queued stays in the loading state until its
           own update lands. Pointer events stay live throughout —
           the user can keep clicking +/- and the changeCart queue
           handles the rest. */
        if (updating || li.dataset.pendingQty === undefined) {
          togglePriceAreas(li, updating);
        }
      });
      document.querySelectorAll('[data-product-group]').forEach(refreshGroupLoading);
      /* Order summary subtotal/discount/total flip to spinner during
         the in-flight cart change — the API response is authoritative
         for these and may shift when automatic discounts re-evaluate. */
      document.querySelectorAll('[data-order-summary]').forEach(scope => {
        togglePriceAreas(scope, updating);
      });
    }

    /* ── Swap the cart line-items area from a section-rendered HTML
          response. Shopify's bundled section rendering gives us the
          freshly-rendered Liquid for the entire cart section in the
          same /cart/change.js round-trip, so all per-line prices,
          line totals, group totals, and any newly-recomputed
          automatic discounts come back in one drift-free chunk.

          Strips the .stagger-fade-in class (and its --stagger-i
          inline custom property) from the injected nodes so the new
          content appears at full opacity immediately. The initial
          server-rendered page still gets the staggered intro
          animation; we only suppress it on dynamic refresh, which is
          what stops the whole cart from flashing on every update. ── */
    function swapCartItemsFromSection(sectionHtml) {
      if (!sectionHtml || !cartItems) return false;
      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionHtml, 'text/html');
      const newCartItems = doc.querySelector('[data-cart-items]');
      if (!newCartItems) return false;

      newCartItems.querySelectorAll('.stagger-fade-in').forEach(el => {
        el.classList.remove('stagger-fade-in');
        el.style.removeProperty('--stagger-i');
        el.style.removeProperty('--stagger-step');
      });

      /* Capture pending qty per line key so spam +/- clicks made
         during the in-flight request aren't clobbered by the
         freshly-rendered server qty. The line keeps showing the
         user's latest value (and stays in loading state) until the
         API catches up. */
      const pendingByKey = new Map();
      cartItems.querySelectorAll('[data-line-item][data-pending-qty]').forEach(li => {
        const k = li.dataset.lineKey;
        const q = parseInt(li.dataset.pendingQty, 10);
        if (k && !isNaN(q)) pendingByKey.set(k, q);
      });

      adoptLoadedImages(cartItems, newCartItems);

      cartItems.replaceChildren(...newCartItems.childNodes);

      /* Re-apply pending state on the newly injected line items. */
      pendingByKey.forEach((qty, key) => {
        const li = cartItems.querySelector('[data-line-item][data-line-key="' + key.replace(/"/g, '\\"') + '"]');
        if (!li) return;
        const input = li.querySelector('[data-quantity-input]');
        const serverQty = input ? parseInt(input.value, 10) : NaN;
        if (qty === serverQty) return; /* API caught up — let the fresh state stand. */
        li.dataset.pendingQty = String(qty);
        if (input) input.value = qty;
        const min = parseInt(li.dataset.lineMin, 10) || 1;
        const max = parseInt(li.dataset.lineMax, 10) || 0;
        li.querySelectorAll('[data-quantity-minus]').forEach(b => { b.disabled = qty <= min; });
        li.querySelectorAll('[data-quantity-plus]').forEach(b => { b.disabled = max > 0 && qty >= max; });
        setLineLoading(li, true);
      });

      cartItems.querySelectorAll('[data-line-item]').forEach(bindLineItem);
      initSwatchPresentation(cartItems);
      return true;
    }

    /* ── Move already-decoded <img> elements from `oldRoot` into
          matching positions in `newRoot` so the subsequent DOM swap
          reuses the same painted image. Without this, every swap
          creates fresh <img> nodes and the browser repaints them with
          a one-frame gap even on cache hits — visible as a flicker on
          every cart update. Match by src (Shopify image URLs are
          stable across renders for a given variant + width). ── */
    function adoptLoadedImages(oldRoot, newRoot) {
      if (!oldRoot || !newRoot) return;
      const cache = new Map();
      oldRoot.querySelectorAll('img').forEach(img => {
        if (!img.complete || img.naturalWidth === 0) return;
        /* Match on the literal src attribute. Shopify image_tag emits
           the same value on every render for the same variant + width,
           so old and new img elements share an exact-string key. */
        const key = img.getAttribute('src');
        if (!key) return;
        if (!cache.has(key)) cache.set(key, []);
        cache.get(key).push(img);
      });
      newRoot.querySelectorAll('img').forEach(newImg => {
        const key = newImg.getAttribute('src');
        if (!key) return;
        const bucket = cache.get(key);
        if (!bucket || !bucket.length) return;
        newImg.replaceWith(bucket.shift());
      });
    }
    /* Expose so the gift-manager IIFE (separate scope) can reuse it. */
    if (window.pigment) window.pigment.adoptLoadedImages = adoptLoadedImages;

    /* ── AJAX cart change with queue to prevent overlapping calls ── */
    async function changeCart(key, quantity, lineItem) {
      /* If already updating, queue this change (replace any pending for same key) */
      const existing = updateQueue.findIndex(q => q.key === key);
      if (existing !== -1) updateQueue.splice(existing, 1);

      if (updating) {
        return new Promise((resolve) => {
          updateQueue.push({ key, quantity, lineItem, resolve });
        });
      }

      updating = true;
      if (lineItem && quantity > 0) setLineLoading(lineItem, true);

      try {
        const response = await fetch(rootUrl + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity, sections: cartSectionId }),
        });

        if (response.status === 422) {
          /* B2B quantity rule violation — fetch fresh cart to restore correct state */
          try {
            const freshCart = await cartGetCart(true);
            updateCartUI(freshCart, key, quantity);
          } catch (e) { /* ignore */ }
          if (lineItem) {
            delete lineItem.dataset.pendingQty;
            setLineLoading(lineItem, false);
          }
          if (updateQueue.length === 0) setCartUpdating(false);
          return;
        }

        if (!response.ok) throw new Error(cartUpdateFailedLabel);

        const cart = await response.json();
        updateCartUI(cart, key, quantity);

        /* Notify other sections (header count, product page stock) */
        if (window.cartNotification && window.cartNotification.refreshCartCount) {
          window.cartNotification.refreshCartCount();
        }
        /* Pass cart + bundled section HTML in detail so listeners can
           skip their own /cart.js and /?sections=… refetches. */
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart,
            sectionHtml: cart.sections && cart.sections[cartSectionId]
          }
        }));

        return cart;
      } catch (error) {
        /* Restore visual state on error */
        if (lineItem) {
          delete lineItem.dataset.pendingQty;
          setLineLoading(lineItem, false);
        }
        if (updateQueue.length === 0) setCartUpdating(false);
      } finally {
        updating = false;
        /* Process next queued update */
        if (updateQueue.length > 0) {
          const next = updateQueue.shift();
          changeCart(next.key, next.quantity, next.lineItem).then(next.resolve);
        }
      }
    }

    /* ── Remove a line item element with a slide-out transition ── */
    function removeLineElement(lineItem) {
      lineItem.style.transition = 'opacity 200ms ease, max-height 200ms ease, min-height 200ms ease, margin 200ms ease, padding 200ms ease';
      lineItem.style.overflow = 'hidden';
      lineItem.style.maxHeight = lineItem.offsetHeight + 'px';

      requestAnimationFrame(() => {
        lineItem.style.opacity = '0';
        lineItem.style.maxHeight = '0';
        /* Variant-swatch-row carries `min-h-[5rem]` for a stable
           layout so collapsing maxHeight alone leaves the row stuck
           at 80px. Zero out minHeight too so the slide-out matches
           cart-line-item's animation. */
        lineItem.style.minHeight = '0';
        lineItem.style.marginTop = '0';
        lineItem.style.marginBottom = '0';
        lineItem.style.paddingTop = '0';
        lineItem.style.paddingBottom = '0';
      });

      setTimeout(() => lineItem.remove(), 220);
    }

    /* ── Show empty cart state ── */
    let emptyCartShown = false;
    function showEmptyCart() {
      if (emptyCartShown) return;
      if (!cartSection) return;
      const container = cartSection.querySelector('.container');
      if (!container) return;
      emptyCartShown = true;

      /* Keep breadcrumbs and heading, replace the rest */
      const breadcrumbs = container.querySelector('nav[aria-label="Breadcrumb"]');
      const heading = container.querySelector('h1');

      container.innerHTML = '';
      if (breadcrumbs) container.appendChild(breadcrumbs);
      if (heading) {
        heading.textContent = cartTitleLabel;
        container.appendChild(heading);
      }

      const empty = document.createElement('div');
      empty.className = 'py-16 text-center';
      empty.innerHTML = '<h2 class="text-xl font-semibold text-foreground">' + emptyHeadingLabel + '</h2>'
        + '<p class="mt-2 text-muted-foreground">' + emptyDescriptionLabel + '</p>'
        + '<a href="' + rootUrl + '" class="text-cta mt-8">'
        + visitHomepageLabel
        + '<svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8.25 4.5l7.5 7.5-7.5 7.5" /></svg>'
        + '</a>';
      container.appendChild(empty);
    }

    /* Expose for other IIFEs (e.g. the Free Gift Manager) so they can
       trigger the empty-state render when their own cart operations are
       what tipped item_count to 0 (auto-removed gifts after the user's
       last paid line was deleted). Without this, the sidebar (order
       summary, discount, share, clear) would survive until a manual
       page reload. */
    window.pigment.cartUI = window.pigment.cartUI || {};
    window.pigment.cartUI.showEmptyCart = showEmptyCart;

    /* ── Update the DOM after a cart API response ── */
    function updateCartUI(cart, changedKey, requestedQty) {
      /* Update totals */
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.original_total_price);
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

      /* Update discount row */
      const discount = cart.total_discount || 0;
      document.querySelectorAll('[data-cart-discount-row]').forEach(row => {
        row.style.display = discount > 0 ? '' : 'none';
      });
      document.querySelectorAll('[data-cart-discount]').forEach(el => {
        el.textContent = '-' + formatMoney(discount);
      });

      /* Update header cart count (inline fallback if cartNotification not loaded yet) */
      const cartCountEls = document.querySelectorAll('[data-cart-count]');
      cartCountEls.forEach(el => {
        el.textContent = cart.item_count > 99 ? '99+' : cart.item_count;
        if (cart.item_count === 0) el.remove();
      });

      /* ── Bundled-section-rendering fast path ──
            If the API response carries the freshly-rendered main-cart
            HTML, replace the entire [data-cart-items] subtree with the
            server-side output. That includes every line item, every
            line total, every group total, every strike-through, and
            every newly-evaluated automatic discount — no client-side
            recomputation, zero drift between Liquid and JS. ── */
      if (cart.sections && cart.sections[cartSectionId]) {
        const swapped = swapCartItemsFromSection(cart.sections[cartSectionId]);
        if (swapped) {
          setCartUpdating(false);
          if (cart.item_count === 0) setTimeout(showEmptyCart, 300);
          return;
        }
      }

      /* Build lookups of current cart items by key and by variant ID */
      const cartItemMap = {};
      const cartItemByVariant = {};
      cart.items.forEach(item => {
        cartItemMap[item.key] = item;
        if (!cartItemByVariant[item.variant_id]) {
          cartItemByVariant[item.variant_id] = item;
        }
      });

      /* Update or remove each line item in the DOM */
      cartItems.querySelectorAll('[data-line-item]').forEach(lineEl => {
        const key = lineEl.dataset.lineKey;
        let cartItem = cartItemMap[key];

        /* Fallback: if key changed after update, match by variant ID */
        if (!cartItem && key) {
          const variantId = key.split(':')[0];
          cartItem = cartItemByVariant[variantId];
          if (cartItem) {
            lineEl.dataset.lineKey = cartItem.key;
          }
        }

        if (!cartItem) {
          /* Item was removed from cart — animate out */
          removeLineElement(lineEl);
          return;
        }

        /* Apply B2B quantity rules from API response if available */
        if (cartItem.quantity_rule && isB2B) {
          applyRuleToLineItem(lineEl, cartItem.quantity_rule);
        }

        /* Update quantity inputs and button states to reflect API response.
           Skip when the line has a newer pendingQty than the API just
           returned — the user has clicked +/- further while the request
           was in flight, so the visible value is intentionally ahead. */
        const pendingAttr = lineEl.dataset.pendingQty;
        const pendingQty = pendingAttr !== undefined ? parseInt(pendingAttr, 10) : null;
        const reflectQty = (pendingQty === null || pendingQty === cartItem.quantity)
          ? cartItem.quantity
          : pendingQty;
        const elMin = parseInt(lineEl.dataset.lineMin) || 1;
        const elMax = parseInt(lineEl.dataset.lineMax) || 0;
        lineEl.querySelectorAll('[data-quantity-input]').forEach(input => {
          input.value = reflectQty;
        });
        lineEl.querySelectorAll('[data-quantity-minus]').forEach(btn => {
          btn.disabled = reflectQty <= elMin;
        });
        lineEl.querySelectorAll('[data-quantity-plus]').forEach(btn => {
          btn.disabled = elMax > 0 && reflectQty >= elMax;
        });

        /* Update unit prices */
        const unitPrice = cartItem.final_price;
        const originalPrice = cartItem.original_price;
        const isDiscountedUnit = originalPrice > unitPrice;
        lineEl.querySelectorAll('[data-line-unit-price]').forEach(el => {
          el.textContent = formatMoney(unitPrice);
        });
        lineEl.querySelectorAll('[data-line-original-price]').forEach(el => {
          el.textContent = formatMoney(originalPrice);
          el.style.display = isDiscountedUnit ? '' : 'none';
        });

        /* Update line total (mobile + desktop column).
           The mobile "Total: £x" wrapper is hidden when qty == 1 to
           avoid showing the same number twice next to the unit price. */
        const lineTotal = lineEl.querySelector('[data-line-total]');
        if (lineTotal) lineTotal.textContent = formatMoney(cartItem.final_line_price);
        const lineTotalWrap = lineEl.querySelector('[data-line-total-wrap]');
        if (lineTotalWrap) lineTotalWrap.style.display = cartItem.quantity > 1 ? '' : 'none';
        const lineTotalCol = lineEl.querySelector('[data-line-total-col]');
        if (lineTotalCol) lineTotalCol.textContent = formatMoney(cartItem.final_line_price);

        /* Update stored prices for group aggregation */
        lineEl.dataset.linePrice = cartItem.final_line_price;
        lineEl.dataset.lineOriginalPrice = cartItem.original_line_price;

        /* Clear loading state only when the API response matches the
           latest user-requested quantity. Lingering pending lines keep
           their spinner visible until their own update lands. */
        if (pendingQty === null || pendingQty === cartItem.quantity) {
          delete lineEl.dataset.pendingQty;
          setLineLoading(lineEl, false);
        }
      });

      /* After all line items are reconciled, refresh every group
         spinner so the parent header total reflects the latest
         per-variant pending state. */
      document.querySelectorAll('[data-product-group]').forEach(refreshGroupLoading);

      /* Drop the cart-wide loading flag once nothing is queued and
         no per-line click is still mid-flight. Lines whose
         pendingQty already cleared above will now hide their
         spinners; lines that still have a queued newer click stay
         loading until their own update lands. */
      const stillPending = updateQueue.length > 0
        || document.querySelector('[data-line-item][data-pending-qty]');
      if (!stillPending) {
        setCartUpdating(false);
      }

      /* Update grouped product totals & remove empty groups */
      document.querySelectorAll('[data-product-group]').forEach(group => {
        /* Check after a brief delay so removed elements are gone */
        setTimeout(() => {
          const remaining = group.querySelectorAll('[data-line-item]');
          if (remaining.length === 0) {
            removeLineElement(group);
            return;
          }
          const groupTotalEl = group.querySelector('[data-group-total]');
          const groupTotalCol = group.querySelector('[data-group-total-col]');
          let sum = 0;
          let originalSum = 0;
          remaining.forEach(li => {
            sum += parseInt(li.dataset.linePrice) || 0;
            originalSum += parseInt(li.dataset.lineOriginalPrice) || 0;
          });
          const isDiscounted = originalSum > sum;
          if (groupTotalEl) {
            groupTotalEl.textContent = cartTotalLabel + ': ' + formatMoney(sum);
            /* Update discount styling on mobile */
            const parent = groupTotalEl.parentElement;
            if (parent) {
              const strikeEl = parent.querySelector('.line-through');
              if (isDiscounted) {
                groupTotalEl.className = groupTotalEl.className.replace('text-muted-foreground', 'text-primary');
                if (!groupTotalEl.classList.contains('text-primary')) groupTotalEl.classList.add('text-primary');
                groupTotalEl.classList.remove('text-muted-foreground');
                if (strikeEl) {
                  strikeEl.textContent = formatMoney(originalSum);
                } else {
                  const s = document.createElement('span');
                  s.className = 'text-muted-foreground line-through';
                  s.textContent = formatMoney(originalSum);
                  parent.appendChild(s);
                }
              } else {
                groupTotalEl.classList.remove('text-primary');
                if (!groupTotalEl.classList.contains('text-muted-foreground')) groupTotalEl.classList.add('text-muted-foreground');
                if (strikeEl) strikeEl.remove();
              }
            }
          }
          if (groupTotalCol) {
            groupTotalCol.textContent = formatMoney(sum);
            /* Update discount styling on desktop */
            const parent = groupTotalCol.parentElement;
            if (parent) {
              const strikeEl = parent.querySelector('.line-through');
              if (isDiscounted) {
                groupTotalCol.classList.remove('text-foreground');
                groupTotalCol.classList.add('text-primary');
                if (strikeEl) {
                  strikeEl.textContent = formatMoney(originalSum);
                } else {
                  const s = document.createElement('span');
                  s.className = 'block text-sm text-muted-foreground line-through';
                  s.textContent = formatMoney(originalSum);
                  parent.appendChild(s);
                }
              } else {
                groupTotalCol.classList.remove('text-primary');
                groupTotalCol.classList.add('text-foreground');
                if (strikeEl) strikeEl.remove();
              }
            }
          }
        }, 250);
      });

      /* Show empty cart if nothing left */
      if (cart.item_count === 0) {
        setTimeout(showEmptyCart, 300);
      }
    }

    /* ── Auto-remove stale line items (deleted/unavailable variants) ──
       Server-rendered loop hides them from view; this aligns the cart
       state so subtotal/total match what's displayed and so checkout
       doesn't trip over them. */
    (function cleanupStaleLineItems() {
      const raw = cartItems.dataset.staleLineKeys || '';
      const keys = raw.split('|||').filter(Boolean);
      if (!keys.length) return;

      const updates = {};
      keys.forEach(k => { updates[k] = 0; });

      fetch(rootUrl + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      })
        .then(res => res.ok ? res.json() : null)
        .then(cart => {
          if (!cart) return;
          updateCartUI(cart);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        })
        .catch(() => { /* swallow — page already hides them visually */ });
    })();

    /* ── Bind quantity controls on a line item (mirrors product-table.liquid pattern) ── */
    /* Reads step/min dynamically from data attributes so they can be updated after
       the cart API fetch provides correct B2B quantity rules. */
    function bindLineItem(lineItem) {
      if (!lineItem.dataset.lineKey) return;

      const inputs = lineItem.querySelectorAll('[data-quantity-input]');
      const minusBtns = lineItem.querySelectorAll('[data-quantity-minus]');
      const plusBtns = lineItem.querySelectorAll('[data-quantity-plus]');
      const removeBtns = lineItem.querySelectorAll('[data-remove-item]');

      /* Read key from data attribute each time so it stays current if updateCartUI refreshes it */
      const getKey = () => lineItem.dataset.lineKey;

      /* Dynamic reads — updated by fetchAndApplyQuantityRules after page load */
      function getMin() { return parseInt(lineItem.dataset.lineMin) || 1; }
      function getStep() { return parseInt(lineItem.dataset.lineStep) || 1; }
      function getLineMax() {
        const m = parseInt(lineItem.dataset.lineMax) || 0;
        return m > 0 ? m : -1; /* -1 = unlimited */
      }

      function snapToStep(val) {
        const min = getMin();
        const step = getStep();
        const steps = Math.round((val - min) / step);
        return min + Math.max(0, steps) * step;
      }

      function clampAndSnap(val) {
        const min = getMin();
        if (val < min) return min;
        val = snapToStep(val);
        const max = getLineMax();
        if (max >= 0) val = Math.min(max, val);
        return val;
      }

      function updateButtons(val) {
        const min = getMin();
        const max = getLineMax();
        const hasLimit = max >= 0;
        minusBtns.forEach(btn => { btn.disabled = val <= min; });
        plusBtns.forEach(btn => { btn.disabled = hasLimit && val >= max; });
      }

      function setQuantity(val) {
        inputs.forEach(i => { i.value = val; });
        updateButtons(val);
      }

      const debouncedCartChange = debounce((newQty) => {
        changeCart(getKey(), newQty, lineItem);
      }, 300);

      /* Mark this line as having an in-flight quantity update so the
         spinner stays visible until the API response actually matches
         the most recently requested value (avoids flicker when the
         user clicks rapidly across multiple lines). Also flips the
         cart-wide loading state so unrelated lines whose prices may
         change because of automatic discount re-evaluation also show
         spinners until /cart/change.js settles. */
      function markPending(newQty) {
        lineItem.dataset.pendingQty = String(newQty);
        setCartUpdating(true);
        setLineLoading(lineItem, true);
      }

      /* +/- button click handlers (matching product-table.liquid) */
      minusBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          const min = getMin();
          const step = getStep();
          const current = parseInt(inputs[0]?.value) || min;
          const newQty = current <= min ? min : clampAndSnap(current - step);
          if (newQty === current) return;
          setQuantity(newQty);
          markPending(newQty);
          debouncedCartChange(newQty);
        });
      });

      plusBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          const min = getMin();
          const step = getStep();
          const current = parseInt(inputs[0]?.value) || min;
          const max = getLineMax();
          if (max >= 0 && current >= max) return;
          const newQty = clampAndSnap(current + step);
          if (newQty === current) return;
          setQuantity(newQty);
          markPending(newQty);
          debouncedCartChange(newQty);
        });
      });

      /* Direct input change (user types a value) */
      inputs.forEach(input => {
        input.addEventListener('change', () => {
          const min = getMin();
          const val = parseInt(input.value);
          let newQty;
          if (isNaN(val) || val < min) {
            newQty = min;
          } else {
            newQty = clampAndSnap(val);
          }
          setQuantity(newQty);
          markPending(newQty);
          debouncedCartChange(newQty);
        });

        input.addEventListener('blur', () => {
          if (input.value === '' || isNaN(parseInt(input.value))) {
            setQuantity(getMin());
          }
        });
      });

      removeBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          /* Removing a line is exactly the kind of action that can
             trigger automatic-discount re-evaluation across the rest
             of the cart, so flip the cart-wide loading state too. */
          setCartUpdating(true);
          removeLineElement(lineItem);
          changeCart(getKey(), 0, lineItem);
        });
      });

      /* Set initial button states */
      updateButtons(parseInt(inputs[0]?.value) || getMin());
    }

    /* ── Apply a quantity rule to a line item element ── */
    function applyRuleToLineItem(li, rule) {
      /* Only UPGRADE values — never overwrite Liquid-rendered B2B rules with API defaults.
         The REST /cart.js and /products/ APIs lack B2B context and return default rules. */
      const curMin = parseInt(li.dataset.lineMin) || 1;
      const curStep = parseInt(li.dataset.lineStep) || 1;
      if (rule.min > curMin) {
        li.dataset.lineMin = rule.min;
      }
      if (rule.increment > curStep) {
        li.dataset.lineStep = rule.increment;
      }
      li.querySelectorAll('[data-quantity-input]').forEach(input => {
        if (rule.min > curMin) input.min = rule.min;
        if (rule.increment > curStep) input.step = rule.increment;
      });
      /* Re-evaluate button states */
      const effectiveMin = parseInt(li.dataset.lineMin) || 1;
      const qty = parseInt(li.querySelector('[data-quantity-input]')?.value) || effectiveMin;
      const maxAttr = parseInt(li.dataset.lineMax) || 0;
      li.querySelectorAll('[data-quantity-minus]').forEach(btn => { btn.disabled = qty <= effectiveMin; });
      li.querySelectorAll('[data-quantity-plus]').forEach(btn => { btn.disabled = maxAttr > 0 && qty >= maxAttr; });
    }

    /* ── Fetch B2B quantity rules and apply to line item data attributes ── */
    const isB2B = document.querySelector('meta[name="shopify-b2b"]')?.getAttribute('content') === 'true';

    async function fetchAndApplyQuantityRules() {
      if (!isB2B) return;

      /* Source 1: cart store — check if items include quantity_rule (only upgrade, never downgrade) */
      try {
        const cart = await cartGetCart();
        let rulesApplied = false;
        cart.items.forEach(item => {
          const rule = item.quantity_rule;
          if (!rule || (rule.increment <= 1 && rule.min <= 1)) return;
          rulesApplied = true;
          const vid = String(item.variant_id);
          cartItems.querySelectorAll('[data-line-item]').forEach(li => {
            const lineVid = li.dataset.lineKey?.split(':')[0];
            if (lineVid !== vid) return;
            applyRuleToLineItem(li, rule);
          });
        });
        if (rulesApplied) return;
      } catch (e) { /* continue to source 2 */ }

      /* Source 2: per-product fetch coalesced via the shared product cache,
         so calling cartGetProduct(handle) for the same handle never refetches.
         Previously this looped per line item firing parallel /products/{handle}.json
         requests; now duplicate handles share a single cached promise. */
      try {
        const productHandles = new Set();
        cartItems.querySelectorAll('[data-line-item]').forEach(li => {
          const parent = li.closest('[data-product-group]') || li;
          const link = parent.querySelector('a[href*="/products/"]');
          if (link) {
            const match = link.getAttribute('href').match(/\/products\/([^?/#]+)/);
            if (match) productHandles.add(match[1]);
          }
        });

        const fetches = Array.from(productHandles).map(function (handle) {
          return cartGetProduct(handle).catch(function () { return null; });
        });
        const results = await Promise.all(fetches);
        results.forEach(function (data) {
          if (!data || !data.product || !data.product.variants) return;
          data.product.variants.forEach(function (v) {
            var rule = v.quantity_rule;
            if (!rule || (rule.increment <= 1 && rule.min <= 1)) return;
            var vid = String(v.id);
            cartItems.querySelectorAll('[data-line-item]').forEach(function (li) {
              var lineVid = (li.dataset.lineKey || '').split(':')[0];
              if (lineVid !== vid) return;
              applyRuleToLineItem(li, rule);
            });
          });
        });
      } catch (e) { /* Fallback to Liquid-rendered values */ }
    }

    /* ── Bind all line items then fetch correct B2B rules ── */
    cartItems.querySelectorAll('[data-line-item]').forEach(bindLineItem);
    fetchAndApplyQuantityRules();

    /* ── Swatch text contrast ── */
    function getRelativeLuminance(hex) {
      hex = hex.replace('#', '');
      if (hex.length === 3) hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
      const r = parseInt(hex.substr(0,2),16)/255;
      const g = parseInt(hex.substr(2,2),16)/255;
      const b = parseInt(hex.substr(4,2),16)/255;
      const [rl,gl,bl] = [r,g,b].map(c => c<=0.03928 ? c/12.92 : Math.pow((c+0.055)/1.055,2.4));
      return 0.2126*rl + 0.7152*gl + 0.0722*bl;
    }

    function getImageLuminance(imgEl) {
      return new Promise(resolve => {
        function measure() {
          const canvas = document.createElement('canvas');
          const size = 64;
          canvas.width = size;
          canvas.height = size;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(imgEl, 0, 0, size, size);
          try {
            const data = ctx.getImageData(0, 0, size, size).data;
            let total = 0;
            const count = data.length / 4;
            for (let i = 0; i < data.length; i += 4) {
              const r = data[i] / 255;
              const g = data[i + 1] / 255;
              const b = data[i + 2] / 255;
              const [rl, gl, bl] = [r, g, b].map(c =>
                c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4)
              );
              total += 0.2126 * rl + 0.7152 * gl + 0.0722 * bl;
            }
            resolve(total / count);
          } catch (e) {
            resolve(0);
          }
        }
        if (imgEl.complete && imgEl.naturalWidth > 0) {
          measure();
        } else {
          imgEl.addEventListener('load', measure, { once: true });
          imgEl.addEventListener('error', () => resolve(0), { once: true });
        }
      });
    }

    /* ── Apply swatch text contrast + white-row borders. Runs once on
          initial load, and again on every section-rendered DOM swap so
          freshly-injected swatch rows pick up the same styling. ── */
    function initSwatchPresentation(scope) {
      if (!scope) return;
      scope.querySelectorAll('[data-swatch-hex]').forEach(el => {
        const hex = el.dataset.swatchHex;
        if (hex && getRelativeLuminance(hex) < 0.4) {
          el.style.color = 'oklch(100% 0 0)';
        }
      });
      scope.querySelectorAll('[data-bg-fallback]').forEach(el => {
        el.style.color = 'oklch(100% 0 0)';
      });
      scope.querySelectorAll('[data-bg-image]').forEach(el => {
        el.style.color = 'oklch(100% 0 0)';
        const img = el.querySelector('img');
        if (img) {
          getImageLuminance(img).then(luminance => {
            if (luminance >= 0.4) {
              el.style.color = '';
            }
          });
        }
      });
      scope.querySelectorAll('[data-variant-rows]').forEach(rowsContainer => {
        const rows = Array.from(rowsContainer.children);
        rows.forEach((el, i) => {
          if (!el.hasAttribute('data-is-white')) return;
          const prev = rows[i - 1];
          const next = rows[i + 1];
          const borderColor = 'var(--color-border)';
          const shadows = [];
          if (!prev || !prev.hasAttribute('data-is-white'))
            shadows.push('inset 0 1px 0 0 ' + borderColor);
          if (!next || !next.hasAttribute('data-is-white'))
            shadows.push('inset 0 -1px 0 0 ' + borderColor);
          shadows.push('inset 1px 0 0 0 ' + borderColor);
          shadows.push('inset -1px 0 0 0 ' + borderColor);
          if (prev && prev.hasAttribute('data-is-white'))
            shadows.push('inset 0 1px 0 0 ' + borderColor);
          el.style.boxShadow = shadows.join(', ');
        });
      });
    }
    initSwatchPresentation(document);

    /* ── Cart note auto-save ── */
    if (cartNote) {
      const saveNote = debounce(async (note) => {
        try {
          await fetch(rootUrl + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note }),
          });
        } catch (error) {
          /* swallow note save error */
        }
      }, 500);

      cartNote.addEventListener('input', (e) => {
        saveNote(e.target.value);
      });
    }

    /* ── Share cart ── */
    const shareCartBtn = document.getElementById('share-cart-btn');
    if (shareCartBtn) {
      shareCartBtn.addEventListener('click', () => {
        /* Build a promise that fetches cart and returns the share URL */
        const urlPromise = cartGetCart()
          .then(cart => {
            if (!cart.items || cart.items.length === 0) {
              throw new Error('empty');
            }
            /* Shopify's native cart permalink: /cart/{variant_id}:{qty},...
               Server-side; tolerant of unavailable variants (silently skipped)
               rather than failing the whole batch like cart/add.js does.
               ?storefront=true forces a redirect to /cart instead of /checkout
               (the permalink defaults to checkout). */
            const items = cart.items.map(item => item.variant_id + ':' + item.quantity);
            return window.location.origin + '/cart/' + items.join(',') + '?storefront=true';
          });

        /*
         * Clipboard write MUST be called synchronously within the click handler.
         * Safari expires transient user activation after any await/async gap,
         * so navigator.clipboard.writeText() after an await will always fail.
         *
         * ClipboardItem accepts a Promise for its data, allowing us to initiate
         * the clipboard write synchronously while resolving the data async.
         */
        const supportsClipboardItem = typeof ClipboardItem !== 'undefined'
          && navigator.clipboard
          && typeof navigator.clipboard.write === 'function';

        if (supportsClipboardItem) {
          const blobPromise = urlPromise.then(url => new Blob([url], { type: 'text/plain' }));
          navigator.clipboard.write([
            new ClipboardItem({ 'text/plain': blobPromise })
          ]).then(() => {
            window.showToast('cart-toast', {
              message: cartLinkCopiedLabel,
              icon: 'check',
              duration: 3000
            });
          }).catch(error => {
            if (error.message === 'empty') return;
            window.showToast('cart-toast', {
              message: cartCopyFailedLabel,
              icon: 'x',
              duration: 3000
            });
          });
        } else {
          /* Fallback for browsers without ClipboardItem (older Firefox, etc.) */
          urlPromise.then(shareUrl => {
            const textarea = document.createElement('textarea');
            textarea.value = shareUrl;
            textarea.setAttribute('readonly', '');
            textarea.style.cssText = 'position:fixed;left:-9999px;top:-9999px;opacity:0';
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            textarea.setSelectionRange(0, textarea.value.length);
            document.execCommand('copy');
            document.body.removeChild(textarea);
            window.showToast('cart-toast', {
              message: cartLinkCopiedLabel,
              icon: 'check',
              duration: 3000
            });
          }).catch(error => {
            if (error.message === 'empty') return;
            window.showToast('cart-toast', {
              message: cartCopyFailedLabel,
              icon: 'x',
              duration: 3000
            });
          });
        }
      });
    }

    /* ── Clear cart ──
       Look up the dialog API at click time. The dialog snippet's bundled
       JS lives in snippet-scripts.js and may not have populated
       window.dialog_clear_cart_confirm by the time this main-cart bundle
       initialises — the previous bind-time capture meant the listener was
       only attached if the API happened to be ready, which it often isn't. */
    const clearCartBtn = document.getElementById('clear-cart-btn');
    const clearCartDialog = document.getElementById('clear-cart-confirm');

    if (clearCartBtn) {
      clearCartBtn.addEventListener('click', () => {
        const api = window.dialog_clear_cart_confirm;
        if (api) api.open();
      });
    }

    if (clearCartDialog) {
      clearCartDialog.addEventListener('dialog:confirm', async () => {
        try {
          const res = await fetch(rootUrl + 'cart/clear.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
          });

          if (!res.ok) throw new Error(cartClearFailedLabel);

          const cart = await res.json().catch(() => null);

          /* Update header cart count */
          document.querySelectorAll('[data-cart-count]').forEach(el => el.remove());

          /* Notify other sections */
          if (window.cartNotification && window.cartNotification.refreshCartCount) {
            window.cartNotification.refreshCartCount();
          }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart ? { cart } : {} }));

          /* Show empty cart state */
          showEmptyCart();

          window.showToast('cart-toast', {
            message: cartClearedLabel,
            icon: 'check',
            duration: 3000
          });
        } catch (error) {
          window.showToast('cart-toast', {
            message: cartClearFailedLabel,
            icon: 'x',
            duration: 3000
          });
        }
      });
    }
  })();

  /* ── Free Gift Manager ── */
  (function() {
    const configEl = document.querySelector('[data-free-gift-config]');
    if (!configEl) return;

    let config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }
    if (!config.gifts || !config.gifts.length) return;

    const rootUrl = window.Shopify?.routes?.root || '/';
    const giftCartSectionEl = document.querySelector('[data-cart-section]');
    const giftCartDs = giftCartSectionEl?.dataset || {};
    const giftOutOfStockLabel = giftCartDs.giftOutOfStockLabel || 'This gift is out of stock. Pick another option.';
    /* Section Rendering API id for the cart section instance.
       Resolved here because cartSectionId in the cart IIFE is out of
       scope. Falls back to 'main' (cart.json's section key). */
    const cartSectionId = (giftCartSectionEl
      && giftCartSectionEl.closest('[id^="shopify-section-"]')
      && giftCartSectionEl.closest('[id^="shopify-section-"]').id.replace('shopify-section-', ''))
      || 'main';
    let giftUpdating = false;
    const giftQueue = [];

    let giftOperationInProgress = false;
    const autoGiftOptedOut = {};

    /* Build all gift variant IDs from config */
    function buildAllGiftVariantIds() {
      const ids = [];
      config.gifts.forEach(g => {
        (g.variantIds || []).forEach(v => ids.push(v));
      });
      return ids;
    }
    let allGiftVariantIds = buildAllGiftVariantIds();

    /* ── Queued AJAX helper for gift operations ── */
    async function giftCartOp(method, body) {
      if (giftUpdating) {
        return new Promise((resolve) => {
          giftQueue.push({ method, body, resolve });
        });
      }
      giftUpdating = true;
      try {
        const url = method === 'add'
          ? rootUrl + 'cart/add.js'
          : rootUrl + 'cart/change.js';
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        });
        if (!res.ok) throw new Error('Gift cart operation failed');
        const cart = await res.json();
        return cart;
      } finally {
        giftUpdating = false;
        if (giftQueue.length > 0) {
          const next = giftQueue.shift();
          giftCartOp(next.method, next.body).then(next.resolve);
        }
      }
    }

    /* ── Refresh gift sections from server ──
       If `prefetchedHtml` is provided (from a /cart/change.js?sections=…
       bundled response we already paid for), reuse it instead of issuing
       a separate /?sections=… request. Halves the request count on every
       qty change. */
    async function refreshGiftSections(prefetchedHtml) {
      try {
        let html = prefetchedHtml;
        if (!html) {
          const res = await fetch(rootUrl + '?sections=' + cartSectionId);
          if (!res.ok) return;
          const data = await res.json();
          html = data[cartSectionId];
        }
        if (!html) return;

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        /* Empty-cart short-circuit: the section renders no [data-cart-items]
           when cart.item_count is 0 (the cart.item_count > 0 liquid block
           is skipped server-side). When the gift manager just auto-removed
           the last remaining line (e.g. the user deleted their last paid
           product and the dependent gift was then evicted), the main cart
           IIFE's updateCartUI has already finished and won't fire again, so
           the sidebar (order summary, discount, share, clear) would otherwise
           survive until a manual reload. Hand off to the main IIFE's
           showEmptyCart, which clears the .container and renders the empty
           state. */
        if (!doc.querySelector('[data-cart-items]')) {
          if (window.pigment && window.pigment.cartUI && window.pigment.cartUI.showEmptyCart) {
            window.pigment.cartUI.showEmptyCart();
          }
          return;
        }

        /* Replace each gift block by data-gift-block-id. Before swapping,
           adopt the existing decoded gift-card <img> nodes into the new
           tree so the browser doesn't repaint them — kills the per-update
           image flicker. */
        const adopt = window.pigment && window.pigment.adoptLoadedImages;
        config.gifts.forEach(gift => {
          const sel = '[data-gift-block-id="' + gift.blockId + '"]';
          const newEl = doc.querySelector(sel);
          const oldEl = document.querySelector(sel);
          if (newEl && oldEl) {
            if (adopt) adopt(oldEl, newEl);
            oldEl.replaceWith(newEl);
          } else if (newEl && !oldEl) {
            const anchor = document.querySelector('[data-cart-subtotal]')?.closest('.border.border-border');
            if (anchor) anchor.before(newEl);
          } else if (!newEl && oldEl) {
            oldEl.remove();
          }
        });

        /* Update config from new HTML */
        const newConfigEl = doc.querySelector('[data-free-gift-config]');
        if (newConfigEl) {
          try {
            config = JSON.parse(newConfigEl.textContent);
            allGiftVariantIds = buildAllGiftVariantIds();
            const oldConfig = document.querySelector('[data-free-gift-config]');
            if (oldConfig) oldConfig.textContent = newConfigEl.textContent;
          } catch (e) { /* ignore parse errors */ }
        }

        /* Re-bind all gift controls after DOM replacement */
        bindAllGiftControls();

        /* Update cart totals in Order Summary */
        const newSubtotal = doc.querySelector('[data-cart-subtotal]');
        const newTotal = doc.querySelector('[data-cart-total]');
        if (newSubtotal) {
          const el = document.querySelector('[data-cart-subtotal]');
          if (el) el.textContent = newSubtotal.textContent;
        }
        if (newTotal) {
          const el = document.querySelector('[data-cart-total]');
          if (el) el.textContent = newTotal.textContent;
        }

        /* Update discount row */
        const newDiscountRow = doc.querySelector('[data-cart-discount-row]');
        const oldDiscountRow = document.querySelector('[data-cart-discount-row]');
        if (newDiscountRow && oldDiscountRow) {
          oldDiscountRow.style.display = newDiscountRow.style.display;
          const newDiscount = newDiscountRow.querySelector('[data-cart-discount]');
          const oldDiscount = oldDiscountRow.querySelector('[data-cart-discount]');
          if (newDiscount && oldDiscount) oldDiscount.textContent = newDiscount.textContent;
        }

        /* Update header cart count */
        const newCounts = doc.querySelectorAll('[data-cart-count]');
        if (newCounts.length > 0) {
          document.querySelectorAll('[data-cart-count]').forEach((el, i) => {
            if (newCounts[i]) el.textContent = newCounts[i].textContent;
          });
        }
      } catch (error) {
      }
    }

    /* ── Reset all gift indicators in a section to unchecked state ── */
    function resetGiftIndicators(section) {
      section.querySelectorAll('[data-gift-card]').forEach(c => {
        const r = c.querySelector('[data-gift-radio]');
        if (r) r.checked = false;
        const u = c.querySelector('[data-gift-unchecked]');
        const ch = c.querySelector('[data-gift-checked]');
        if (ch && ch.style.display !== 'none') {
          ch.style.animation = 'gift-check-out 100ms ease-in forwards';
          setTimeout(() => { ch.style.display = 'none'; ch.style.animation = ''; }, 100);
        }
        if (u && u.style.display === 'none') {
          u.style.display = '';
          u.style.animation = 'none';
          u.offsetHeight;
          u.style.animation = 'gift-check-in 120ms ease-out';
        }
      });
    }

    /* ── Animate the checkmark pop-in on a freshly rendered card ── */
    function animateCheckIn(section, variantId) {
      const card = section
        ? section.querySelector('[data-gift-card][data-variant-id="' + variantId + '"]')
        : document.querySelector('[data-gift-card][data-variant-id="' + variantId + '"]');
      if (!card) return;
      const ch = card.querySelector('[data-gift-checked]');
      if (ch && ch.style.display !== 'none') {
        ch.style.animation = 'none';
        ch.offsetHeight;
        ch.style.animation = 'gift-check-in 120ms ease-out';
      }
    }

    /* ── Set a single card's indicator to checked or unchecked ── */
    function setGiftIndicator(card, checked) {
      const u = card.querySelector('[data-gift-unchecked]');
      const ch = card.querySelector('[data-gift-checked]');
      if (checked) {
        if (u) {
          u.style.animation = 'gift-check-out 100ms ease-in forwards';
          setTimeout(() => { u.style.display = 'none'; u.style.animation = ''; }, 100);
        }
        if (ch) {
          ch.style.display = '';
          ch.style.animation = 'none';
          ch.offsetHeight;
          ch.style.animation = 'gift-check-in 120ms ease-out';
        }
      } else {
        if (ch) {
          ch.style.animation = 'gift-check-out 100ms ease-in forwards';
          setTimeout(() => { ch.style.display = 'none'; ch.style.animation = ''; }, 100);
        }
        if (u) {
          u.style.display = '';
          u.style.animation = 'none';
          u.offsetHeight;
          u.style.animation = 'gift-check-in 120ms ease-out';
        }
      }
    }

    /* ── Gift card loading spinner helpers ── */
    function showGiftSpinner(card) {
      card._spinnerTimer = setTimeout(() => {
        const unchecked = card.querySelector('[data-gift-unchecked]');
        const checked = card.querySelector('[data-gift-checked]');
        const spinner = card.querySelector('[data-gift-spinner]');
        const spinnerInner = spinner && spinner.querySelector('[role="status"]');
        if (unchecked) unchecked.style.display = 'none';
        if (checked) checked.style.display = 'none';
        if (spinner) spinner.style.display = '';
        if (spinnerInner) spinnerInner.style.display = '';
        card._spinnerVisible = true;
      }, 150);
    }

    function hideGiftSpinner(card) {
      clearTimeout(card._spinnerTimer);
      if (!card._spinnerVisible) return;
      const radio = card.querySelector('[data-gift-radio]');
      const unchecked = card.querySelector('[data-gift-unchecked]');
      const checked = card.querySelector('[data-gift-checked]');
      const spinner = card.querySelector('[data-gift-spinner]');
      const spinnerInner = spinner && spinner.querySelector('[role="status"]');
      if (spinner) spinner.style.display = 'none';
      if (spinnerInner) spinnerInner.style.display = 'none';
      const isChecked = radio && radio.checked;
      if (isChecked) {
        if (unchecked) unchecked.style.display = 'none';
        if (checked) {
          checked.style.display = '';
          checked.style.animation = 'none';
          checked.offsetHeight;
          checked.style.animation = 'gift-check-in 120ms ease-out';
        }
      } else {
        if (checked) checked.style.display = 'none';
        if (unchecked) {
          unchecked.style.display = '';
          unchecked.style.animation = 'none';
          unchecked.offsetHeight;
          unchecked.style.animation = 'gift-check-in 120ms ease-out';
        }
      }
      card._spinnerVisible = false;
    }

    /* ── Bind all gift controls (iterates config.gifts) ── */
    function bindAllGiftControls() {
      config.gifts.forEach(giftConfig => {
        const section = document.querySelector('[data-gift-block-id="' + giftConfig.blockId + '"]');
        if (!section) return;
        if (giftConfig.mode === 'pick') bindPickGiftSection(section, giftConfig);
        else if (giftConfig.mode === 'auto') bindAutoGiftSection(section, giftConfig);
      });
    }

    /* ── Pick gift controls (per block instance) ── */
    function bindPickGiftSection(section, giftConfig) {
      const maxTotal = parseInt(section.dataset.maxTotal) || 1;
      const pickVids = giftConfig.variantIds || [];

      section.querySelectorAll('[data-gift-card]').forEach(card => {
        const radio = card.querySelector('[data-gift-radio]');
        if (!radio) return;

        card.addEventListener('click', async (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (giftOperationInProgress) return;

          const variantId = parseInt(card.dataset.variantId);
          const handle = card.dataset.productHandle;
          const isSelected = card.querySelector('[data-gift-checked]').style.display !== 'none';

          if (isSelected) {
            radio.checked = false;
            setGiftIndicator(card, false);
            showGiftSpinner(card);
            giftOperationInProgress = true;
            try {
              const cart = await cartGetCart(true);
              for (const item of cart.items) {
                if (pickVids.includes(item.variant_id)) {
                  await giftCartOp('change', { id: item.key, quantity: 0 });
                }
              }
              if (window.cartNotification && window.cartNotification.refreshCartCount) {
                window.cartNotification.refreshCartCount();
              }
            } finally {
              giftOperationInProgress = false;
              hideGiftSpinner(card);
            }
            return;
          }

          if (handle) {
            try {
              const pData = await cartGetProduct(handle);
              if (pData && pData.product) {
                const variant = pData.product.variants.find(v => v.id === variantId);
                if (variant && variant.inventory_management && variant.inventory_quantity < maxTotal) {
                  if (window.showToast) {
                    window.showToast('cart-toast', {
                      message: giftOutOfStockLabel,
                      icon: 'info',
                      duration: 4000
                    });
                  }
                  return;
                }
              }
            } catch (e) { /* proceed if check fails */ }
          }

          resetGiftIndicators(section);
          showGiftSpinner(card);
          giftOperationInProgress = true;
          try {
            const cart = await cartGetCart(true);
            let existingItem = null;
            for (const item of cart.items) {
              if (pickVids.includes(item.variant_id)) {
                if (item.variant_id === variantId) {
                  existingItem = item;
                } else {
                  await giftCartOp('change', { id: item.key, quantity: 0 });
                }
              }
            }

            if (existingItem) {
              await giftCartOp('change', { id: existingItem.key, quantity: maxTotal });
            } else {
              await giftCartOp('add', { items: [{ id: variantId, quantity: maxTotal }] });
            }

            if (window.cartNotification && window.cartNotification.refreshCartCount) {
              window.cartNotification.refreshCartCount();
            }
            await refreshGiftSections();
            animateCheckIn(null, variantId);
          } catch (err) {
            hideGiftSpinner(card);
          } finally {
            giftOperationInProgress = false;
          }
        });
      });
    }

    /* ── Auto gift controls (per block instance) ── */
    function bindAutoGiftSection(section, giftConfig) {
      const autoVid = (giftConfig.variantIds || [])[0];
      if (!autoVid) return;

      const card = section.querySelector('[data-gift-card]');
      if (!card) return;

      const radio = card.querySelector('[data-gift-radio]');
      if (!radio) return;

      card.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (giftOperationInProgress) return;

        const isSelected = card.querySelector('[data-gift-checked]').style.display !== 'none';

        if (isSelected) {
          radio.checked = false;
          setGiftIndicator(card, false);
          autoGiftOptedOut[giftConfig.blockId] = true;
          showGiftSpinner(card);
          giftOperationInProgress = true;
          try {
            const cart = await cartGetCart(true);
            const autoItem = cart.items.find(i => i.variant_id === autoVid);
            if (autoItem) await giftCartOp('change', { id: autoItem.key, quantity: 0 });
            if (window.cartNotification && window.cartNotification.refreshCartCount) {
              window.cartNotification.refreshCartCount();
            }
          } finally {
            giftOperationInProgress = false;
            hideGiftSpinner(card);
          }
          return;
        }

        autoGiftOptedOut[giftConfig.blockId] = false;
        showGiftSpinner(card);
        giftOperationInProgress = true;
        try {
          await giftCartOp('add', { items: [{ id: autoVid, quantity: 1 }] });
          if (window.cartNotification && window.cartNotification.refreshCartCount) {
            window.cartNotification.refreshCartCount();
          }
          await refreshGiftSections();
          animateCheckIn(null, autoVid);
        } catch (err) {
          hideGiftSpinner(card);
        } finally {
          giftOperationInProgress = false;
        }
      });
    }

    /* ── Check condition helper ── */
    async function checkCondition(gift, cartTotal, cart) {
      if (gift.condition === 'spend') {
        return { met: cartTotal >= gift.threshold, qualifyingCount: 0, taggedSpend: 0 };
      }
      const { count: qualifyingCount, spend: taggedSpend } = gift.tag
        ? await countQualifyingItems(cart, gift.tag)
        : { count: 0, spend: 0 };
      if (gift.condition === 'tag') {
        return { met: qualifyingCount > 0, qualifyingCount, taggedSpend };
      }
      if (gift.condition === 'tag_and_spend') {
        return { met: qualifyingCount > 0 && taggedSpend >= gift.threshold, qualifyingCount, taggedSpend };
      }
      return { met: false, qualifyingCount: 0, taggedSpend: 0 };
    }

    /* ── Auto Gift: add/remove automatically ── */
    async function enforceAutoGift(cart) {
      let mutated = false;
      for (const gift of config.gifts) {
        if (gift.mode !== 'auto') continue;
        const autoVid = (gift.variantIds || [])[0];
        if (!autoVid) continue;

        let cartTotalExGifts = 0;
        let autoGiftItem = null;
        cart.items.forEach(item => {
          if (item.variant_id === autoVid) {
            autoGiftItem = item;
          } else if (!allGiftVariantIds.includes(item.variant_id)) {
            cartTotalExGifts += item.final_line_price;
          }
        });

        const { met } = await checkCondition(gift, cartTotalExGifts, cart);

        if (met && !autoGiftItem && !autoGiftOptedOut[gift.blockId]) {
          giftOperationInProgress = true;
          try {
            await giftCartOp('add', { items: [{ id: autoVid, quantity: 1 }] });
            mutated = true;
            if (window.cartNotification && window.cartNotification.refreshCartCount) {
              window.cartNotification.refreshCartCount();
            }
          } finally {
            giftOperationInProgress = false;
          }
        } else if (!met && autoGiftItem) {
          giftOperationInProgress = true;
          try {
            await giftCartOp('change', { id: autoGiftItem.key, quantity: 0 });
            mutated = true;
            if (window.cartNotification && window.cartNotification.refreshCartCount) {
              window.cartNotification.refreshCartCount();
            }
          } finally {
            giftOperationInProgress = false;
          }
        } else if (autoGiftItem && autoGiftItem.quantity > 1) {
          giftOperationInProgress = true;
          try {
            await giftCartOp('change', { id: autoGiftItem.key, quantity: 1 });
            mutated = true;
          } finally {
            giftOperationInProgress = false;
          }
        }
      }
      return mutated;
    }

    /* ── Tag-check cache for qualifying product lookups ── */
    const tagCache = {};

    async function countQualifyingItems(cart, tag) {
      let count = 0;
      let spend = 0;
      for (const item of cart.items) {
        if (allGiftVariantIds.includes(item.variant_id)) continue;
        if (tagCache[item.handle] !== undefined) {
          if (Array.isArray(tagCache[item.handle]) && tagCache[item.handle].includes(tag)) {
            count += item.quantity;
            spend += item.final_line_price;
          }
          continue;
        }
        try {
          const pData = await cartGetProduct(item.handle);
          const rawTags = pData && pData.product && pData.product.tags;
          tagCache[item.handle] = Array.isArray(rawTags)
            ? rawTags
            : (typeof rawTags === 'string' ? rawTags.split(', ') : false);
        } catch (e) {
          tagCache[item.handle] = false;
        }
        if (Array.isArray(tagCache[item.handle]) && tagCache[item.handle].includes(tag)) {
          count += item.quantity;
          spend += item.final_line_price;
        }
      }
      return { count, spend };
    }

    /* ── Listen for cart:updated to enforce limits ──
       Reuse cart + section HTML from event detail when present (set by
       main-cart's own dispatchers) so the steady-state qty-change path
       costs one network request — the original /cart/change.js — instead
       of also re-fetching /cart.js and /?sections=…. The end-of-enforce
       refreshGiftSections is only fired when the enforce actually
       mutated the cart; otherwise the immediate refresh above already
       reflects the latest state. */
    let enforceTimer = null;
    document.addEventListener('cart:updated', (e) => {
      if (giftOperationInProgress) return;

      const detail = (e && e.detail) || {};
      const detailCart = detail.cart || null;
      const detailSectionHtml = detail.sectionHtml || null;

      refreshGiftSections(detailSectionHtml);

      clearTimeout(enforceTimer);
      enforceTimer = setTimeout(async () => {
        try {
          /* Prefer the cart bundled into the event over a fresh /cart.js
             round-trip. Fall back to the cart store when an external
             dispatcher fires cart:updated without detail. */
          const cart = detailCart || await cartGetCart(true);
          let mutated = false;

          const cartTotalExGifts = cart.items.reduce((sum, i) =>
            sum + (allGiftVariantIds.includes(i.variant_id) ? 0 : i.final_line_price), 0);

          for (const gift of config.gifts) {
            const giftVids = gift.variantIds || [];
            const giftInCart = cart.items.find(i => giftVids.includes(i.variant_id));

            if (gift.mode === 'pick') {
              const { met, qualifyingCount } = await checkCondition(gift, cartTotalExGifts, cart);

              if (giftInCart && !met) {
                await giftCartOp('change', { id: giftInCart.key, quantity: 0 });
                mutated = true;
                if (window.cartNotification && window.cartNotification.refreshCartCount) {
                  window.cartNotification.refreshCartCount();
                }
              } else if (giftInCart && met && gift.quantityMode === 'match_qualifying' && qualifyingCount > 0) {
                let effectiveCount = qualifyingCount;
                try {
                  const pData = await cartGetProduct(giftInCart.handle);
                  if (pData && pData.product) {
                    const variant = pData.product.variants.find(v => v.id === giftInCart.variant_id);
                    if (variant && variant.inventory_management && variant.inventory_quantity < effectiveCount) {
                      effectiveCount = Math.max(0, variant.inventory_quantity);
                    }
                  }
                } catch (e) { /* proceed with uncapped count */ }
                if (effectiveCount === 0) {
                  await giftCartOp('change', { id: giftInCart.key, quantity: 0 });
                  mutated = true;
                } else if (giftInCart.quantity !== effectiveCount) {
                  await giftCartOp('change', { id: giftInCart.key, quantity: effectiveCount });
                  mutated = true;
                }
              } else if (!giftInCart && met && gift.defaultVariantId) {
                giftOperationInProgress = true;
                try {
                  await giftCartOp('add', { items: [{ id: gift.defaultVariantId, quantity: 1 }] });
                  mutated = true;
                  if (window.cartNotification && window.cartNotification.refreshCartCount) {
                    window.cartNotification.refreshCartCount();
                  }
                } finally {
                  giftOperationInProgress = false;
                }
              }
            }
          }

          const autoMutated = await enforceAutoGift(cart);
          if (mutated || autoMutated) {
            /* Cart actually changed during enforce — re-render gift
               blocks against fresh server state. No prefetched HTML to
               reuse here, so this does pay one /?sections=… request. */
            refreshGiftSections();
          }
        } catch (e) {
        }
      }, 500);
    });

    /* ── Initial bind ── */
    bindAllGiftControls();

    /* ── Initial gift enforcement on page load ── */
    {
      const needsEnforcement = config.gifts.some(g => (g.variantIds || []).length > 0);
      if (needsEnforcement) {
        cartGetCart()
          .then(async cart => {
            const cartTotalExGifts = cart.items.reduce((sum, i) =>
              sum + (allGiftVariantIds.includes(i.variant_id) ? 0 : i.final_line_price), 0);

            for (const gift of config.gifts) {
              if (gift.mode === 'pick') {
                const giftVids = gift.variantIds || [];
                const giftItem = cart.items.find(i => giftVids.includes(i.variant_id));
                const { met } = await checkCondition(gift, cartTotalExGifts, cart);
                if (giftItem && !met) {
                  await giftCartOp('change', { id: giftItem.key || giftItem.variant_id, quantity: 0 });
                } else if (!giftItem && met && gift.defaultVariantId) {
                  giftOperationInProgress = true;
                  try {
                    await giftCartOp('add', { items: [{ id: gift.defaultVariantId, quantity: 1 }] });
                  } finally {
                    giftOperationInProgress = false;
                  }
                }
              }
            }
            await enforceAutoGift(cart);
            await refreshGiftSections();
          })
          .catch(() => {});
      }
    }
  })();

  /* ── Pre-Checkout Gift Gate ──
     Independent safety net: validates all gifts before checkout.
     Runs outside the Free Gift Manager so it works even if that IIFE errors.
     Uses line item keys (Shopify recommended) and the Product API for tags. */
  (function() {
    var configEl = document.querySelector('[data-free-gift-config]');
    if (!configEl) return;

    var cfg;
    try { cfg = JSON.parse(configEl.textContent); } catch (e) { return; }
    if (!cfg.gifts || !cfg.gifts.length) return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var checkoutCartDs = document.querySelector('[data-cart-section]')?.dataset || {};
    var checkoutValidatingLabel = checkoutCartDs.discountValidatingLabel || 'Validating…';

    var allGiftVids = [];
    cfg.gifts.forEach(function(g) {
      (g.variantIds || []).forEach(function(v) { allGiftVids.push(v); });
    });

    function removeItem(key) {
      return fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
    }

    function changeItem(key, qty) {
      return fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
    }

    async function validateGifts() {
      var cart = await cartGetCart(true);

      /* Cart total excluding all gift items */
      var cartTotal = 0;
      cart.items.forEach(function(item) {
        if (allGiftVids.indexOf(item.variant_id) === -1) {
          cartTotal += item.final_line_price;
        }
      });

      /* Tag cache: handle → tags array (or false) */
      var tagCacheGate = {};

      async function countTagged(tag) {
        var count = 0;
        var spend = 0;
        for (var i = 0; i < cart.items.length; i++) {
          var ci = cart.items[i];
          if (allGiftVids.indexOf(ci.variant_id) !== -1) continue;
          if (tagCacheGate[ci.handle] === undefined) {
            try {
              var pData = await cartGetProduct(ci.handle);
              var rawTags = pData && pData.product && pData.product.tags;
              tagCacheGate[ci.handle] = Array.isArray(rawTags)
                ? rawTags
                : (typeof rawTags === 'string' ? rawTags.split(', ') : false);
            } catch (e) {
              tagCacheGate[ci.handle] = false;
            }
          }
          var cached = tagCacheGate[ci.handle];
          if (Array.isArray(cached) && cached.indexOf(tag) !== -1) {
            count += ci.quantity;
            spend += ci.final_line_price;
          }
        }
        return { count: count, spend: spend };
      }

      for (var gi = 0; gi < cfg.gifts.length; gi++) {
        var gift = cfg.gifts[gi];
        var giftVids = gift.variantIds || [];

        /* Find gift items in cart */
        var giftsInCart = [];
        for (var i = 0; i < cart.items.length; i++) {
          if (giftVids.indexOf(cart.items[i].variant_id) !== -1) {
            giftsInCart.push(cart.items[i]);
          }
        }
        if (giftsInCart.length === 0) continue;

        /* Evaluate condition */
        var conditionMet = false;
        var qualifyingCount = 0;
        var tagResult = { count: 0, spend: 0 };

        if (gift.condition === 'spend') {
          conditionMet = cartTotal >= gift.threshold;
        } else if (gift.condition === 'tag') {
          tagResult = gift.tag ? await countTagged(gift.tag) : tagResult;
          qualifyingCount = tagResult.count;
          conditionMet = qualifyingCount > 0;
        } else if (gift.condition === 'tag_and_spend') {
          tagResult = gift.tag ? await countTagged(gift.tag) : tagResult;
          qualifyingCount = tagResult.count;
          conditionMet = qualifyingCount > 0 && tagResult.spend >= gift.threshold;
        }

        if (!conditionMet) {
          /* Remove all gift items for this block */
          for (var g = 0; g < giftsInCart.length; g++) {
            await removeItem(giftsInCart[g].key);
          }
        } else if (gift.quantityMode === 'match_qualifying' && qualifyingCount > 0) {
          /* Enforce quantity cap */
          var totalGiftQty = 0;
          for (var g = 0; g < giftsInCart.length; g++) totalGiftQty += giftsInCart[g].quantity;
          if (totalGiftQty > qualifyingCount) {
            var remaining = qualifyingCount;
            for (var g = 0; g < giftsInCart.length; g++) {
              var newQty = Math.min(giftsInCart[g].quantity, remaining);
              if (newQty !== giftsInCart[g].quantity) {
                if (newQty === 0) await removeItem(giftsInCart[g].key);
                else await changeItem(giftsInCart[g].key, newQty);
              }
              remaining -= newQty;
            }
          }
        }
      }
    }

    /* Intercept ALL checkout links (delegated, catches any path to /checkout) */
    document.addEventListener('click', function(e) {
      var link = e.target.closest('a[href$="/checkout"], a[href="/checkout"]');
      if (!link) return;

      e.preventDefault();
      link.style.pointerEvents = 'none';
      link.style.opacity = '0.7';
      link.textContent = checkoutValidatingLabel;

      validateGifts()
        .catch(function() { /* always proceed */ })
        .then(function() { window.location.href = root + 'checkout'; });
    });
  })();

  /* ── Discount Code Block ── */
  (function() {
    const block = document.querySelector('[data-discount-block]');
    if (!block) return;

    const cartDs = document.querySelector('[data-cart-section]')?.dataset || {};
    const alreadyAppliedLabel = cartDs.discountAlreadyAppliedLabel || 'This code is already in your cart.';
    const invalidLabel = cartDs.discountInvalidLabel || "This code isn't active or doesn't apply to this order.";
    const applyFailedLabel = cartDs.discountApplyFailedLabel || "Couldn't apply code. Try again or refresh.";
    const removeDiscountLabel = cartDs.removeDiscountLabel || 'Remove discount';

    const rootUrl = window.Shopify?.routes?.root || '/';
    const input = block.querySelector('[data-discount-input]');
    const applyBtn = block.querySelector('[data-apply-discount]');
    const errorEl = block.querySelector('[data-discount-error]');
    const appliedContainer = block.querySelector('[data-applied-discounts]');

    if (!input || !applyBtn) return;

    function fmt(cents) {
      var ns = window.pigment;
      if (ns && ns.formatMoney) return ns.formatMoney(cents);
      return (cents / 100).toFixed(2);
    }

    function showError(msg) {
      if (errorEl) { errorEl.textContent = msg; errorEl.style.display = ''; }
    }

    function hideError() {
      if (errorEl) { errorEl.style.display = 'none'; errorEl.textContent = ''; }
    }

    function setLoading(on) {
      input.disabled = on;
      applyBtn.disabled = on || !input.value.trim();
    }

    function updateTotals(cart) {
      const discount = cart.total_discount || 0;
      document.querySelectorAll('[data-cart-subtotal]').forEach(el => {
        el.textContent = fmt(cart.original_total_price);
      });
      document.querySelectorAll('[data-cart-total]').forEach(el => {
        el.textContent = fmt(cart.total_price);
      });
      document.querySelectorAll('[data-cart-discount-row]').forEach(row => {
        row.style.display = discount > 0 ? '' : 'none';
      });
      document.querySelectorAll('[data-cart-discount]').forEach(el => {
        el.textContent = '-' + fmt(discount);
      });
    }

    function renderAppliedCode(code, amount) {
      if (!appliedContainer) return;
      appliedContainer.innerHTML = '';
      const pill = document.createElement('div');
      pill.className = 'flex items-center justify-between';
      pill.dataset.appliedDiscount = code;
      pill.innerHTML =
        '<div class="flex items-center gap-2 text-sm">'
        + '<span class="font-medium text-foreground">' + code + '</span>'
        + (amount > 0 ? '<span class="font-medium text-success">-' + fmt(amount) + '</span>' : '')
        + '</div>'
        + '<button type="button" class="text-muted-foreground transition-opacity hover:opacity-70 p-1" data-remove-discount aria-label="' + removeDiscountLabel + '">'
        + '<svg class="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
        + '</button>';
      appliedContainer.appendChild(pill);
      appliedContainer.style.display = '';
      pill.querySelector('[data-remove-discount]').addEventListener('click', handleRemove);
    }

    function clearApplied() {
      if (!appliedContainer) return;
      appliedContainer.innerHTML = '';
      appliedContainer.style.display = 'none';
    }

    async function handleApply() {
      const code = input.value.trim();
      if (!code) return;

      /* Check if already applied */
      const existing = appliedContainer?.querySelector('[data-applied-discount]');
      if (existing && existing.dataset.appliedDiscount === code.toUpperCase()) {
        showError(alreadyAppliedLabel);
        return;
      }

      hideError();
      setLoading(true);

      try {
        const beforeCart = await cartGetCart(true);
        const beforeDiscount = beforeCart.total_discount || 0;

        const res = await fetch(rootUrl + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: code }),
        });

        if (!res.ok) {
          showError(applyFailedLabel);
          setLoading(false);
          return;
        }

        const cart = await res.json();
        const afterDiscount = cart.total_discount || 0;

        if (afterDiscount > beforeDiscount) {
          const codeAmount = afterDiscount - beforeDiscount;
          renderAppliedCode(code.toUpperCase(), codeAmount);
          sessionStorage.setItem('discountCode', code.toUpperCase());
          input.value = '';
          updateTotals(cart);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        } else {
          showError(invalidLabel);
          /* Revert: restore previous discount (if any) to avoid storing an inapplicable code */
          const prevCode = existing ? existing.dataset.appliedDiscount : '';
          fetch(rootUrl + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: prevCode }),
          });
        }
      } catch (e) {
        showError(applyFailedLabel);
      } finally {
        setLoading(false);
      }
    }

    async function handleRemove() {
      setLoading(true);
      hideError();

      try {
        const res = await fetch(rootUrl + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: '' }),
        });

        if (!res.ok) throw new Error(applyFailedLabel);

        const cart = await res.json();
        clearApplied();
        sessionStorage.removeItem('discountCode');
        updateTotals(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      } catch (e) {
      } finally {
        setLoading(false);
      }
    }

    /* Enable/disable Apply button based on input content */
    function syncButtonState() {
      applyBtn.disabled = !input.value.trim();
    }
    input.addEventListener('input', syncButtonState);

    applyBtn.addEventListener('click', handleApply);
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') { e.preventDefault(); handleApply(); }
    });

    /* Restore any existing discount code on page load */
    (async function restoreDiscount() {
      try {
        const cart = await cartGetCart();
        if (cart.total_discount > 0) {
          const codeApp = (cart.cart_level_discount_applications || [])
            .find(d => d.type === 'discount_code');
          if (codeApp) {
            renderAppliedCode(codeApp.title, codeApp.total_allocated_amount);
          } else {
            const stored = sessionStorage.getItem('discountCode');
            if (stored) renderAppliedCode(stored, cart.total_discount);
          }
        } else {
          sessionStorage.removeItem('discountCode');
        }
      } catch (e) { /* silent */ }
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-collection-section]');
    sections.forEach(function (section) {
      var collectionUrl = section.getAttribute('data-collection-url') || '';

      // Description read-more / show-less toggle (scoped to this section)
      section.querySelectorAll('[data-collection-description]').forEach(function (container) {
        var content = container.querySelector('[data-description-content]');
        var toggle = container.querySelector('[data-description-toggle]');
        if (!content || !toggle) return;
        var collapsedHeight = container.dataset.collapsedHeight || '4.5em';
        var readMoreLabel = container.dataset.readMoreLabel || 'Read more';
        var showLessLabel = container.dataset.showLessLabel || 'Show less';
        var isExpanded = false;
        if (content.scrollHeight > content.clientHeight + 2) {
          toggle.classList.remove('hidden');
        }
        toggle.addEventListener('click', function () {
          isExpanded = !isExpanded;
          if (isExpanded) {
            content.style.maxHeight = content.scrollHeight + 'px';
            toggle.textContent = showLessLabel;
          } else {
            content.style.maxHeight = collapsedHeight;
            toggle.textContent = readMoreLabel;
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        });
      });

      // Replace inline `onchange="window.location.href = this.value"`:
      // delegated change listener for sort radios in the desktop sidebar.
      section.addEventListener('change', function (e) {
        var t = e.target;
        if (!(t instanceof HTMLInputElement)) return;
        if (t.matches('[data-sort-radio]')) {
          if (t.value) window.location.href = t.value;
          return;
        }
        // Replace inline `onchange="this.form.submit()"` for the desktop
        // filter checkboxes — only the desktop sidebar form auto-submits.
        if (t.matches('[data-filter-checkbox]') && t.form) {
          t.form.submit();
        }
      });

      // Mobile drawer filter form: build URL on submit (no inline script).
      var drawerForm = section.querySelector('#filter-drawer-form');
      if (drawerForm) {
        drawerForm.querySelectorAll('[data-filter-group="radio"]').forEach(function (group) {
          group.addEventListener('change', function (e) {
            if (!(e.target instanceof HTMLInputElement) || e.target.type !== 'radio') return;
            group.querySelectorAll('[data-filter-label]').forEach(function (label) {
              label.classList.remove('font-semibold');
              label.classList.add('font-normal');
            });
            var sel = e.target.closest('label');
            var selLabel = sel && sel.querySelector('[data-filter-label]');
            if (selLabel) {
              selLabel.classList.remove('font-normal');
              selLabel.classList.add('font-semibold');
            }
          });
        });

        drawerForm.querySelectorAll('[data-filter-group="checkbox"]').forEach(function (group) {
          group.addEventListener('change', function (e) {
            if (!(e.target instanceof HTMLInputElement) || e.target.type !== 'checkbox') return;
            var sel = e.target.closest('label');
            var label = sel && sel.querySelector('[data-filter-label]');
            if (!label) return;
            if (e.target.checked) {
              label.classList.remove('font-normal');
              label.classList.add('font-semibold');
            } else {
              label.classList.remove('font-semibold');
              label.classList.add('font-normal');
            }
          });
        });

        drawerForm.addEventListener('submit', function (e) {
          e.preventDefault();
          var fd = new FormData(drawerForm);
          var params = new URLSearchParams();
          var sortBy = fd.get('sort_by');
          if (sortBy) params.set('sort_by', sortBy);
          for (var entry of fd.entries()) {
            var key = entry[0];
            var value = entry[1];
            if (key !== 'sort_by' && value) params.append(key, value);
          }
          var qs = params.toString();
          window.location.href = collectionUrl + (qs ? '?' + qs : '');
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(slider) {
      if (slider.dataset.heroSliderBound === '1') return;
      slider.dataset.heroSliderBound = '1';

      const slides = slider.querySelectorAll('[data-slide]');
      const contents = slider.querySelectorAll('[data-hero-content]');
      const dots = slider.querySelectorAll('[data-slider-dot]');
      const progressBars = slider.querySelectorAll('[data-slider-progress]');
      const prevBtn = slider.querySelector('[data-slider-prev]');
      const nextBtn = slider.querySelector('[data-slider-next]');
      const pauseBtn = slider.querySelector('[data-slider-pause]');
      const interval = (parseInt(slider.dataset.autoplayInterval) || 8) * 1000;
      const slideDuration = parseInt(slider.dataset.slideDuration) || 700;
      const textFadeOffset = (parseInt(slider.dataset.textFadeOffset) || 40) / 100;

      const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      let prefersReducedMotion = reduceMotionQuery.matches;
    /* Save-Data / Network Information API: skip ken-burns and autoplay video
       on metered or constrained connections. We treat saveData OR a slow
       effective type as "lighten everything" so users on poor networks
       don't pay for hero animation work. */
      const conn = navigator.connection || navigator.webkitConnection || navigator.mozConnection;
      const saveData = !!(conn && (conn.saveData || /(2g|slow-2g)/.test(conn.effectiveType || '')));
    /* Pause autoplay videos when Save-Data is on. */
      if (saveData) {
      slider.querySelectorAll('video[autoplay]').forEach(function (v) {
        try { v.removeAttribute('autoplay'); v.pause(); } catch (e) {}
      });
    }

      let currentIndex = 0;
      let progressAnimation = null;
      let isPaused = false;
      let isTransitioning = false;
      let userPaused = false;

      function goToSlide(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      if (index === currentIndex || isTransitioning) return;

      isTransitioning = true;
      const prev = currentIndex;
      const outgoing = slides[prev];
      const incoming = slides[index];
      const outContent = contents[prev];
      const inContent = contents[index];

      // Fade out the outgoing text immediately
      if (outContent) outContent.style.opacity = '0';

      // Hide incoming text initially
      if (inContent) {
        inContent.style.transition = 'none';
        inContent.style.opacity = '0';
      }

      // Position incoming slide off-screen right, no transition
      outgoing.setAttribute('data-transitioning', '');
      incoming.setAttribute('data-transitioning', '');
      incoming.style.transition = 'none';
      incoming.style.transform = 'translateX(100%)';
      incoming.style.zIndex = '2';
      incoming.setAttribute('aria-hidden', 'false');
      outgoing.style.zIndex = '1';

      // Force reflow
      incoming.offsetWidth;

      // Animate both: outgoing slides left, incoming slides in from right
      outgoing.style.transition = 'transform ' + slideDuration + 'ms ease-in-out';
      outgoing.style.transform = 'translateX(-100%)';
      incoming.style.transition = 'transform ' + slideDuration + 'ms ease-in-out';
      incoming.style.transform = 'translateX(0)';

      // Fade in the incoming text after a short delay
      setTimeout(() => {
        if (inContent) {
          inContent.style.transition = 'opacity 400ms ease';
          inContent.style.opacity = '1';
        }
      }, slideDuration * textFadeOffset);

      // After slide transition completes, clean up
      setTimeout(() => {
        outgoing.style.transition = 'none';
        outgoing.style.transform = 'translateX(100%)';
        outgoing.style.zIndex = '';
        outgoing.setAttribute('aria-hidden', 'true');
        outgoing.removeAttribute('data-transitioning');
        incoming.removeAttribute('data-transitioning');
        incoming.style.zIndex = '';
        isTransitioning = false;
      }, slideDuration);

      // Update dots
      dots.forEach((dot, i) => {
        dot.setAttribute('aria-selected', i === index);
      });

      // Reset progress bars
      progressBars.forEach((bar, i) => {
        if (i !== index) {
          bar.style.transition = 'none';
          bar.style.transform = 'scaleX(0)';
        }
      });

      currentIndex = index;
      startProgress();
    }

      function startProgress() {
      cancelProgress();
      if (slides.length <= 1) return;
      if (prefersReducedMotion || userPaused) return;

      const bar = progressBars[currentIndex];
      bar.style.transition = 'none';
      bar.style.transform = 'scaleX(0)';

      bar.offsetWidth;

      bar.style.transition = 'transform ' + interval + 'ms linear';
      bar.style.transform = 'scaleX(1)';

      progressAnimation = setTimeout(() => {
        goToSlide(currentIndex + 1);
      }, interval);
    }

      function cancelProgress() {
      if (progressAnimation) {
        clearTimeout(progressAnimation);
        progressAnimation = null;
      }
    }

      function pause() {
      if (isPaused) return;
      isPaused = true;
      cancelProgress();

      const bar = progressBars[currentIndex];
      const computed = getComputedStyle(bar).transform;
      bar.style.transition = 'none';
      bar.style.transform = computed;
    }

      function resume() {
      if (!isPaused) return;
      isPaused = false;

      if (slides.length <= 1) return;

      const bar = progressBars[currentIndex];
      const matrix = new DOMMatrix(getComputedStyle(bar).transform);
      const currentScale = matrix.a;
      const remaining = interval * (1 - currentScale);

      bar.style.transition = 'transform ' + remaining + 'ms linear';
      bar.style.transform = 'scaleX(1)';

      progressAnimation = setTimeout(() => {
        goToSlide(currentIndex + 1);
      }, remaining);
    }

      function manualNav(index) {
      isPaused = false;
      cancelProgress();
      goToSlide(index);
    }

    prevBtn?.addEventListener('click', () => manualNav(currentIndex - 1));
    nextBtn?.addEventListener('click', () => manualNav(currentIndex + 1));

    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        manualNav(parseInt(dot.dataset.sliderDot));
      });
    });

    // Touch/swipe support
    let touchStartX = 0;

    slider.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
      pause();
    }, { passive: true });

    slider.addEventListener('touchend', (e) => {
      const diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 50) {
        manualNav(currentIndex + (diff > 0 ? 1 : -1));
      } else {
        resume();
      }
    }, { passive: true });

    // Pause on hover
    slider.addEventListener('mouseenter', pause);
    slider.addEventListener('mouseleave', () => { if (!userPaused) resume(); });

    // Pause on keyboard focus inside the slider
    slider.addEventListener('focusin', pause);
    slider.addEventListener('focusout', (e) => {
      if (!slider.contains(e.relatedTarget) && !userPaused) {
        resume();
      }
    });

    // Pause when not visible
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        pause();
      } else if (!userPaused) {
        resume();
      }
    });

    // User pause/play toggle (visible Pause button)
    if (pauseBtn) {
      const iconPause = pauseBtn.querySelector('[data-icon-pause]');
      const iconPlay = pauseBtn.querySelector('[data-icon-play]');
      pauseBtn.addEventListener('click', () => {
        userPaused = !userPaused;
        pauseBtn.setAttribute('aria-pressed', String(userPaused));
        if (userPaused) {
          pause();
          if (iconPause) iconPause.classList.add('hidden');
          if (iconPlay) iconPlay.classList.remove('hidden');
        } else {
          if (iconPause) iconPause.classList.remove('hidden');
          if (iconPlay) iconPlay.classList.add('hidden');
          resume();
        }
      });
    }

    // Respect prefers-reduced-motion changes at runtime
    reduceMotionQuery.addEventListener('change', (e) => {
      prefersReducedMotion = e.matches;
      if (prefersReducedMotion) {
        cancelProgress();
      } else if (!userPaused) {
        startProgress();
      }
    });
      startProgress();
    }

    // Defer init behind IntersectionObserver: heroes below the LCP fold
    // (e.g. on mobile when the slider isn't actually visible) shouldn't
    // schedule timers on every page just in case.
    document.querySelectorAll('[data-hero-slider]').forEach(function (slider) {
      if (!('IntersectionObserver' in window)) {
        init(slider);
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            io.disconnect();
            init(slider);
          }
        });
      }, { rootMargin: '200px' });
      io.observe(slider);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-password-countdown]').forEach(function (container) {
      var target = new Date(container.dataset.target).getTime();
      var hoursEl = container.querySelector('[data-countdown-hours]');
      var hoursWrap = container.querySelector('[data-countdown-hours-wrap]');
      var hoursLabel = container.querySelector('[data-countdown-hours-label]');
      var minutesEl = container.querySelector('[data-countdown-minutes]');
      var textEl = container.querySelector('[data-countdown-text]');
      var expiredEl = container.querySelector('[data-countdown-expired]');
      var stopped = false;

      function tick() {
        if (stopped) return;
        var diff = target - Date.now();
        if (diff <= 0) {
          if (textEl) textEl.classList.add('hidden');
          if (expiredEl) expiredEl.classList.remove('hidden');
          stopped = true;
          return;
        }
        var hours = Math.floor(diff / 3600000);
        var minutes = Math.floor((diff % 3600000) / 60000);
        if (hours > 0) {
          if (hoursWrap) hoursWrap.classList.remove('hidden');
          if (hoursEl) hoursEl.textContent = hours;
          if (hoursLabel) hoursLabel.textContent = hours === 1 ? 'hour' : 'hours';
        } else if (hoursWrap) {
          hoursWrap.classList.add('hidden');
        }
        if (minutesEl) minutesEl.textContent = minutes;
        if (window.pigment && window.pigment.isHidden && window.pigment.isHidden()) return;
        setTimeout(tick, 1000 - (Date.now() % 1000));
      }

      if (window.pigment && window.pigment.onVisibility) {
        window.pigment.onVisibility(function (hidden) {
          if (!hidden && !stopped) tick();
        });
      }
      tick();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('[data-product-information]');
    if (!section) return;
    if (section.dataset.productInfoBound === '1') return;
    section.dataset.productInfoBound = '1';

    var addToCartLabel = section.dataset.addToCartLabel || 'Add to cart';
    var soldOutLabel = section.dataset.soldOutLabel || 'Sold out';
    var saleLabel = section.dataset.saleLabel || 'Sale';
    var allStockInCartLabel = section.dataset.allStockInCartLabel || 'All stock in cart';
    var notifyBackInStockLabel = section.dataset.notifyBackInStockLabel || 'Notify when back in stock';
    var fromPriceLabel = section.dataset.fromPriceLabel || 'From __PRICE__';
    var readMoreLabel = section.dataset.readMoreLabel || 'Read more';
    var showLessLabel = section.dataset.showLessLabel || 'Show less';

    const productJson = JSON.parse(section.querySelector('[data-product-json]').textContent);
    const form = document.querySelector('#product-form');
    const variantInput = form.querySelector('[data-variant-id]');

    /* Nullable element references — blocks may be absent */
    const mainImage = section.querySelector('#product-main-image');
    const mainVideo = section.querySelector('[data-main-video]');
    const thumbnails = section.querySelectorAll('[data-thumbnail]');
    const optionSelectors = section.querySelectorAll('[data-option-selector]');
    const addToCartBtn = form.querySelector('[data-add-to-cart]');
    const priceContainer = section.querySelector('[data-price-container]');
    const volumeDiscountEl = section.querySelector('[data-volume-discount]');
    const inCartLabel = section.querySelector('[data-in-cart-label]');
    const countdownBlock = section.querySelector('[data-delivery-countdown-block]');
    const productBadge = section.querySelector('[data-product-badge]');
    const qtyInput = form.querySelector('[data-quantity-input]');
    const qtyPlusBtn = form.querySelector('[data-quantity-plus]');

    /* ── Cart quantity tracking ──
       stock_max is now folded into each variant in the slim product payload
       above, so look it up via productJson.variants instead of a separate map. */
    function getStockMax(vid) {
      var v = productJson.variants.find(function(x) { return String(x.id) === String(vid); });
      return v ? v.stock_max : 0;
    }
    let cartQuantities = {};

    function applyCartPayload(cart) {
      cartQuantities = {};
      if (!cart || !cart.items) return;
      cart.items.forEach(function (ci) {
        var vid = String(ci.variant_id);
        cartQuantities[vid] = (cartQuantities[vid] || 0) + ci.quantity;
      });
    }

    function fetchCartQuantities() {
      var ns = window.pigment;
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var p = ns && ns.cart
        ? ns.cart.get()
        : fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      return p.then(applyCartPayload).catch(function () { cartQuantities = {}; });
    }

    function updateInCartState() {
      var vid = String(variantInput.value);
      var cartQty = cartQuantities[vid] || 0;
      var stockMax = getStockMax(vid);
      var hasLimit = typeof stockMax === 'number' && stockMax > 0;

      /* Update in-cart label */
      if (inCartLabel) {
        if (cartQty > 0) {
          inCartLabel.textContent = cartQty + ' in cart';
          inCartLabel.style.display = '';
        } else {
          inCartLabel.style.display = 'none';
        }
      }

      /* Update quantity input max and button states */
      if (qtyInput) {
        var qtyMinusBtn = form.querySelector('[data-quantity-minus]');
        if (hasLimit) {
          var remaining = Math.max(0, stockMax - cartQty);
          qtyInput.max = remaining;
          if (remaining === 0) {
            qtyInput.value = 0;
            if (qtyPlusBtn) qtyPlusBtn.disabled = true;
            if (qtyMinusBtn) qtyMinusBtn.disabled = true;
          } else {
            var val = parseInt(qtyInput.value) || 0;
            if (val > remaining) qtyInput.value = remaining;
            if (val < 1) qtyInput.value = 1;
            var newVal = parseInt(qtyInput.value);
            if (qtyPlusBtn) qtyPlusBtn.disabled = newVal >= remaining;
            if (qtyMinusBtn) qtyMinusBtn.disabled = newVal <= 1;
          }
        } else {
          qtyInput.max = 99;
          var val = parseInt(qtyInput.value) || 1;
          if (qtyPlusBtn) qtyPlusBtn.disabled = val >= 99;
          if (qtyMinusBtn) qtyMinusBtn.disabled = val <= 1;
        }
      }

      /* Disable add-to-cart when no remaining stock.
         `isSoldOut` is selected-variant level — drives the add-to-cart CTA
         (so a sold-out variant can still flip the button to "Notify back
         in stock"). `isProductSoldOut` is product-level — drives the badge
         and the delivery countdown, which should only disappear when the
         whole product is unavailable, not just the current selection. */
      var variant = productJson.variants.find(function(v) { return String(v.id) === vid; });
      var variantAvailable = variant ? variant.available : false;
      var isSoldOut = !variantAvailable;
      var isProductSoldOut = !productJson.variants.some(function(v) { return v.available; });

      if (addToCartBtn) {
        var btnTextEl = addToCartBtn.querySelector('[data-btn-text]');
        if (hasLimit && Math.max(0, stockMax - cartQty) === 0) {
          addToCartBtn.disabled = true;
          addToCartBtn.removeAttribute('data-back-in-stock');
          addToCartBtn.classList.remove('bg-foreground', 'text-background', 'hover:bg-foreground/90');
          addToCartBtn.classList.add('bg-primary', 'text-primary-foreground', 'hover:bg-primary/90');
          if (btnTextEl) btnTextEl.textContent = allStockInCartLabel;
        } else if (isSoldOut) {
          addToCartBtn.disabled = false;
          addToCartBtn.setAttribute('data-back-in-stock', '');
          addToCartBtn.setAttribute('data-product-id', variant.product_id || productJson.id);
          addToCartBtn.setAttribute('data-product-url', productJson.url);
          addToCartBtn.setAttribute('data-variant-id', variant.id);
          addToCartBtn.setAttribute('data-variant-price', variant.price);
          addToCartBtn.classList.remove('bg-primary', 'text-primary-foreground', 'hover:bg-primary/90');
          addToCartBtn.classList.add('bg-foreground', 'text-background', 'hover:bg-foreground/90');
          if (btnTextEl) btnTextEl.textContent = notifyBackInStockLabel;
        } else {
          addToCartBtn.disabled = false;
          addToCartBtn.removeAttribute('data-back-in-stock');
          addToCartBtn.classList.remove('bg-foreground', 'text-background', 'hover:bg-foreground/90');
          addToCartBtn.classList.add('bg-primary', 'text-primary-foreground', 'hover:bg-primary/90');
          if (btnTextEl) btnTextEl.textContent = addToCartLabel;
        }
      }

      /* Hide delivery countdown only when every variant is sold out. */
      if (countdownBlock) {
        countdownBlock.style.display = isProductSoldOut ? 'none' : '';
      }

      /* Update product badge — toggle .hidden (Tailwind) instead of the
         inline display style we removed when migrating the wrapper to
         utility classes. Sold-out badge reflects product-level state. */
      if (productBadge) {
        var onSale = variant && variant.compare_at_price && variant.compare_at_price > variant.price;
        if (isProductSoldOut) {
          productBadge.innerHTML = '<span class="inline-flex items-center font-medium whitespace-nowrap bg-muted-foreground text-primary-foreground text-base px-3.5 py-1.5">' + soldOutLabel + '</span>';
          productBadge.classList.remove('hidden');
        } else if (onSale) {
          productBadge.innerHTML = '<span class="inline-flex items-center font-medium whitespace-nowrap bg-sale text-sale-foreground text-base px-3.5 py-1.5">' + saleLabel + '</span>';
          productBadge.classList.remove('hidden');
        } else {
          productBadge.classList.add('hidden');
        }
      }
    }

    /* Subscribe to the shared cart store so this component re-renders on
       any cart change without firing its own /cart.js fetch — the store
       coalesces fetches across cart-notification, main-cart and product-table. */
    if (window.pigment && window.pigment.cart) {
      window.pigment.cart.subscribe(function (cart) {
        applyCartPayload(cart);
        updateInCartState();
      });
      // Initial paint: trigger one shared fetch (will be deduped if any
      // other consumer already fired it within the coalesce window).
      window.pigment.cart.get().then(applyCartPayload).then(updateInCartState);
    } else {
      fetchCartQuantities().then(updateInCartState);
    }

    /* ── Variant Selection ── */
    let selectedOptions = productJson.options.map((_, i) => {
      const selector = section.querySelector(`[data-option-index="${i}"]`);
      if (!selector) return productJson.variants[0][`option${i + 1}`];
      const selected = selector.querySelector('.border-foreground, .border-primary');
      return selected?.dataset.optionValue || productJson.variants[0][`option${i + 1}`];
    });

    optionSelectors.forEach(selector => {
      const buttons = selector.querySelectorAll('[data-option-value]');
      const optionIndex = parseInt(selector.dataset.optionIndex);

      buttons.forEach(btn => {
        btn.addEventListener('click', () => {
          selectedOptions[optionIndex] = btn.dataset.optionValue;

          /* Update button styles */
          buttons.forEach(b => {
            const isSelected = b === btn;
            if (b.style.backgroundColor) {
              /* Colour swatch */
              b.classList.toggle('border-foreground', isSelected);
              b.classList.toggle('ring-2', isSelected);
              b.classList.toggle('ring-foreground', isSelected);
              b.classList.toggle('ring-offset-2', isSelected);
              b.classList.toggle('border-border', !isSelected);
            } else {
              /* Standard button */
              b.classList.toggle('border-primary', isSelected);
              b.classList.toggle('text-primary', isSelected);
              b.classList.toggle('outline-primary', isSelected);
              b.classList.toggle('border-border', !isSelected);
              b.classList.toggle('text-foreground', !isSelected);
              b.classList.toggle('outline-transparent', !isSelected);
            }
          });

          /* Update selected option label */
          const optionName = productJson.options[optionIndex];
          const labelSpan = section.querySelector(`[data-selected-option="${optionName}"]`);
          if (labelSpan) {
            labelSpan.textContent = btn.dataset.optionValue;
          }

          /* Find matching variant */
          const variant = productJson.variants.find(v => {
            return selectedOptions.every((opt, i) => v[`option${i + 1}`] === opt);
          });

          if (variant) {
            updateVariant(variant);
          }
        });
      });
    });

    function updateVariant(variant) {
      /* Update hidden input */
      variantInput.value = variant.id;

      /* Update URL */
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      /* Update price (if price block exists). We toggle .hidden on the
         pre-rendered spans rather than innerHTML-replacing the container,
         so the container's height stays constant across every variant
         change — eliminating the per-click CLS that the previous
         innerHTML rewrite produced. */
      if (priceContainer) {
        const volumeDecrease = parseInt(priceContainer.dataset.volumeDecrease) || 0;
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        const fromEl = priceContainer.querySelector('[data-price-from]');
        const currentEl = priceContainer.querySelector('[data-price-current]');
        const compareEl = priceContainer.querySelector('[data-price-compare]');
        if (volumeDecrease > 0) {
          if (fromEl) {
            fromEl.textContent = fromPriceLabel.replace('__PRICE__', formatMoney(variant.price - volumeDecrease));
            fromEl.classList.remove('hidden');
          }
          if (currentEl) currentEl.classList.add('hidden');
          if (compareEl) compareEl.classList.add('hidden');
        } else if (onSale) {
          if (fromEl) fromEl.classList.add('hidden');
          if (currentEl) {
            currentEl.textContent = formatMoney(variant.price);
            currentEl.classList.remove('hidden');
          }
          if (compareEl) {
            compareEl.textContent = formatMoney(variant.compare_at_price);
            compareEl.classList.remove('hidden');
          }
        } else {
          if (fromEl) fromEl.classList.add('hidden');
          if (currentEl) {
            currentEl.textContent = formatMoney(variant.price);
            currentEl.classList.remove('hidden');
          }
          if (compareEl) compareEl.classList.add('hidden');
        }
      }

      /* Update image if variant has image */
      if (variant.featured_image && mainImage) {
        showImage(variant.featured_image.src, '', variant.featured_image.alt || productJson.title);
      }

      /* Update volume discount prices (if block exists) */
      if (volumeDiscountEl) {
        updateVolumeDiscountPrices(variant);
      }

      /* Reset quantity to 1 and update in-cart state for new variant */
      if (qtyInput) {
        qtyInput.value = parseInt(qtyInput.min) || 1;
      }
      updateInCartState();
    }

    function updateVolumeDiscountPrices(variant) {
      const basePriceEl = volumeDiscountEl.querySelector('[data-volume-base-price]');
      if (basePriceEl) {
        basePriceEl.textContent = formatMoney(variant.price);
      }

      const table = volumeDiscountEl.querySelector('table');
      if (!table || !table.dataset.volumeDecreases) return;

      try {
        const decreases = JSON.parse(table.dataset.volumeDecreases);
        decreases.forEach((decrease, i) => {
          const cell = volumeDiscountEl.querySelector(`[data-volume-price="${i + 1}"]`);
          if (cell && decrease > 0) {
            cell.textContent = formatMoney(variant.price - decrease);
          }
        });
      } catch (e) {
        /* Silently ignore JSON parse errors */
      }
    }

    function formatMoney(cents) {
      var ns = window.pigment;
      if (ns && ns.formatMoney) return ns.formatMoney(cents);
      return (cents / 100).toFixed(2);
    }

    /* ── Media Helpers ── */
    function stopVideo() {
      if (!mainVideo) return;
      mainVideo.innerHTML = '';
      mainVideo.classList.add('hidden');
    }

    var GALLERY_WIDTHS = [480, 640, 768, 900, 1024, 1200, 1500];

    function buildGalleryUrls(base) {
      try {
        var src = '';
        var srcset = [];
        for (var i = 0; i < GALLERY_WIDTHS.length; i++) {
          var w = GALLERY_WIDTHS[i];
          var u = new URL(base, window.location.href);
          u.searchParams.set('width', String(w));
          var href = u.toString();
          srcset.push(href + ' ' + w + 'w');
          if (w === 1500) src = href;
        }
        return { src: src, srcset: srcset.join(', ') };
      } catch (e) {
        return { src: base, srcset: '' };
      }
    }

    function showImage(base, alt) {
      if (!mainImage) return;
      stopVideo();
      var built = buildGalleryUrls(base);
      mainImage.src = built.src;
      if (built.srcset) mainImage.srcset = built.srcset;
      mainImage.alt = alt || '';
      mainImage.classList.remove('hidden');
    }

    function showHostedVideo(sourcesJson) {
      if (!mainVideo || !mainImage) return;
      mainImage.classList.add('hidden');
      try {
        const sources = JSON.parse(sourcesJson);
        const video = document.createElement('video');
        video.controls = true;
        video.muted = true;
        video.playsInline = true;
        video.className = 'h-full w-full object-cover';
        sources.forEach(s => {
          const source = document.createElement('source');
          source.src = s.url;
          source.type = s.mime_type;
          video.appendChild(source);
        });
        mainVideo.innerHTML = '';
        mainVideo.appendChild(video);
        mainVideo.classList.remove('hidden');
      } catch (e) { /* ignore parse errors */ }
    }

    function showExternalVideo(url) {
      if (!mainVideo || !mainImage) return;
      mainImage.classList.add('hidden');
      const iframe = document.createElement('iframe');
      iframe.src = url;
      iframe.className = 'h-full w-full';
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('allow', 'autoplay; encrypted-media');
      mainVideo.innerHTML = '';
      mainVideo.appendChild(iframe);
      mainVideo.classList.remove('hidden');
    }

    /* ── Gallery image warming ──
       Only the first gallery image is loaded eagerly; clicking a thumbnail
       triggers a cold fetch of the full-size variant, which is what makes
       the swap feel slow. Warm the rest in two passes:
         1) on browser idle after page load — bulk background fetch at low
            priority, skipped on save-data or 2g.
         2) on pointerenter / touchstart of each thumbnail — guarantees the
            image is in flight by the time the click handler fires, even if
            idle warming hasn't reached this one yet.
       Uses the same srcset + sizes as the displayed main image so the
       browser picks the URL it would actually need. */
    var MAIN_IMAGE_SIZES = '(min-width: 1024px) 50vw, 100vw';
    var warmedImageBases = new Set();

    function warmGalleryImage(base) {
      if (!base || warmedImageBases.has(base)) return;
      warmedImageBases.add(base);
      var built = buildGalleryUrls(base);
      var img = new Image();
      img.decoding = 'async';
      img.sizes = MAIN_IMAGE_SIZES;
      if (built.srcset) img.srcset = built.srcset;
      img.src = built.src;
    }

    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    var saveData = !!(conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')));

    if (!saveData) {
      var scheduleIdle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 1); };
      scheduleIdle(function () {
        thumbnails.forEach(function (thumb) {
          if (thumb.dataset.mediaType !== 'image') return;
          warmGalleryImage(thumb.dataset.imageBase);
        });
      }, { timeout: 2000 });
    }

    /* ── Thumbnail Gallery ── */
    thumbnails.forEach(thumb => {
      if (thumb.dataset.mediaType === 'image' && thumb.dataset.imageBase) {
        var warmThis = function () { warmGalleryImage(thumb.dataset.imageBase); };
        thumb.addEventListener('pointerenter', warmThis, { once: true, passive: true });
        thumb.addEventListener('touchstart', warmThis, { once: true, passive: true });
      }

      thumb.addEventListener('click', () => {
        const mediaType = thumb.dataset.mediaType || 'image';

        if (mediaType === 'image') {
          showImage(thumb.dataset.imageBase, thumb.dataset.imageAlt);
        } else if (mediaType === 'video') {
          showHostedVideo(thumb.dataset.videoSources);
        } else if (mediaType === 'external_video') {
          showExternalVideo(thumb.dataset.videoUrl);
        }

        thumbnails.forEach(t => {
          t.classList.toggle('outline-foreground', t === thumb);
          t.classList.toggle('outline-transparent', t !== thumb);
        });
      });
    });

    /* Add to Cart is handled by the global cart-notification snippet
       (snippets/cart-notification.liquid) which intercepts all form submits
       matching #product-form or action="/cart/add". After a successful add it
       dispatches 'cart:updated' which propagates through the shared cart
       store subscription above. */

    /* ── scroll-to-reviews button (was a separate inline script — now
          scoped to this section's DOM with querySelectorAll) ── */
    section.querySelectorAll('[data-scroll-to-reviews]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var reviews = document.querySelector('[data-product-reviews]');
        if (reviews) reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    /* ── view-table button (jumps to the product-table on table-template
          products — same scoping fix as scroll-to-reviews) ── */
    section.querySelectorAll('[data-view-table-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var table = document.querySelector('[data-variant-table-container]');
        if (table) table.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    /* ── Promotions accordion: auto-open on desktop, collapse on mobile ── */
    section.querySelectorAll('[data-promotions-details]').forEach(function (details) {
      var mql = window.matchMedia('(min-width: 1024px)');
      function handleViewport(e) {
        if (e.matches) details.setAttribute('open', '');
        else details.removeAttribute('open');
      }
      handleViewport(mql);
      mql.addEventListener('change', handleViewport);
    });

    /* ── Description read-more toggle (mobile + desktop instances) ── */
    section.querySelectorAll('[data-product-description], [data-product-description-mobile]').forEach(function (container) {
      var content = container.querySelector('[data-description-content]');
      var toggle = container.querySelector('[data-description-toggle]');
      if (!content || !toggle || container.dataset.toggleInit) return;
      container.dataset.toggleInit = 'true';
      var isExpanded = false;
      function checkOverflow() {
        if (getComputedStyle(container).display === 'none') return;
        if (isExpanded) return;
        if (content.scrollHeight > content.clientHeight + 2) {
          toggle.classList.remove('hidden');
        } else {
          toggle.classList.add('hidden');
        }
      }
      /* Initial check runs synchronously, but Safari often measures before
         web fonts swap in — the post-swap reflow changes scrollHeight and
         the button would stay hidden until the next resize. Re-check after
         fonts load, on window load, and via ResizeObserver on the content. */
      checkOverflow();
      if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
        document.fonts.ready.then(checkOverflow);
      }
      if (document.readyState !== 'complete') {
        window.addEventListener('load', checkOverflow, { once: true });
      }
      if (typeof ResizeObserver === 'function') {
        new ResizeObserver(checkOverflow).observe(content);
      }
      toggle.addEventListener('click', function () {
        isExpanded = !isExpanded;
        if (isExpanded) {
          content.classList.remove('line-clamp-6');
          toggle.textContent = showLessLabel;
        } else {
          content.classList.add('line-clamp-6');
          toggle.textContent = readMoreLabel;
          container.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
      window.addEventListener('resize', checkOverflow, { passive: true });
    });
  })();

  /* ──────────────────────────────────────────────────────────────────
     Pack-contents carousel module. Was inline (~280 lines) per pack-
     contents block; now bound from the section bundle. Adds
     IntersectionObserver-based pause when off-screen and a document
     visibility pause so the auto-scroll RAF tick stops while the user
     is on another tab — neither was true in the inline version.
     ────────────────────────────────────────────────────────────────── */
  (function () {
    function init(el) {
      if (el.dataset.packContentsBound === '1') return;
      el.dataset.packContentsBound = '1';

      var container = el.querySelector('[data-pack-scroll-container]');
      var track = el.querySelector('[data-pack-track]');
      var leftBtn = el.querySelector('[data-pack-scroll-left]');
      var rightBtn = el.querySelector('[data-pack-scroll-right]');
      if (!container || !track || !leftBtn || !rightBtn) return;

      var originals = Array.prototype.slice.call(track.querySelectorAll('[data-pack-original]'));
      if (originals.length === 0) return;
      var gap = 8;

      if (originals[0].offsetWidth === 0) {
        requestAnimationFrame(function () { init(el); });
        return;
      }

      var canScroll = false;
      var offset = 0;
      var setWidth = 0;

      (function setupClones() {
        var totalWidth = 0;
        originals.forEach(function (item) { totalWidth += item.offsetWidth + gap; });
        if (totalWidth <= container.offsetWidth) return;
        canScroll = true;
        for (var round = 0; round < 2; round++) {
          originals.forEach(function (item) {
            var clone = item.cloneNode(true);
            clone.removeAttribute('data-pack-original');
            clone.setAttribute('aria-hidden', 'true');
            track.appendChild(clone);
          });
        }
        var last = originals[originals.length - 1];
        setWidth = last.offsetLeft + last.offsetWidth + gap - originals[0].offsetLeft;
      })();

      function getScrollAmount() { return originals[0].offsetWidth + gap; }
      function wrapOffset() {
        if (!canScroll || setWidth <= 0) return;
        offset = ((offset % setWidth) + setWidth) % setWidth;
      }
      function applyTransform() {
        track.style.transform = 'translate3d(' + (-offset) + 'px,0,0)';
      }

      var scrollRaf = null;
      var animating = false;
      function smoothScrollBy(amount) {
        if (scrollRaf) { cancelAnimationFrame(scrollRaf); scrollRaf = null; }
        animating = true;
        var start = offset;
        var startTime = 0;
        function step(ts) {
          if (!startTime) startTime = ts;
          var t = Math.min((ts - startTime) / 300, 1);
          var ease = 1 - Math.pow(1 - t, 3);
          offset = start + amount * ease;
          wrapOffset();
          applyTransform();
          if (t < 1) scrollRaf = requestAnimationFrame(step);
          else { scrollRaf = null; animating = false; }
        }
        scrollRaf = requestAnimationFrame(step);
      }

      leftBtn.addEventListener('click', function () { pauseAuto(); smoothScrollBy(-getScrollAmount()); });
      rightBtn.addEventListener('click', function () { pauseAuto(); smoothScrollBy(getScrollAmount()); });

      var touchStartX = 0, touchStartY = 0, touchStartOffset = 0;
      var isDragging = false, dirLocked = false, isHoriz = false, hasDragged = false;
      var lastTouchX = 0, lastTouchTime = 0, velocity = 0;
      var momentumRaf = null;

      container.addEventListener('touchstart', function (e) {
        pauseAuto();
        if (scrollRaf) { cancelAnimationFrame(scrollRaf); scrollRaf = null; animating = false; }
        if (momentumRaf) { cancelAnimationFrame(momentumRaf); momentumRaf = null; }
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchStartOffset = offset;
        isDragging = true; dirLocked = false; isHoriz = false; hasDragged = false;
        lastTouchX = touchStartX;
        lastTouchTime = Date.now();
        velocity = 0;
      }, { passive: true });

      container.addEventListener('touchmove', function (e) {
        if (!isDragging || !canScroll) return;
        var x = e.touches[0].clientX;
        var y = e.touches[0].clientY;
        if (!dirLocked) {
          var dx = Math.abs(touchStartX - x);
          var dy = Math.abs(touchStartY - y);
          if (dx > 5 || dy > 5) { dirLocked = true; isHoriz = dx > dy; }
        }
        if (!isHoriz) return;
        e.preventDefault();
        hasDragged = true;
        var now = Date.now();
        var dt = now - lastTouchTime;
        if (dt > 0) velocity = (lastTouchX - x) / dt;
        lastTouchX = x; lastTouchTime = now;
        offset = touchStartOffset + (touchStartX - x);
        wrapOffset();
        applyTransform();
      }, { passive: false });

      container.addEventListener('touchend', function () {
        isDragging = false;
        if (!isHoriz || !canScroll) return;
        var friction = 0.95;
        function momentumStep() {
          velocity *= friction;
          if (Math.abs(velocity) < 0.01) { momentumRaf = null; return; }
          offset += velocity * 16;
          wrapOffset();
          applyTransform();
          momentumRaf = requestAnimationFrame(momentumStep);
        }
        if (Math.abs(velocity) > 0.1) momentumRaf = requestAnimationFrame(momentumStep);
      }, { passive: true });

      track.addEventListener('click', function (e) {
        if (hasDragged) { e.preventDefault(); hasDragged = false; }
      });

      var mouseStartX = 0, mouseStartOffset = 0, isMouseDrag = false, mouseMoved = false;
      container.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        pauseAuto();
        if (scrollRaf) { cancelAnimationFrame(scrollRaf); scrollRaf = null; animating = false; }
        mouseStartX = e.clientX;
        mouseStartOffset = offset;
        isMouseDrag = true;
        mouseMoved = false;
        container.style.cursor = 'grabbing';
        e.preventDefault();
      });
      document.addEventListener('mousemove', function (e) {
        if (!isMouseDrag || !canScroll) return;
        var dx = mouseStartX - e.clientX;
        if (Math.abs(dx) > 3) mouseMoved = true;
        offset = mouseStartOffset + dx;
        wrapOffset();
        applyTransform();
      });
      document.addEventListener('mouseup', function () {
        if (!isMouseDrag) return;
        isMouseDrag = false;
        container.style.cursor = '';
        if (mouseMoved) {
          hasDragged = true;
          setTimeout(function () { hasDragged = false; }, 0);
        }
      });

      container.addEventListener('wheel', function (e) {
        if (!canScroll) return;
        pauseAuto();
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && e.deltaX !== 0) {
          e.preventDefault();
          offset += e.deltaX;
          wrapOffset();
          applyTransform();
        }
      }, { passive: false });

      var rafId = null;
      var pauseTimer = null;
      var userPaused = false;
      var inViewport = true;
      var lastTime = 0;
      var SPEED = 0.5;

      function tick(ts) {
        if (!userPaused && canScroll && inViewport && !animating && !isDragging && !isMouseDrag) {
          if (lastTime) {
            offset += SPEED * ((ts - lastTime) / 16.67);
            wrapOffset();
            applyTransform();
          }
          lastTime = ts;
        } else {
          lastTime = 0;
        }
        rafId = requestAnimationFrame(tick);
      }
      function startAuto() {
        if (!canScroll || rafId) return;
        if (window.pigment && window.pigment.isHidden && window.pigment.isHidden()) return;
        lastTime = 0;
        rafId = requestAnimationFrame(tick);
      }
      function stopAuto() {
        if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
        lastTime = 0;
      }
      function pauseAuto() {
        userPaused = true;
        clearTimeout(pauseTimer);
        pauseTimer = setTimeout(function () { userPaused = false; }, 4000);
      }

      // Pause when the carousel scrolls off-screen so the RAF loop doesn't
      // run for the lifetime of the page on hidden product pages.
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            inViewport = entry.isIntersecting;
            if (!inViewport) stopAuto();
            else startAuto();
          });
        }, { rootMargin: '100px' });
        io.observe(el);
      }

      if (window.pigment && window.pigment.onVisibility) {
        window.pigment.onVisibility(function (hidden) {
          if (hidden) stopAuto();
          else if (inViewport) startAuto();
        });
      } else {
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) stopAuto();
          else if (inViewport) startAuto();
        });
      }

      startAuto();
      applyTransform();
    }

    function discover() {
      document.querySelectorAll('[data-pack-contents]').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        requestAnimationFrame(function () { requestAnimationFrame(discover); });
      });
    } else {
      requestAnimationFrame(function () { requestAnimationFrame(discover); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-search-page-input]').forEach(function (input) {
      var clearBtn = input.parentElement
        ? input.parentElement.querySelector('[data-search-page-clear]')
        : null;
      if (!clearBtn) return;

      function toggleClear() {
        var has = !!input.value;
        clearBtn.classList.toggle('hidden', !has);
        clearBtn.classList.toggle('flex', has);
      }

      toggleClear();
      input.addEventListener('input', toggleClear);
      clearBtn.addEventListener('click', function () {
        input.value = '';
        toggleClear();
        input.focus();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-brand-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-brand-products]').forEach(function (section) {
      var container = section.querySelector('[data-scroll-container]');
      var leftBtn = section.querySelector('[data-scroll-left]');
      var rightBtn = section.querySelector('[data-scroll-right]');
      if (!container || !leftBtn || !rightBtn) return;
      function getScrollAmount() {
        var firstCard = container.querySelector(':scope > div');
        if (!firstCard) return 300;
        return firstCard.offsetWidth + 12;
      }
      function updateButtonStates() {
        var scrollLeft = container.scrollLeft;
        var maxScroll = container.scrollWidth - container.clientWidth;
        leftBtn.disabled = scrollLeft <= 0;
        rightBtn.disabled = scrollLeft >= maxScroll - 1;
      }
      leftBtn.addEventListener('click', function () {
        container.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
      rightBtn.addEventListener('click', function () {
        container.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
      container.addEventListener('scroll', updateButtonStates, { passive: true });
      window.addEventListener('resize', updateButtonStates, { passive: true });
      updateButtonStates();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      var PRODUCT_ID = section.dataset.productId;
      var PRODUCT_NAME = section.dataset.productName || '';
      var PRODUCT_URL = section.dataset.productUrl || '';
      var REVIEWS_TO_SHOW = parseInt(section.dataset.reviewsToShow, 10) || 6;
      var STAGGER_MS = 75;
      var RATING_STARS_TEMPLATE = section.dataset.ratingStarsTemplate || 'Rating: __RATING__ out of 5 stars';
      var RESPONSE_TEMPLATE = section.dataset.responseTemplate || 'Response from __NAME__';
      var verifiedBuyerLabel = section.dataset.verifiedBuyerLabel || '';
      var shopName = section.dataset.shopName || '';

      if (!PRODUCT_ID) return;
      if (!window.pigment.Reviews || !window.pigment.Reviews.adapter) {
        section.style.display = 'none';
        return;
      }

      var container = section.querySelector('[data-scroll-container]');
      var summaryContainer = section.querySelector('[data-review-summary]');
      var leftBtn = section.querySelector('[data-scroll-left]');
      var rightBtn = section.querySelector('[data-scroll-right]');
      if (!container || !leftBtn || !rightBtn) return;

    function buildStarRating(rating) {
      var max = 5;
      var fullStars = Math.floor(rating);
      var decimal = rating - fullStars;
      var html = '';
      var uniqueId = 'sr-' + Math.random().toString(36).substr(2, 6);

      html += '<div class="flex items-center gap-1" aria-label="' + RATING_STARS_TEMPLATE.replace('__RATING__', rating) + '">';
      html += '<div class="flex items-center gap-1" role="img" aria-hidden="true">';

      for (var i = 1; i <= max; i++) {
        if (i <= fullStars) {
          html += '<svg class="w-5 h-5 shrink-0 text-success" aria-hidden="true" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">';
          html += '<polygon fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="miter" points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />';
          html += '</svg>';
        } else if (i === fullStars + 1 && decimal > 0) {
          var fillWidth = decimal * 24;
          var clipId = uniqueId + '-clip-' + i;
          html += '<svg class="w-5 h-5 shrink-0 text-success" aria-hidden="true" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">';
          html += '<defs><clipPath id="' + clipId + '"><rect x="0" y="0" width="' + fillWidth + '" height="24" /></clipPath></defs>';
          html += '<polygon fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="miter" points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />';
          html += '<polygon fill="currentColor" stroke="none" points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" clip-path="url(#' + clipId + ')" />';
          html += '</svg>';
        } else {
          html += '<svg class="w-5 h-5 shrink-0 text-success" aria-hidden="true" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">';
          html += '<polygon fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="miter" points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />';
          html += '</svg>';
        }
      }

      html += '</div></div>';
      return html;
    }

    function timeAgo(dateString) {
      var now = new Date();
      var date = new Date(dateString);
      var seconds = Math.floor((now - date) / 1000);

      var intervals = [
        { label: 'year', seconds: 31536000 },
        { label: 'month', seconds: 2592000 },
        { label: 'week', seconds: 604800 },
        { label: 'day', seconds: 86400 },
        { label: 'hour', seconds: 3600 },
        { label: 'minute', seconds: 60 }
      ];

      for (var i = 0; i < intervals.length; i++) {
        var count = Math.floor(seconds / intervals[i].seconds);
        if (count >= 1) {
          return count + ' ' + intervals[i].label + (count > 1 ? 's' : '') + ' ago';
        }
      }

      return 'Just now';
    }

    function escapeHtml(str) {
      if (!str) return '';
      var div = document.createElement('div');
      div.appendChild(document.createTextNode(str));
      return div.innerHTML;
    }

    function buildReviewCard(review) {
      var name = escapeHtml(review.author);
      var title = escapeHtml(review.title);
      var body = escapeHtml(review.body);
      var rating = review.rating;
      var date = review.date ? timeAgo(review.date) : '';
      var verified = review.verified;

      var html = '';
      html += '<div class="w-[75%] sm:w-[40%] lg:w-[28.57%] shrink-0 snap-start">';
      html += '<div class="flex flex-col border border-border p-5 min-h-[300px]">';
      html += buildStarRating(rating);

      if (title && body) {
        html += '<h3 class="mt-5 mb-3 text-base font-semibold text-foreground line-clamp-1">' + title + '</h3>';
        html += '<p class="text-sm text-muted-foreground">' + body + '</p>';
      } else if (body) {
        html += '<h3 class="mt-5 mb-3 text-base font-semibold text-foreground">' + body + '</h3>';
      }

      if (review.reply && review.reply.body) {
        var replierName = review.reply.author || shopName;
        var responseLabel = RESPONSE_TEMPLATE.replace('__NAME__', escapeHtml(replierName));
        html += '<div class="mt-4 pt-4 border-t border-border">';
        html += '<p class="text-sm font-semibold text-foreground mb-2">' + responseLabel + '</p>';
        html += '<p class="text-sm text-muted-foreground">' + escapeHtml(review.reply.body) + '</p>';
        html += '</div>';
      }

      html += '<div class="mt-auto pt-4 flex items-center justify-between">';
      html += '<div>';
      html += '<p class="text-sm font-medium text-foreground">' + name + '</p>';
      html += '<p class="text-xs text-muted-foreground">' + verifiedBuyerLabel + '</p>';
      html += '</div>';
      if (date) {
        html += '<p class="text-xs text-muted-foreground">' + date + '</p>';
      }
      html += '</div>';
      html += '</div>';
      html += '</div>';

      return html;
    }

    function buildReviewSummary(reviews) {
      var total = reviews.length;
      if (total === 0) return '';

      // Calculate average rating
      var sum = 0;
      var breakdown = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
      for (var i = 0; i < reviews.length; i++) {
        var r = Math.round(reviews[i].rating);
        sum += reviews[i].rating;
        if (breakdown[r] !== undefined) breakdown[r]++;
      }
      var average = (sum / total).toFixed(1);

      var html = '';
      html += '<div class="mb-8 flex flex-col sm:flex-row gap-6 sm:gap-10 items-start">';

      // Left side: average rating
      html += '<div class="flex flex-col items-start shrink-0">';
      var displayAvg = average.replace(/\.0$/, '');
      html += '<span class="text-3xl font-semibold text-primary leading-none">' + displayAvg + '/5</span>';
      html += '<p class="mt-2 text-sm text-muted-foreground">Based on ' + total + ' review' + (total !== 1 ? 's' : '') + '</p>';
      html += '</div>';

      // Right side: star breakdown bars
      html += '<div class="flex-1 w-full min-w-0 flex flex-col gap-1.5">';
      for (var star = 5; star >= 1; star--) {
        var count = breakdown[star];
        var pct = Math.round((count / total) * 100);
        html += '<div class="flex items-center gap-2">';
        html += '<span class="shrink-0 w-3 text-sm text-muted-foreground text-right tabular-nums">' + star + '</span>';
        html += '<svg class="w-3.5 h-3.5 shrink-0 text-muted-foreground/60" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><polygon fill="currentColor" points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" /></svg>';
        html += '<div class="flex-1 h-1.5 bg-primary/15 rounded-full overflow-hidden">';
        html += '<div class="h-full bg-primary rounded-full" style="width: ' + pct + '%"></div>';
        html += '</div>';
        html += '<span class="shrink-0 w-10 text-xs text-muted-foreground tabular-nums text-right">(' + pct + '%)</span>';
        html += '</div>';
      }
      html += '</div>';

      html += '</div>';
      return html;
    }

    function initCarousel() {
      function getScrollAmount() {
        var firstCard = container.querySelector(':scope > div');
        if (!firstCard) return 300;
        return firstCard.offsetWidth + 12;
      }

      function updateButtonStates() {
        var scrollLeft = container.scrollLeft;
        var maxScroll = container.scrollWidth - container.clientWidth;
        leftBtn.disabled = scrollLeft <= 0;
        rightBtn.disabled = scrollLeft >= maxScroll - 1;
      }

      leftBtn.addEventListener('click', function() {
        container.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });

      rightBtn.addEventListener('click', function() {
        container.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });

      container.addEventListener('scroll', updateButtonStates, { passive: true });
      window.addEventListener('resize', updateButtonStates, { passive: true });
      updateButtonStates();
    }

    function emitReviewsJsonLd(reviews) {
      if (!reviews.length) return;
      var productScript = document.querySelector('script[data-product-jsonld]');
      if (!productScript) return;
      var productLd;
      try {
        productLd = JSON.parse(productScript.textContent);
      } catch (e) {
        return;
      }
      var reviewNodes = reviews.map(function (r) {
        var node = {
          '@type': 'Review',
          author: { '@type': 'Person', name: r.author || 'Anonymous' },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: r.rating,
            bestRating: 5,
            worstRating: 1
          }
        };
        if (r.title) node.name = r.title;
        if (r.body) node.reviewBody = r.body;
        if (r.date) node.datePublished = r.date;
        return node;
      });
      var ratingSum = 0;
      for (var i = 0; i < reviews.length; i++) ratingSum += reviews[i].rating;
      var averageRating = Math.round((ratingSum / reviews.length) * 10) / 10;
      productLd.aggregateRating = {
        '@type': 'AggregateRating',
        ratingValue: averageRating,
        reviewCount: reviews.length,
        bestRating: 5,
        worstRating: 1
      };
      productLd.review = reviewNodes;
      productScript.textContent = JSON.stringify(productLd);
    }

    function fetchAndRender() {
      window.pigment.Reviews.adapter.fetch(PRODUCT_ID).then(function (reviews) {
        if (!reviews || reviews.length === 0) {
          section.style.display = 'none';
          return;
        }
        emitReviewsJsonLd(reviews);
        if (summaryContainer) summaryContainer.innerHTML = buildReviewSummary(reviews);
        var displayReviews = reviews.slice(0, REVIEWS_TO_SHOW);
        var html = '';
        for (var i = 0; i < displayReviews.length; i++) html += buildReviewCard(displayReviews[i]);
        container.innerHTML = html;
        container.querySelectorAll(':scope > div').forEach(function (card, idx) {
          card.classList.add('stagger-fade-in');
          card.style.setProperty('--stagger-i', idx);
          card.style.setProperty('--stagger-step', STAGGER_MS + 'ms');
        });
        initCarousel();
      });
    }

    /* Defer the Judge.me network fetch until the section enters the
       viewport. Reviews are always below the fold (after gallery, form,
       and recommendations) so paying for the cross-origin fetch on every
       product page render is pure waste. rootMargin gives us ~600px of
       runway so the cards are ready by the time the user scrolls there. */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            io.disconnect();
            fetchAndRender();
          }
        });
      }, { rootMargin: '600px 0px' });
      io.observe(section);
    } else {
      fetchAndRender();
    }
    }

    document.querySelectorAll('[data-product-reviews]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-table"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var container = document.querySelector('[data-variant-table-container]');
    if (!container) return;
    if (container.dataset.productTableBound === '1') return;
    container.dataset.productTableBound = '1';

    var addToCartLabel = container.dataset.addToCartLabel || 'Add to cart';
    var addingLabel = container.dataset.addingLabel || 'Adding';
    var addedLabel = container.dataset.addedLabel || 'Item added';
    var addFailedLabel = container.dataset.addFailedLabel || "Couldn't add item. Try again or refresh.";
    var addFailedShortLabel = container.dataset.addFailedShortLabel || "Couldn't add";
    var selectionClearedLabel = container.dataset.selectionClearedLabel || 'Selection cleared';

    /* `items` is `let` (not `const`) so the Storefront-API overflow
       fetch can append fresh rows and the existing iteration sites —
       updateAllLimits, updateInCartLabels, applyCartPayload,
       filterItems, updateCartSummary, addAllToCart, distributeColumns —
       see them via the closed-over binding without re-querying the DOM. */
    let items = Array.from(container.querySelectorAll('[data-variant-item]'));
    const list = container.querySelector('[data-variant-list]');
    const searchInput = container.querySelector('[data-variant-search]');
    /* `let` so rebuildCategoryTabs() can refresh the reference after
       JS-injected tabs are added during the lazy-fetch chain. */
    let categoryTabs = container.querySelectorAll('[data-category]');
    const noResultsEl = container.querySelector('[data-no-results]');
    const clearSearchBtn = container.querySelector('[data-clear-search]');

    const sortToggleBtn = container.querySelector('[data-sort-toggle]');
    const sortIconCols = container.querySelector('[data-sort-icon-cols]');
    const sortIconRows = container.querySelector('[data-sort-icon-rows]');
    const sortLabel = container.querySelector('[data-sort-label]');
    const colCountToggleBtn = container.querySelector('[data-col-count-toggle]');
    const colSymbol = container.querySelector('[data-col-symbol]');

    /* Move top & bottom bars into list wrapper so sticky positioning is scoped to the list area */
    const listWrapper = container.querySelector('[data-table-list-wrapper]');
    const topBar = container.querySelector('[data-table-top-bar]');
    const bottomBar = container.querySelector('[data-table-bottom-bar]');
    if (topBar && listWrapper) listWrapper.prepend(topBar);
    if (bottomBar && listWrapper) listWrapper.appendChild(bottomBar);

    /* Set initial category to first tab */
    let activeCategory = categoryTabs.length > 0 ? categoryTabs[0].dataset.category : null;
    /* Track the category the user manually chose (so we can revert when search clears) */
    let userChosenCategory = activeCategory;
    /* Cache the original "X colours" tab counts so we can restore them after a search */
    const originalTabCounts = {};
    categoryTabs.forEach(tab => {
      const countEl = tab.querySelector('.category-tab-count');
      if (countEl) originalTabCounts[tab.dataset.category] = countEl.textContent;
    });
    let searchTerm = '';
    let sortByRows = false; /* false = column-first (default), true = row-first */
    let userColOverride = null; /* null = responsive default, number = user override */
    let colDirection = -1; /* -1 = removing a column, 1 = adding a column */

    /* ── Persisted user preferences (column count + sort direction) ──
       Stored globally so the choice survives page navigation. The override is
       saved as the user's *requested* count; getColumnCount() clamps it to the
       current viewport's max, so a saved 3-col preference on mobile shows 1
       column but expands back to 3 when the viewport allows. */
    const PREFS_KEY = 'productTable:prefs:v1';
    function loadTablePrefs() {
      try {
        const raw = localStorage.getItem(PREFS_KEY);
        if (!raw) return null;
        const p = JSON.parse(raw);
        return (p && typeof p === 'object') ? p : null;
      } catch (e) { return null; }
    }
    function saveTablePrefs() {
      try {
        localStorage.setItem(PREFS_KEY, JSON.stringify({
          sortByRows: sortByRows,
          userColOverride: userColOverride,
        }));
      } catch (e) { /* storage disabled — fall through */ }
    }
    (function applyStoredPrefs() {
      const prefs = loadTablePrefs();
      if (!prefs) return;
      if (typeof prefs.sortByRows === 'boolean') sortByRows = prefs.sortByRows;
      if (typeof prefs.userColOverride === 'number' && prefs.userColOverride >= 1) {
        userColOverride = prefs.userColOverride;
      }
    })();

    /* ── Cart quantity tracking ── */
    const isB2B = document.querySelector('meta[name="shopify-b2b"]')?.getAttribute('content') === 'true';
    let cartQuantities = {}; /* variant_id (string) → quantity currently in cart */

    function applyCartPayload(cart) {
      cartQuantities = {};
      if (!cart || !cart.items) return;
      cart.items.forEach(function (ci) {
        var vid = String(ci.variant_id);
        cartQuantities[vid] = (cartQuantities[vid] || 0) + ci.quantity;
        // Upgrade B2B quantity rules from the cart payload — never downgrade
        // Liquid-rendered defaults, since the REST cart API does carry B2B
        // context for line items already in the cart.
        if (ci.quantity_rule && isB2B) {
          items.forEach(function (item) {
            if (item.dataset.variantId !== vid) return;
            var curMin = parseInt(item.dataset.quantityMin) || 1;
            var curInc = parseInt(item.dataset.quantityIncrement) || 1;
            if (ci.quantity_rule.min > curMin) item.dataset.quantityMin = ci.quantity_rule.min;
            if (ci.quantity_rule.increment > curInc) item.dataset.quantityIncrement = ci.quantity_rule.increment;
          });
        }
      });
    }

    function fetchCartQuantities() {
      // Use the shared cart store so this fetch is coalesced with the
      // header badge / cart-notification / main-product consumers
      // instead of firing a duplicate /cart.js request per page.
      var ns = window.pigment;
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var p = ns && ns.cart ? ns.cart.get() : fetch(rootUrl + 'cart.js').then(function (r) { return r.json(); });
      return p.then(applyCartPayload).catch(function () { cartQuantities = {}; });
    }
    // Subscribe so cart updates from add-to-cart elsewhere on the page
    // also refresh the table state without an extra fetch.
    if (window.pigment && window.pigment.cart) {
      window.pigment.cart.subscribe(function (cart) {
        applyCartPayload(cart);
        updateAllLimits();
        updateInCartLabels();
      });
    }
    // The previous version also fired /products/{handle}.json to "upgrade"
    // B2B quantity rules. Batch 2 already inlines the slim B2B payload via
    // Liquid render, and the cart API already provides upgrades for line
    // items already in the cart, so the extra round-trip has been removed —
    // there is now a single source of truth for quantity rules.

    /* Returns remaining stock the customer can add: -1 = no limit, 0+ = exact remaining */
    function getEffectiveMax(item) {
      const baseMax = parseInt(item.dataset.quantityMax) || 0;
      if (baseMax === 0) return -1; /* no inventory tracking → unlimited */
      const vid = item.dataset.variantId;
      const cartQty = cartQuantities[vid] || 0;
      return Math.max(0, baseMax - cartQty);
    }

    function updateAllLimits() {
      items.forEach(item => {
        const input = item.querySelector('[data-quantity-input]');
        const minusBtn = item.querySelector('[data-quantity-minus]');
        const plusBtn = item.querySelector('[data-quantity-plus]');
        if (!input || !minusBtn || !plusBtn) return;
        const max = getEffectiveMax(item);
        const hasLimit = max >= 0;
        const val = parseInt(input.value) || 0;
        if (hasLimit && val > max) {
          input.value = Math.max(0, max);
        }
        const newVal = parseInt(input.value) || 0;
        minusBtn.disabled = newVal <= 0;
        plusBtn.disabled = hasLimit && newVal >= max;
        if (hasLimit) input.max = max; else input.removeAttribute('max');
      });
      updateCartSummary();
    }

    function updateInCartLabels() {
      items.forEach(item => {
        const label = item.querySelector('[data-in-cart]');
        if (!label) return;
        const vid = item.dataset.variantId;
        const qty = cartQuantities[vid] || 0;
        if (qty > 0) {
          label.textContent = qty + ' in cart';
          label.style.display = '';
        } else {
          label.style.display = 'none';
        }
      });
    }

    /* ── Text contrast detection ── */
    function getRelativeLuminance(hex) {
      hex = hex.replace('#', '');
      if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }
      const r = parseInt(hex.substr(0, 2), 16) / 255;
      const g = parseInt(hex.substr(2, 2), 16) / 255;
      const b = parseInt(hex.substr(4, 2), 16) / 255;
      const [rl, gl, bl] = [r, g, b].map(c =>
        c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4)
      );
      return 0.2126 * rl + 0.7152 * gl + 0.0722 * bl;
    }

    function getImageLuminance(imgEl) {
      return new Promise(resolve => {
        function measure() {
          const canvas = document.createElement('canvas');
          const size = 64;
          canvas.width = size;
          canvas.height = size;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(imgEl, 0, 0, size, size);
          try {
            const data = ctx.getImageData(0, 0, size, size).data;
            let total = 0;
            const count = data.length / 4;
            for (let i = 0; i < data.length; i += 4) {
              const r = data[i] / 255;
              const g = data[i + 1] / 255;
              const b = data[i + 2] / 255;
              const [rl, gl, bl] = [r, g, b].map(c =>
                c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4)
              );
              total += 0.2126 * rl + 0.7152 * gl + 0.0722 * bl;
            }
            resolve(total / count);
          } catch (e) {
            resolve(0);
          }
        }
        if (imgEl.complete && imgEl.naturalWidth > 0) {
          measure();
        } else {
          imgEl.addEventListener('load', measure, { once: true });
          imgEl.addEventListener('error', () => resolve(0), { once: true });
        }
      });
    }

    /* Extracted so it runs identically for the initial server-rendered
       items and any rows the Storefront-API overflow fetch appends. */
    function applyContrastToItems(itemList) {
      itemList.forEach(item => {
        if (item.dataset.contrastApplied === '1') return;
        item.dataset.contrastApplied = '1';
        const hex = item.dataset.swatchHex;
        if (hex) {
          const luminance = getRelativeLuminance(hex);
          if (luminance < 0.4) {
            item.classList.add('dark-bg');
          }
        } else if (item.hasAttribute('data-bg-fallback')) {
          item.classList.add('dark-bg');
        } else if (item.hasAttribute('data-bg-image')) {
          item.classList.add('dark-bg');
          const img = item.querySelector('img');
          if (img) {
            getImageLuminance(img).then(luminance => {
              if (luminance >= 0.4) {
                item.classList.remove('dark-bg');
              }
            });
          }
        }
      });
    }
    applyContrastToItems(items);

    /* ── Category filtering ── */
    const tabIndicator = container.querySelector('[data-tab-indicator]');
    const categorySelect = container.querySelector('[data-category-select]');

    function positionIndicator(tab) {
      if (!tabIndicator || !tab) return;
      tabIndicator.style.width = tab.offsetWidth + 'px';
      tabIndicator.style.transform = 'translateX(' + tab.offsetLeft + 'px)';
    }

    /* Set initial indicator position after layout */
    if (categoryTabs.length > 0) {
      requestAnimationFrame(() => positionIndicator(categoryTabs[0]));
    }

    /* Extracted so rebuildCategoryTabs() can wire the same handler to
       JS-injected tabs and they behave identically to server-rendered
       ones. Idempotent — guards against double-binding. */
    function bindTabClick(tab) {
      if (tab.dataset.tabBound === '1') return;
      tab.dataset.tabBound = '1';
      tab.addEventListener('click', () => {
        activeCategory = tab.dataset.category;
        userChosenCategory = activeCategory;

        categoryTabs.forEach(t => {
          const isActive = t === tab;
          t.classList.toggle('is-active', isActive);
          t.setAttribute('aria-pressed', String(isActive));
        });

        if (categorySelect) categorySelect.value = activeCategory;
        positionIndicator(tab);
        filterItems();
        container.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
    categoryTabs.forEach(bindTabClick);

    /* Mobile category select */
    categorySelect?.addEventListener('change', (e) => {
      activeCategory = e.target.value;
      userChosenCategory = activeCategory;
      categoryTabs.forEach(t => {
        const isActive = t.dataset.category === activeCategory;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-pressed', String(isActive));
      });
      filterItems();
      container.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    /* ── Sort direction toggle ── */
    sortToggleBtn?.addEventListener('click', () => {
      sortByRows = !sortByRows;
      sortIconCols.classList.toggle('hidden', sortByRows);
      sortIconRows.classList.toggle('hidden', !sortByRows);
      /* Label stays as "Sort"; arrow icon swap handles the visual change */
      distributeColumns();
      saveTablePrefs();
    });

    /* ── Column count toggle ── */
    colCountToggleBtn?.addEventListener('click', () => {
      const max = getMaxColumns();
      const current = getColumnCount();
      const next = current + colDirection;

      userColOverride = next;
      updateColumnUI();
      distributeColumns();

      /* Reverse direction at boundaries */
      if (next <= 1) colDirection = 1;
      else if (next >= max) colDirection = -1;

      /* Update symbol to show what next click will do */
      if (colSymbol) colSymbol.textContent = colDirection === 1 ? '+' : '\u2212';
      saveTablePrefs();
    });

    /* ── Search filtering ── */
    const inlineClearBtn = container.querySelector('[data-variant-search-clear]');
    function updateInlineClearVisibility() {
      if (!inlineClearBtn) return;
      if (searchInput && searchInput.value.length > 0) {
        inlineClearBtn.classList.add('is-visible');
      } else {
        inlineClearBtn.classList.remove('is-visible');
      }
    }
    searchInput?.addEventListener('input', (e) => {
      searchTerm = e.target.value.toLowerCase().trim();
      updateInlineClearVisibility();
      filterItems();
    });

    inlineClearBtn?.addEventListener('click', () => {
      if (!searchInput) return;
      searchInput.value = '';
      searchTerm = '';
      updateInlineClearVisibility();
      filterItems();
      searchInput.focus();
    });

    clearSearchBtn?.addEventListener('click', () => {
      searchInput.value = '';
      searchTerm = '';
      updateInlineClearVisibility();
      filterItems();
    });

    updateInlineClearVisibility();

    /* ── Grid column distribution ── */
    function getMaxColumns() {
      if (window.matchMedia('(min-width: 1280px)').matches) return 3;
      if (window.matchMedia('(min-width: 768px)').matches) return 2;
      return 1;
    }

    function getColumnCount() {
      const max = getMaxColumns();
      if (userColOverride !== null) return Math.min(userColOverride, max);
      return max;
    }

    function updateColumnUI() {
      const cols = getColumnCount();
      list.classList.remove('md:grid-cols-1', 'md:grid-cols-2', 'md:grid-cols-3', 'xl:grid-cols-3');
      if (userColOverride !== null) {
        if (cols === 1) list.classList.add('md:grid-cols-1');
        else if (cols === 2) list.classList.add('md:grid-cols-2');
        else if (cols === 3) list.classList.add('md:grid-cols-3');
      } else {
        list.classList.add('md:grid-cols-2', 'xl:grid-cols-3');
      }
    }

    function distributeColumns() {
      const cols = getColumnCount();
      const visible = Array.from(items).filter(item => !item.classList.contains('hidden'));
      /* Sort visible by variant.position (set from product.variants order in
         Liquid). product.variants is sorted by option-value position, so this
         ensures the on-screen order tracks option-value reordering even when
         the DOM order is grouped by category or appended from lazy-fetched
         overflow pages. Numeric ascending; missing values fall back to a
         stable index so the original DOM order is preserved as a tiebreaker. */
      visible.forEach((item, i) => { item._pt_idx = i; });
      visible.sort((a, b) => {
        const pa = parseInt(a.dataset.variantPosition, 10);
        const pb = parseInt(b.dataset.variantPosition, 10);
        const va = Number.isFinite(pa) ? pa : a._pt_idx;
        const vb = Number.isFinite(pb) ? pb : b._pt_idx;
        if (va !== vb) return va - vb;
        return a._pt_idx - b._pt_idx;
      });
      const total = visible.length;
      const grid = [];

      if (sortByRows) {
        /* Row-first: items flow left-to-right, then down */
        const rowCount = Math.ceil(total / cols) || 1;
        for (let i = 0; i < total; i++) {
          const r = Math.floor(i / cols);
          const c = i % cols;
          if (!grid[r]) grid[r] = [];
          grid[r][c] = visible[i];
          visible[i].style.order = i;
        }
        list.style.gridTemplateRows = 'repeat(' + rowCount + ', auto)';
        list.style.gridAutoFlow = 'row';
      } else {
        /* Column-first: items flow top-to-bottom, then right */
        const baseSize = Math.floor(total / cols);
        const remainder = total % cols;
        const colSizes = [];
        for (let c = 0; c < cols; c++) {
          colSizes.push(baseSize + (c < remainder ? 1 : 0));
        }

        let idx = 0;
        for (let c = 0; c < cols; c++) {
          for (let r = 0; r < colSizes[c]; r++) {
            if (!grid[r]) grid[r] = [];
            grid[r][c] = visible[idx];
            visible[idx].style.order = r * cols + c;
            idx++;
          }
        }

        const rows = colSizes[0] || 1;
        list.style.gridTemplateRows = 'repeat(' + rows + ', auto)';
        list.style.gridAutoFlow = 'row';
      }

      /* Apply per-side borders to white/contrast items based on neighbour adjacency */
      const borderColor = 'var(--color-border)';
      visible.forEach(item => {
        item.style.boxShadow = '';
        item.style.setProperty('--_border-shadow', 'none');
      });

      function needsBorder(item) {
        return item && (item.hasAttribute('data-is-white') || item.hasAttribute('data-list-item-contrast'));
      }

      for (let r = 0; r < grid.length; r++) {
        for (let c = 0; c < cols; c++) {
          const item = grid[r] && grid[r][c];
          if (!item || !needsBorder(item)) continue;

          const top = grid[r - 1] && grid[r - 1][c];
          const bottom = grid[r + 1] && grid[r + 1][c];
          const left = grid[r][c - 1];
          const right = grid[r][c + 1];

          const shadows = [];
          /* Always show border on a side unless the neighbour also needs a border */
          if (!needsBorder(top))
            shadows.push('inset 0 1px 0 0 ' + borderColor);
          if (!needsBorder(bottom))
            shadows.push('inset 0 -1px 0 0 ' + borderColor);
          if (!needsBorder(left))
            shadows.push('inset 1px 0 0 0 ' + borderColor);
          if (!needsBorder(right))
            shadows.push('inset -1px 0 0 0 ' + borderColor);

          /* For shared edges between bordered items, only one side draws the border */
          if (needsBorder(top))
            shadows.push('inset 0 1px 0 0 ' + borderColor);
          if (needsBorder(left))
            shadows.push('inset 1px 0 0 0 ' + borderColor);

          const shadowVal = shadows.join(', ');
          /* Contrast items use ::after overlay so border renders over swatch */
          if (item.hasAttribute('data-list-item-contrast')) {
            item.style.setProperty('--_border-shadow', shadowVal);
          } else {
            item.style.boxShadow = shadowVal;
          }
        }
      }
    }

    function filterItems() {
      /* ── Pass 1: count search matches per category across the ENTIRE range ── */
      const matchesByCategory = {};
      let totalMatches = 0;

      items.forEach(item => {
        const name = item.dataset.variantName;
        const code = item.dataset.variantCode;
        const cat = item.dataset.variantCategory || '';

        const matchesSearch = !searchTerm ||
          name.includes(searchTerm) ||
          code.includes(searchTerm);

        if (matchesSearch) {
          matchesByCategory[cat] = (matchesByCategory[cat] || 0) + 1;
          totalMatches++;
        }
      });

      /* ── Decide which category should be active right now ── */
      if (searchTerm) {
        /* If the user's current tab has matches, stay there. Otherwise jump
           to the first tab (in display order) that has matches, so the table
           "follows" the search results across catalogues. */
        const activeMatches = matchesByCategory[activeCategory] || 0;
        if (activeMatches === 0 && totalMatches > 0) {
          for (let i = 0; i < categoryTabs.length; i++) {
            const cat = categoryTabs[i].dataset.category;
            if ((matchesByCategory[cat] || 0) > 0) {
              activeCategory = cat;
              break;
            }
          }
        }
      } else if (userChosenCategory && activeCategory !== userChosenCategory) {
        /* Search cleared → restore the user's last manually picked tab */
        activeCategory = userChosenCategory;
      }

      /* ── Update tab UI: active state, counts, dimming ── */
      let activeTabEl = null;
      categoryTabs.forEach(tab => {
        const cat = tab.dataset.category;
        const isActive = cat === activeCategory;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-pressed', String(isActive));
        if (isActive) activeTabEl = tab;

        const countEl = tab.querySelector('.category-tab-count');
        if (countEl) {
          if (searchTerm) {
            const m = matchesByCategory[cat] || 0;
            countEl.textContent = m === 1 ? '1 match' : m + ' matches';
            tab.classList.toggle('has-no-matches', m === 0);
          } else {
            if (originalTabCounts[cat] != null) countEl.textContent = originalTabCounts[cat];
            tab.classList.remove('has-no-matches');
          }
        }
      });

      /* Keep mobile select in sync */
      if (categorySelect && categorySelect.value !== activeCategory) {
        categorySelect.value = activeCategory;
      }

      /* Reposition indicator since the active tab may have changed */
      if (activeTabEl) positionIndicator(activeTabEl);

      /* ── Pass 2: apply visibility using the (possibly auto-switched) category ── */
      let visibleCount = 0;
      items.forEach(item => {
        const name = item.dataset.variantName;
        const code = item.dataset.variantCode;
        const category = item.dataset.variantCategory;

        const matchesCategory = !activeCategory || category === activeCategory;
        const matchesSearch = !searchTerm ||
          name.includes(searchTerm) ||
          code.includes(searchTerm);

        const visible = matchesCategory && matchesSearch;
        item.classList.toggle('hidden', !visible);

        if (visible) visibleCount++;
      });

      /* "No results" only fires when the search has zero matches in ANY category */
      const hasNoMatchesAnywhere = !!searchTerm && totalMatches === 0;
      noResultsEl.classList.toggle('hidden', !hasNoMatchesAnywhere);
      list.classList.toggle('hidden', visibleCount === 0);
      distributeColumns();
      updateVolumeDiscount();
      updateCartSummary();
    }

    /* ── Volume discount update ── */
    const volumeDiscountEl = container.querySelector('[data-table-volume-discount]');
    const volumeTable = volumeDiscountEl;
    const totalPriceEl = container.querySelector('[data-table-total-price]');
    const totalQtyEl = container.querySelector('[data-table-total-qty]');
    const addToCartBtn = container.querySelector('[data-table-add-to-cart]');

    function formatMoney(cents) {
      var ns = window.pigment;
      if (ns && ns.formatMoney) return ns.formatMoney(cents);
      return (cents / 100).toFixed(2);
    }

    function updateVolumeDiscount() {
      const firstVisible = Array.from(items).find(
        item => !item.classList.contains('hidden') && item.dataset.variantPrice
      );
      if (!firstVisible) return;

      const price = parseInt(firstVisible.dataset.variantPrice);
      const basePriceEl = container.querySelector('[data-table-volume-base-price]');
      if (basePriceEl) basePriceEl.textContent = formatMoney(price);

      if (!volumeTable || !volumeTable.dataset.tableVolumeDecreases) return;

      try {
        const decreases = JSON.parse(volumeTable.dataset.tableVolumeDecreases);
        decreases.forEach((decrease, i) => {
          const cell = volumeDiscountEl.querySelector('[data-table-volume-price="' + (i + 1) + '"]');
          if (cell && decrease > 0) {
            cell.textContent = formatMoney(price - decrease);
          }
        });
      } catch (e) {}
    }

    /* ── Cart summary + volume tier highlighting ── */
    function getActiveTier(totalQty) {
      if (!volumeTable) return { tierIndex: 0, decrease: 0 };
      if (!volumeTable.dataset.tableVolumeAmounts) return { tierIndex: 0, decrease: 0 };
      try {
        const amounts = JSON.parse(volumeTable.dataset.tableVolumeAmounts);
        const decreases = JSON.parse(volumeTable.dataset.tableVolumeDecreases);
        let tierIndex = 0;
        let decrease = 0;
        for (let i = 0; i < amounts.length; i++) {
          if (totalQty >= amounts[i]) {
            tierIndex = i + 1;
            decrease = decreases[i] || 0;
          }
        }
        return { tierIndex, decrease };
      } catch (e) {
        return { tierIndex: 0, decrease: 0 };
      }
    }

    function highlightActiveTier(tierIndex) {
      if (!volumeDiscountEl) return;
      const allCells = volumeDiscountEl.querySelectorAll('[data-table-volume-col]');
      allCells.forEach(el => el.classList.remove('volume-active'));
      if (tierIndex < 0) return;
      const activeCells = volumeDiscountEl.querySelectorAll('[data-table-volume-col="' + tierIndex + '"]');
      activeCells.forEach(el => el.classList.add('volume-active'));
    }

    function updateCartSummary() {
      let totalQty = 0;
      let totalPrice = 0;

      /* Sum quantities across ALL items (all tabs, not just visible) */
      items.forEach(item => {
        const input = item.querySelector('[data-quantity-input]');
        if (!input) return;
        const qty = parseInt(input.value) || 0;
        if (qty <= 0) return;
        totalQty += qty;
      });

      const { tierIndex, decrease } = getActiveTier(totalQty);

      /* Calculate total price with volume discount applied per variant */
      items.forEach(item => {
        const input = item.querySelector('[data-quantity-input]');
        if (!input) return;
        const qty = parseInt(input.value) || 0;
        if (qty <= 0) return;
        const basePrice = parseInt(item.dataset.variantPrice) || 0;
        const discountedPrice = Math.max(0, basePrice - decrease);
        totalPrice += discountedPrice * qty;
      });

      if (totalPriceEl) totalPriceEl.textContent = formatMoney(totalPrice);
      if (totalQtyEl) {
        totalQtyEl.textContent = totalQty;
      }
      if (addToCartBtn) addToCartBtn.disabled = totalQty === 0;
      const clearSelectionBtn = container.querySelector('[data-clear-selection]');
      if (clearSelectionBtn) clearSelectionBtn.disabled = totalQty === 0;
      highlightActiveTier(totalQty > 0 ? tierIndex : -1);

      /* Update mobile sticky-bar toggle to reflect the active tier */
      const toggleLabelEl = container.querySelector('[data-volume-toggle-label]');
      const toggleTierPriceEl = container.querySelector('[data-volume-toggle-price]');
      if (volumeDiscountEl && (toggleLabelEl || toggleTierPriceEl)) {
        const activeTierCol = volumeDiscountEl.querySelector('[data-table-volume-col="' + tierIndex + '"]');
        if (activeTierCol) {
          const labelSrc = activeTierCol.querySelector('span:first-child');
          if (toggleLabelEl && labelSrc) {
            toggleLabelEl.textContent = labelSrc.textContent.trim() + ':';
          }
          if (toggleTierPriceEl) {
            const priceSrc = tierIndex === 0
              ? activeTierCol.querySelector('[data-table-volume-base-price]')
              : activeTierCol.querySelector('[data-table-volume-price="' + tierIndex + '"]');
            if (priceSrc) toggleTierPriceEl.textContent = priceSrc.textContent.trim();
            toggleTierPriceEl.classList.toggle('is-discounted', totalQty > 0 && tierIndex > 0);
          }
        }
      }
    }

    async function addAllToCart() {
      const itemsToAdd = [];
      items.forEach(item => {
        const input = item.querySelector('[data-quantity-input]');
        if (!input) return;
        const qty = parseInt(input.value) || 0;
        if (qty <= 0) return;
        itemsToAdd.push({
          id: parseInt(item.dataset.variantId),
          quantity: qty
        });
      });
      if (itemsToAdd.length === 0) return;

      const totalQty = itemsToAdd.reduce((sum, i) => sum + i.quantity, 0);

      const tblBtnText = addToCartBtn.querySelector('[data-btn-text]');
      const tblBtnSpinner = addToCartBtn.querySelector('[role="status"]');
      addToCartBtn.disabled = true;
      if (tblBtnText) tblBtnText.textContent = addingLabel;
      if (tblBtnSpinner) tblBtnSpinner.style.display = '';

      try {
        const rootUrl = window.Shopify?.routes?.root || '/';

        const response = await fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd })
        });

        if (!response.ok) {
          const err = await response.json().catch(() => ({}));
          throw new Error(err.description || addFailedLabel);
        }

        const data = await response.json();
        if (tblBtnSpinner) tblBtnSpinner.style.display = 'none';
        if (tblBtnText) tblBtnText.textContent = addedLabel;

        /* Show notification and update cart count */
        if (window.cartNotification?.onCartAdd) {
          window.cartNotification.onCartAdd(data);
        }

        /* Reset all quantities, then update limits with new cart state */
        items.forEach(item => {
          const input = item.querySelector('[data-quantity-input]');
          if (input) input.value = 0;
        });
        itemsToAdd.forEach(({ id, quantity }) => {
          const vid = String(id);
          cartQuantities[vid] = (cartQuantities[vid] || 0) + quantity;
        });
        updateAllLimits();
        updateInCartLabels();

        setTimeout(() => {
          if (tblBtnText) tblBtnText.textContent = addToCartLabel;
        }, 2000);
      } catch (error) {
        if (window.showToast) {
          window.showToast('cart-error-toast', {
            message: error.message,
            icon: 'x',
            duration: 4000
          });
        }
        if (tblBtnSpinner) tblBtnSpinner.style.display = 'none';
        if (tblBtnText) tblBtnText.textContent = addFailedShortLabel;
        addToCartBtn.disabled = false;
        setTimeout(() => {
          if (tblBtnText) tblBtnText.textContent = addToCartLabel;
        }, 3000);
      }
    }

    addToCartBtn?.addEventListener('click', addAllToCart);

    /* ── Scroll to top ── */
    const scrollToTopBtn = container.querySelector('[data-scroll-to-top]');
    scrollToTopBtn?.addEventListener('click', () => {
      container.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    /* ── Clear selection ──
       Look up the dialog API at click time, not bind time. The dialog
       snippet's bundled JS lives in a separate snippet-scripts.js file and
       may not have populated window.dialog_<id> by the time this section
       bundle initialises — capturing it at bind time was the entire reason
       the click handler appeared dead. */
    var clearBtn = container.querySelector('[data-clear-selection]');
    var clearDialogId = container.dataset.clearDialogId;
    var clearDialog = clearDialogId ? document.getElementById(clearDialogId) : null;

    if (clearBtn) clearBtn.addEventListener('click', function () {
      var api = window[container.dataset.clearDialogKey];
      if (api) api.open();
    });

    if (clearDialog) clearDialog.addEventListener('dialog:confirm', function () {
      items.forEach(function (item) {
        var input = item.querySelector('[data-quantity-input]');
        if (input) input.value = 0;
      });
      updateAllLimits();
      var toastApi = window[container.dataset.toastKey];
      if (toastApi) toastApi.show({ message: selectionClearedLabel, icon: 'check' });
    });

    /* ── Volume pricing toggle (mobile) ── */
    const volumeToggle = container.querySelector('[data-volume-toggle]');
    const volumeTiersPanel = container.querySelector('[data-volume-tiers]');
    const volumeToggleSummary = container.querySelector('[data-volume-toggle-summary]');
    volumeToggle?.addEventListener('click', () => {
      const isOpen = volumeTiersPanel.classList.toggle('is-open');
      volumeToggle.setAttribute('aria-expanded', String(isOpen));
      if (volumeToggleSummary) volumeToggleSummary.classList.toggle('invisible', isOpen);
    });

    /* Recalculate on resize */
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        updateColumnUI();
        distributeColumns();
        /* Reposition tab indicator */
        const activeTab = Array.from(categoryTabs).find(t => t.classList.contains('is-active'));
        if (activeTab) positionIndicator(activeTab);
      }, 100);
    });

    /* Sync sort-icon visibility with restored sortByRows preference */
    if (sortIconCols) sortIconCols.classList.toggle('hidden', sortByRows);
    if (sortIconRows) sortIconRows.classList.toggle('hidden', !sortByRows);

    /* Initialise colDirection + symbol from restored override.
       At max → next click removes; at 1 → next click adds; otherwise keep
       the default (remove) so the toggle behaves like a fresh visit. */
    (function syncColToggleSymbol() {
      const max = getMaxColumns();
      const current = getColumnCount();
      if (current >= max) colDirection = -1;
      else if (current <= 1) colDirection = 1;
      if (colSymbol) colSymbol.textContent = colDirection === 1 ? '+' : '−';
    })();

    /* Apply initial filter to show only the first category */
    filterItems();
    updateColumnUI();

    /* Fetch cart quantities (single source — see fetchCartQuantities note) */
    fetchCartQuantities().then(function () {
      updateAllLimits();
      updateInCartLabels();
    });

    /* ── Quantity controls ──
       Extracted so overflow rows fetched via Storefront API pick up
       the same handlers via one code path. Idempotent: skips items
       already bound. */
    function attachQuantityHandlers(itemList) {
      itemList.forEach(item => {
        if (item.dataset.qtyBound === '1') return;
        const minusBtn = item.querySelector('[data-quantity-minus]');
        const plusBtn = item.querySelector('[data-quantity-plus]');
        const input = item.querySelector('[data-quantity-input]');

        if (!minusBtn || !plusBtn || !input) return;
        item.dataset.qtyBound = '1';

        function getQtyMin() { return parseInt(item.dataset.quantityMin) || 1; }
        function getQtyStep() { return parseInt(item.dataset.quantityIncrement) || 1; }

        function getCurrentMax() {
          return getEffectiveMax(item);
        }

        function snapToStep(val) {
          const qtyMin = getQtyMin(), qtyStep = getQtyStep();
          const steps = Math.round((val - qtyMin) / qtyStep);
          return qtyMin + (steps * qtyStep);
        }

        function clampAndSnap(val) {
          if (val <= 0) return 0;
          val = Math.max(getQtyMin(), val);
          val = snapToStep(val);
          const max = getCurrentMax();
          if (max >= 0) val = Math.min(max, val);
          return val;
        }

        function updateButtons(val) {
          const max = getCurrentMax();
          const hasLimit = max >= 0;
          minusBtn.disabled = val <= 0;
          plusBtn.disabled = hasLimit && val >= max;
        }

        function setQuantity(val) {
          input.value = val;
          updateButtons(val);
          updateCartSummary();
        }

        minusBtn.addEventListener('click', () => {
          const current = parseInt(input.value) || 0;
          if (current <= getQtyMin()) {
            setQuantity(0);
          } else {
            setQuantity(clampAndSnap(current - getQtyStep()));
          }
        });

        plusBtn.addEventListener('click', () => {
          const current = parseInt(input.value) || 0;
          const max = getCurrentMax();
          if (max === 0) return;
          if (current === 0) {
            const qtyMin = getQtyMin();
            setQuantity(max >= 0 ? Math.min(qtyMin, max) : qtyMin);
          } else {
            setQuantity(clampAndSnap(current + getQtyStep()));
          }
        });

        input.addEventListener('change', () => {
          const val = parseInt(input.value);
          if (isNaN(val) || val < 0) {
            setQuantity(0);
          } else if (val > 0) {
            setQuantity(clampAndSnap(val));
          } else {
            setQuantity(0);
          }
        });

        input.addEventListener('blur', () => {
          if (input.value === '' || isNaN(parseInt(input.value))) {
            setQuantity(0);
          }
        });

        updateButtons(0);
      });
    }
    attachQuantityHandlers(items);

    /* ── Variant overflow fetch via Section Rendering API ──
       Liquid caps product.variants at 250. By wrapping the rendered
       output in a paginate tag (product.variants by 250) at the top
       of this section, we get page 1 server-rendered as today AND a
       route to fetch pages 2..N via Shopify's Section Rendering API.
       Each page
       returns the full section HTML; we parse out the variant list's
       <li>s, append them to the main list, and run the same per-row
       init the server-rendered rows get. No token, no app, no GraphQL —
       all unauth, all driven by the existing section.

       data-paginate-pages comes from paginate.pages (Liquid) on the
       container. When >1, this block kicks off the lazy-fetch chain. */
    const totalPages = parseInt(container.dataset.paginatePages || '1', 10) || 1;
    if (totalPages > 1) {
      const sectionId = container.dataset.paginateSectionId;
      const productHandle = container.dataset.productHandle;
      if (sectionId && productHandle) {
        fetchOverflowPages(productHandle, sectionId, totalPages).catch(function (err) {
          console.error('[product-table] overflow fetch failed:', err);
        });
      }
    }

    async function fetchOverflowPages(handle, sectionId, pages) {
      const newItems = [];
      for (let page = 2; page <= pages; page++) {
        const url = '/products/' + encodeURIComponent(handle)
          + '?section_id=' + encodeURIComponent(sectionId)
          + '&page=' + page;
        const r = await fetch(url, { headers: { Accept: 'text/html' } });
        if (!r.ok) {
          console.error('[product-table] page ' + page + ' fetch failed: ' + r.status);
          continue;
        }
        const html = await r.text();
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const remoteList = tmp.querySelector('[data-variant-list]');
        if (!remoteList) continue;
        const remoteItems = Array.from(remoteList.querySelectorAll('[data-variant-item]'));
        remoteItems.forEach(function (li) {
          /* Defend against duplicate variant IDs across pages — extremely
             rare but cheap to guard. */
          const vid = li.dataset.variantId;
          if (vid && container.querySelector('[data-variant-id="' + vid + '"]')) return;
          list.appendChild(li);
          newItems.push(li);
        });
      }

      if (newItems.length === 0) return;

      items = items.concat(newItems);
      applyContrastToItems(newItems);
      attachQuantityHandlers(newItems);
      /* Re-apply cached cart so new B2B rows pick up quantity-rule upgrades. */
      if (window.pigment && window.pigment.cart) {
        const cached = window.pigment.cart.cached();
        if (cached) applyCartPayload(cached);
      }
      /* Tabs may need updating: the page-1 pre-walk only saw the first
         250 variants, so any category whose variants live entirely in
         pages 2..N has no tab yet. Rebuild from items[] before the
         filter pass so search counts include the new tabs. */
      rebuildCategoryTabs();
      updateAllLimits();
      updateInCartLabels();
      filterItems();
    }

    /* ── Tabs rebuild after lazy-fetch ──
       Walks items[] (server-rendered + injected), discovers every
       distinct category handle, ensures each one has a tab, and
       updates per-tab counts. Reveals the tabs wrapper if it was
       hidden because the initial pre-walk only saw one category. */
    function rebuildCategoryTabs() {
      const tabsContainer = container.querySelector('[data-category-tabs]');
      if (!tabsContainer) return;

      /* Aggregate categories present across all loaded variants. */
      const counts = new Map(); /* handle → { name, count } */
      items.forEach(item => {
        const handle = item.dataset.variantCategory || '';
        if (!handle) return;
        const name = item.dataset.variantCategoryName || handle;
        const entry = counts.get(handle) || { name: name, count: 0 };
        entry.count++;
        counts.set(handle, entry);
      });

      const existing = new Set();
      Array.from(tabsContainer.querySelectorAll('[data-category]')).forEach(t => {
        existing.add(t.dataset.category);
      });

      let added = 0;
      counts.forEach((info, handle) => {
        if (existing.has(handle)) return;
        const btn = buildCategoryTab(handle, info.name, info.count, tabsContainer);
        tabsContainer.appendChild(btn);
        bindTabClick(btn);
        const countEl = btn.querySelector('.category-tab-count');
        if (countEl) originalTabCounts[handle] = countEl.textContent;
        added++;
      });

      /* Refresh categoryTabs reference so existing iteration sites see
         injected tabs too. */
      categoryTabs = container.querySelectorAll('[data-category]');

      /* Update count text on every tab — including initial ones — so
         page-1 counts reflect the post-fetch totals. */
      categoryTabs.forEach(tab => {
        const handle = tab.dataset.category;
        const info = counts.get(handle);
        if (!info) return;
        const countEl = tab.querySelector('.category-tab-count');
        if (countEl) {
          const newText = formatTabCount(info.count, countEl.textContent);
          countEl.textContent = newText;
          originalTabCounts[handle] = newText;
        }
      });

      /* Reveal the wrapper if it was hidden (paginated product whose
         first 250 only had one category). */
      if (added > 0 || categoryTabs.length > 1) {
        const wrapper = container.querySelector('[data-tabs-wrapper]');
        if (wrapper && wrapper.hasAttribute('hidden')) {
          wrapper.removeAttribute('hidden');
          wrapper.removeAttribute('data-tabs-wrapper-pending');
        }
      }
    }

    function buildCategoryTab(handle, name, count, tabsContainer) {
      /* Clone an existing tab when one is available — preserves the
         exact class list, SVG arrow, and count-text format (which can
         be locale-dependent or driven by a product metafield). */
      const template = tabsContainer.querySelector('.category-tab');
      let btn;
      if (template) {
        btn = template.cloneNode(true);
        btn.classList.remove('is-active');
        btn.setAttribute('aria-pressed', 'false');
        btn.removeAttribute('aria-current');
      } else {
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'category-tab relative snap-start shrink-0 border border-input bg-background px-3 py-2 text-left btn-radius-lg transition-[background-color,border-color]';
        btn.setAttribute('aria-pressed', 'false');
        btn.innerHTML =
          '<span class="flex items-center gap-1 text-sm font-semibold leading-tight text-foreground category-tab-name">' +
          '<svg class="category-tab-arrow shrink-0" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>' +
          '</span>' +
          '<span class="mt-0.5 block text-xs font-medium leading-tight text-muted-foreground category-tab-count"></span>';
      }
      btn.dataset.category = handle;
      btn.dataset.tabBound = '';

      const nameEl = btn.querySelector('.category-tab-name');
      if (nameEl) {
        const svg = nameEl.querySelector('svg');
        const isStandard = name.toLowerCase() === 'standard';
        nameEl.textContent = isStandard ? name : (name + 's');
        if (svg) nameEl.appendChild(svg);
      }

      const countEl = btn.querySelector('.category-tab-count');
      if (countEl) {
        countEl.textContent = formatTabCount(count, template
          ? template.querySelector('.category-tab-count')?.textContent
          : null);
      }

      return btn;
    }

    function formatTabCount(count, sampleText) {
      /* If we have an existing tab's count text to mimic ("12 colours",
         "1 can", etc.), preserve the noun + handle singular/plural the
         same way the Liquid template does. Otherwise fall back to
         "X colours". */
      if (sampleText) {
        const match = String(sampleText).trim().match(/^(\d+)\s+(.+)$/);
        if (match) {
          let noun = match[2];
          if (count === 1 && noun.endsWith('s')) noun = noun.slice(0, -1);
          else if (count !== 1 && !noun.endsWith('s')) noun = noun + 's';
          return count + ' ' + noun;
        }
      }
      return count + (count === 1 ? ' colour' : ' colours');
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-collections"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-related-collections]').forEach(function (section) {
      var container = section.querySelector('[data-scroll-container]');
      var leftBtn = section.querySelector('[data-scroll-left]');
      var rightBtn = section.querySelector('[data-scroll-right]');
      if (!container || !leftBtn || !rightBtn) return;
      function getScrollAmount() {
        var firstCard = container.querySelector(':scope > div');
        if (!firstCard) return 300;
        return firstCard.offsetWidth + 12;
      }
      function updateButtonStates() {
        var scrollLeft = container.scrollLeft;
        var maxScroll = container.scrollWidth - container.clientWidth;
        leftBtn.disabled = scrollLeft <= 0;
        rightBtn.disabled = scrollLeft >= maxScroll - 1;
      }
      leftBtn.addEventListener('click', function () {
        container.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
      rightBtn.addEventListener('click', function () {
        container.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
      container.addEventListener('scroll', updateButtonStates, { passive: true });
      window.addEventListener('resize', updateButtonStates, { passive: true });
      updateButtonStates();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      var LAYOUT = section.dataset.layout === 'grid' ? 'grid' : 'carousel';
      var REVIEWS_TO_SHOW = parseInt(section.dataset.reviewsToShow, 10) || 6;
      var REVIEWS_PER_PAGE = parseInt(section.dataset.reviewsPerPage, 10) || 9;
      var STAGGER_MS = 75;
      var RATING_STARS_TEMPLATE = section.dataset.ratingStarsTemplate || 'Rating: __RATING__ out of 5 stars';
      var RESPONSE_TEMPLATE = section.dataset.responseTemplate || 'Response from __NAME__';
      var verifiedBuyerLabel = section.dataset.verifiedBuyerLabel || '';
      var shopName = section.dataset.shopName || '';

      if (!window.pigment.Reviews || !window.pigment.Reviews.adapter || !window.pigment.Reviews.adapter.fetchStore) {
        section.style.display = 'none';
        return;
      }

      var container = section.querySelector('[data-reviews-container]');
      var summaryContainer = section.querySelector('[data-review-summary]');
      var paginationContainer = section.querySelector('[data-pagination-container]');
      var leftBtn = section.querySelector('[data-scroll-left]');
      var rightBtn = section.querySelector('[data-scroll-right]');
      if (!container) return;
      if (LAYOUT === 'carousel' && (!leftBtn || !rightBtn)) return;

      var chevronLeftTpl = section.querySelector('[data-icon-chevron-left]');
      var chevronRightTpl = section.querySelector('[data-icon-chevron-right]');
      var chevronLeftSvg = chevronLeftTpl ? chevronLeftTpl.innerHTML : '';
      var chevronRightSvg = chevronRightTpl ? chevronRightTpl.innerHTML : '';

      function buildStarRating(rating) {
        var max = 5;
        var fullStars = Math.floor(rating);
        var decimal = rating - fullStars;
        var html = '';
        var uniqueId = 'sr-' + Math.random().toString(36).substr(2, 6);

        html += '<div class="flex items-center gap-1" aria-label="' + RATING_STARS_TEMPLATE.replace('__RATING__', rating) + '">';
        html += '<div class="flex items-center gap-1" role="img" aria-hidden="true">';

        for (var i = 1; i <= max; i++) {
          if (i <= fullStars) {
            html += '<svg class="w-5 h-5 shrink-0 text-success" aria-hidden="true" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">';
            html += '<polygon fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="miter" points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />';
            html += '</svg>';
          } else if (i === fullStars + 1 && decimal > 0) {
            var fillWidth = decimal * 24;
            var clipId = uniqueId + '-clip-' + i;
            html += '<svg class="w-5 h-5 shrink-0 text-success" aria-hidden="true" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">';
            html += '<defs><clipPath id="' + clipId + '"><rect x="0" y="0" width="' + fillWidth + '" height="24" /></clipPath></defs>';
            html += '<polygon fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="miter" points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />';
            html += '<polygon fill="currentColor" stroke="none" points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" clip-path="url(#' + clipId + ')" />';
            html += '</svg>';
          } else {
            html += '<svg class="w-5 h-5 shrink-0 text-success" aria-hidden="true" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">';
            html += '<polygon fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="miter" points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />';
            html += '</svg>';
          }
        }

        html += '</div></div>';
        return html;
      }

      function timeAgo(dateString) {
        var now = new Date();
        var date = new Date(dateString);
        var seconds = Math.floor((now - date) / 1000);

        var intervals = [
          { label: 'year', seconds: 31536000 },
          { label: 'month', seconds: 2592000 },
          { label: 'week', seconds: 604800 },
          { label: 'day', seconds: 86400 },
          { label: 'hour', seconds: 3600 },
          { label: 'minute', seconds: 60 }
        ];

        for (var i = 0; i < intervals.length; i++) {
          var count = Math.floor(seconds / intervals[i].seconds);
          if (count >= 1) {
            return count + ' ' + intervals[i].label + (count > 1 ? 's' : '') + ' ago';
          }
        }

        return 'Just now';
      }

      function escapeHtml(str) {
        if (!str) return '';
        var div = document.createElement('div');
        div.appendChild(document.createTextNode(str));
        return div.innerHTML;
      }

      /* Grid items stretch to the row's tallest child by default, but
         only at the immediate grid-child level. The wrapper div is the
         grid child, so it stretches; without h-full on the inner card,
         the card sits at min-height inside a taller wrapper. h-full
         pushes the card to fill the wrapper so a row of cards matches
         the tallest one. */
      var cardWrapperClasses = LAYOUT === 'grid'
        ? 'h-full'
        : 'w-[75%] sm:w-[40%] lg:w-[28.57%] shrink-0 snap-start';
      var cardInnerClasses = 'flex flex-col border border-border p-5 min-h-[300px]' +
        (LAYOUT === 'grid' ? ' h-full' : '');

      function buildReviewCard(review) {
        var name = escapeHtml(review.author);
        var title = escapeHtml(review.title);
        var body = escapeHtml(review.body);
        var rating = review.rating;
        var date = review.date ? timeAgo(review.date) : '';

        var html = '';
        html += '<div class="' + cardWrapperClasses + '">';
        html += '<div class="' + cardInnerClasses + '">';
        html += buildStarRating(rating);

        if (title && body) {
          html += '<h3 class="mt-5 mb-3 text-base font-semibold text-foreground line-clamp-1">' + title + '</h3>';
          html += '<p class="text-sm text-muted-foreground">' + body + '</p>';
        } else if (body) {
          html += '<h3 class="mt-5 mb-3 text-base font-semibold text-foreground">' + body + '</h3>';
        }

        if (review.reply && review.reply.body) {
          var replierName = review.reply.author || shopName;
          var responseLabel = RESPONSE_TEMPLATE.replace('__NAME__', escapeHtml(replierName));
          html += '<div class="mt-4 pt-4 border-t border-border">';
          html += '<p class="text-sm font-semibold text-foreground mb-2">' + responseLabel + '</p>';
          html += '<p class="text-sm text-muted-foreground">' + escapeHtml(review.reply.body) + '</p>';
          html += '</div>';
        }

        html += '<div class="mt-auto pt-4 flex items-center justify-between">';
        html += '<div>';
        html += '<p class="text-sm font-medium text-foreground">' + name + '</p>';
        html += '<p class="text-xs text-muted-foreground">' + verifiedBuyerLabel + '</p>';
        html += '</div>';
        if (date) {
          html += '<p class="text-xs text-muted-foreground">' + date + '</p>';
        }
        html += '</div>';
        html += '</div>';
        html += '</div>';

        return html;
      }

      function buildReviewSummary(meta) {
        if (!meta || !meta.total) return '';

        var html = '';
        html += '<div class="mb-8 flex flex-col sm:flex-row gap-6 sm:gap-10 items-start">';

        var displayAvg = (Math.round(meta.average * 10) / 10).toString().replace(/\.0$/, '');
        html += '<div class="flex flex-col items-start shrink-0">';
        html += '<span class="text-3xl font-semibold text-primary leading-none">' + displayAvg + '/5</span>';
        html += '<p class="mt-2 text-sm text-muted-foreground">Based on ' + meta.total + ' review' + (meta.total !== 1 ? 's' : '') + '</p>';
        html += '</div>';

        html += '<div class="flex-1 w-full min-w-0 flex flex-col gap-1.5">';
        for (var star = 5; star >= 1; star--) {
          var bucket = (meta.histogram && meta.histogram[star]) || { count: 0, pct: 0 };
          html += '<div class="flex items-center gap-2">';
          html += '<span class="shrink-0 w-3 text-sm text-muted-foreground text-right tabular-nums">' + star + '</span>';
          html += '<svg class="w-3.5 h-3.5 shrink-0 text-muted-foreground/60" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><polygon fill="currentColor" points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" /></svg>';
          html += '<div class="flex-1 h-1.5 bg-primary/15 rounded-full overflow-hidden">';
          html += '<div class="h-full bg-primary rounded-full" style="width: ' + bucket.pct + '%"></div>';
          html += '</div>';
          html += '<span class="shrink-0 w-10 text-xs text-muted-foreground tabular-nums text-right">(' + bucket.pct + '%)</span>';
          html += '</div>';
        }
        html += '</div>';
        html += '</div>';
        return html;
      }

      function buildPagination(currentPage, totalPages) {
        if (totalPages <= 1) return '';
        var prevClasses = 'inline-flex items-center gap-1 px-3 py-2 text-sm font-medium text-foreground transition-colors hover:text-muted-foreground';
        var disabledNavClasses = 'inline-flex items-center gap-1 px-3 py-2 text-sm font-medium text-secondary-foreground cursor-not-allowed';
        var currentPageClasses = 'inline-flex h-10 w-10 items-center justify-center border border-input bg-secondary text-sm font-medium text-foreground transition-colors';
        var pageLinkClasses = 'inline-flex h-10 w-10 items-center justify-center text-sm font-medium text-foreground transition-colors border border-input bg-background';
        var ellipsisClasses = 'inline-flex h-10 w-10 items-center justify-center text-muted-foreground';

        var html = '<nav aria-label="Pagination" class="flex items-center justify-center gap-1" data-pagination>';

        if (currentPage > 1) {
          html += '<a href="#" class="' + prevClasses + '" rel="prev" data-page-link="' + (currentPage - 1) + '">' + chevronLeftSvg + '<span class="hidden sm:inline">Previous</span></a>';
        } else {
          html += '<span class="' + disabledNavClasses + '" aria-hidden="true">' + chevronLeftSvg + '<span class="hidden sm:inline">Previous</span></span>';
        }

        html += '<div class="flex items-center gap-1">';
        if (currentPage === 1) {
          html += '<span class="' + currentPageClasses + '" aria-current="page" data-pagination-current>1</span>';
        } else {
          html += '<a href="#" class="' + pageLinkClasses + '" data-page-link="1" data-pagination-link>1</a>';
        }
        if (currentPage > 2) {
          html += '<span class="' + ellipsisClasses + '" aria-hidden="true">...</span>';
        }
        if (currentPage !== 1 && currentPage !== totalPages) {
          html += '<span class="' + currentPageClasses + '" aria-current="page" data-pagination-current>' + currentPage + '</span>';
        }
        if (currentPage < totalPages - 1) {
          html += '<span class="' + ellipsisClasses + '" aria-hidden="true">...</span>';
        }
        if (totalPages !== 1) {
          if (currentPage === totalPages) {
            html += '<span class="' + currentPageClasses + '" aria-current="page" data-pagination-current>' + totalPages + '</span>';
          } else {
            html += '<a href="#" class="' + pageLinkClasses + '" data-page-link="' + totalPages + '" data-pagination-link>' + totalPages + '</a>';
          }
        }
        html += '</div>';

        if (currentPage < totalPages) {
          html += '<a href="#" class="' + prevClasses + '" rel="next" data-page-link="' + (currentPage + 1) + '"><span class="hidden sm:inline">Next</span>' + chevronRightSvg + '</a>';
        } else {
          html += '<span class="' + disabledNavClasses + '" aria-hidden="true"><span class="hidden sm:inline">Next</span>' + chevronRightSvg + '</span>';
        }

        html += '</nav>';
        return html;
      }

      function initCarousel() {
        function getScrollAmount() {
          var firstCard = container.querySelector(':scope > div');
          if (!firstCard) return 300;
          return firstCard.offsetWidth + 12;
        }

        function updateButtonStates() {
          var scrollLeft = container.scrollLeft;
          var maxScroll = container.scrollWidth - container.clientWidth;
          leftBtn.disabled = scrollLeft <= 0;
          rightBtn.disabled = scrollLeft >= maxScroll - 1;
        }

        leftBtn.addEventListener('click', function () {
          container.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        });

        rightBtn.addEventListener('click', function () {
          container.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        });

        container.addEventListener('scroll', updateButtonStates, { passive: true });
        window.addEventListener('resize', updateButtonStates, { passive: true });
        updateButtonStates();
      }

      var carouselInitialised = false;
      var allReviews = null;    // cached after first fetch
      var summaryMeta = null;

      function loadReviews() {
        if (allReviews) return Promise.resolve(allReviews);
        return window.pigment.Reviews.adapter.fetchStore().then(function (data) {
          if (!data) data = { reviews: [], total: 0, average: 0, histogram: {} };
          allReviews = data.reviews || [];
          summaryMeta = { total: data.total, average: data.average, histogram: data.histogram };
          return allReviews;
        });
      }

      function getReviewsForDisplayPage(displayPage) {
        return loadReviews().then(function (reviews) {
          if (LAYOUT !== 'grid') return reviews.slice(0, REVIEWS_TO_SHOW);
          var start = (displayPage - 1) * REVIEWS_PER_PAGE;
          return reviews.slice(start, start + REVIEWS_PER_PAGE);
        });
      }

      function renderCards(cards) {
        var html = '';
        for (var i = 0; i < cards.length; i++) html += buildReviewCard(cards[i]);
        container.innerHTML = html;
        container.querySelectorAll(':scope > div').forEach(function (card, idx) {
          card.classList.add('stagger-fade-in');
          card.style.setProperty('--stagger-i', idx);
          card.style.setProperty('--stagger-step', STAGGER_MS + 'ms');
        });
      }

      function renderPagination(currentPage) {
        if (!paginationContainer || LAYOUT !== 'grid') return;
        var totalPages = Math.max(1, Math.ceil(((allReviews && allReviews.length) || 0) / REVIEWS_PER_PAGE));
        paginationContainer.innerHTML = buildPagination(currentPage, totalPages);
        paginationContainer.querySelectorAll('[data-page-link]').forEach(function (link) {
          link.addEventListener('click', function (e) {
            e.preventDefault();
            var pg = parseInt(link.getAttribute('data-page-link'), 10);
            if (!pg || pg === currentPage) return;
            fetchAndRender(pg, true);
          });
        });
      }

      function fetchAndRender(displayPage, scrollToTop) {
        var current = displayPage || 1;
        loadReviews().then(function (reviews) {
          if (!reviews || reviews.length === 0) {
            section.style.display = 'none';
            return;
          }
          if (summaryContainer && summaryMeta) summaryContainer.innerHTML = buildReviewSummary(summaryMeta);
          return getReviewsForDisplayPage(current).then(function (cards) {
            if (!cards.length && current === 1) {
              section.style.display = 'none';
              return;
            }
            renderCards(cards);
            renderPagination(current);
            if (LAYOUT === 'carousel' && !carouselInitialised) {
              carouselInitialised = true;
              initCarousel();
            }
            if (scrollToTop) {
              var rect = section.getBoundingClientRect();
              window.scrollTo({ top: window.pageYOffset + rect.top - 16, behavior: 'smooth' });
            }
          });
        });
      }

      /* Defer the Judge.me network fetch until the section enters the
         viewport. Store reviews typically sit below the fold of a page
         template, so paying for the cross-origin fetch on initial render
         is waste. rootMargin gives ~600px of runway. */
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              io.disconnect();
              fetchAndRender(1, false);
            }
          });
        }, { rootMargin: '600px 0px' });
        io.observe(section);
      } else {
        fetchAndRender(1, false);
      }
    }

    document.querySelectorAll('[data-store-reviews]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usp-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-usp-bar]').forEach(function (bar) {
      var slides = bar.querySelectorAll('[data-usp-slide]');
      if (slides.length < 2) return;

      var rotationInterval = parseInt(bar.dataset.rotationInterval, 10) || 4000;
      var fadeDuration = parseInt(bar.dataset.fadeDuration, 10) || 300;
      var reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      var current = 0;
      var timer = null;

      function showSlide(index) {
        var prev = slides[current];

        current = (index + slides.length) % slides.length;

        var next = slides[current];

        prev.classList.add('opacity-0', 'pointer-events-none');
        prev.classList.remove('opacity-100');

        setTimeout(function () {
          prev.classList.add('absolute', 'inset-0');
          prev.classList.remove('relative');

          next.classList.remove(
            'absolute',
            'inset-0',
            'opacity-0',
            'pointer-events-none'
          );

          next.classList.add('opacity-100', 'relative');
        }, fadeDuration);
      }

      function startTimer() {
        stopTimer();

        if (reduceMotionQuery.matches) return;

        if (
          window.pigment &&
          window.pigment.isHidden &&
          window.pigment.isHidden()
        ) return;

        timer = setInterval(function () {
          showSlide(current + 1);
        }, rotationInterval);
      }

      function stopTimer() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      bar.addEventListener('mouseenter', stopTimer);
      bar.addEventListener('mouseleave', startTimer);
      bar.addEventListener('focusin', stopTimer);

      bar.addEventListener('focusout', function (e) {
        if (!bar.contains(e.relatedTarget)) startTimer();
      });

      reduceMotionQuery.addEventListener('change', function (e) {
        if (e.matches) {
          stopTimer();
        } else {
          startTimer();
        }
      });

      if (window.pigment && window.pigment.onVisibility) {
        window.pigment.onVisibility(function (hidden) {
          if (hidden) {
            stopTimer();
          } else {
            startTimer();
          }
        });
      }

      startTimer();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
